"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productIdAppTypeMap = void 0;
/* tslint:disable */
const appType_1 = require("./appType");
/* Auto-generated, do not modify!!! */
exports.productIdAppTypeMap = {
    'Drops premium 1 year': appType_1.AppType.local_zh,
    'Drops premium 1 year - 40% discount': appType_1.AppType.local_zh,
    'Drops premium 3 months': appType_1.AppType.local_zh,
    'Drops premium lifetime': appType_1.AppType.local_zh,
    'drops_topup_forever_10mins_discounted': appType_1.AppType.int,
    'drops_topup_forever_10mins_discounted_hu': appType_1.AppType.local_hu,
    'drops_topup_forever_10mins_hu': appType_1.AppType.local_hu,
    'drops_topup_forever_5mins': appType_1.AppType.int,
    'drops_topup_forever_99mins': appType_1.AppType.int,
    'drops_topup_forever_99mins_discounted': appType_1.AppType.int,
    'drops_topup_forever_99mins_discounted_hu': appType_1.AppType.local_hu,
    'drops_topup_forever_99mins_hu': appType_1.AppType.local_hu,
    'drops_topup_monthly_10mins_hu': appType_1.AppType.local_hu,
    'drops_topup_monthly_10mins_int': appType_1.AppType.int,
    'drops_topup_monthly_10mins_local_ar': appType_1.AppType.local_ar,
    'drops_topup_yearly_10mins_hu': appType_1.AppType.local_hu,
    'drops_topup_yearly_10mins_int': appType_1.AppType.int,
    'forever10MinsDiscounted': appType_1.AppType.bite,
    'forever5Mins': appType_1.AppType.bite,
    'forever99Mins': appType_1.AppType.bite,
    'forever99MinsDiscounted': appType_1.AppType.bite,
    'forever_10_mins_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_40_alternative_int': appType_1.AppType.int,
    'forever_10_mins_discounted_40_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_40_droplets': appType_1.AppType.droplets,
    'forever_10_mins_discounted_40_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_discounted_40_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_discounted_40_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_40_int': appType_1.AppType.int,
    'forever_10_mins_discounted_40_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_discounted_40_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_discounted_40_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_discounted_40_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_discounted_40_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_discounted_40_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_discounted_40_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_discounted_40_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_40_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_40_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_discounted_40_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_discounted_40_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_40_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_40_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_discounted_40_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_discounted_40_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_discounted_40_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_discounted_40_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_discounted_40_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_discounted_40_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_discounted_40_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_discounted_40_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_discounted_40_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_discounted_40_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_discounted_40_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_discounted_40_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_40_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_40_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_discounted_40_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_discounted_40_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_discounted_40_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_discounted_40_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_discounted_40_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_40_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_discounted_40_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_40_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_discounted_40_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_discounted_40_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_discounted_40_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_discounted_40_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_discounted_40_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_discounted_40_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_discounted_40_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_discounted_40_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_discounted_40_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_40_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_40_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_discounted_40_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_40_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_discounted_40_scripts': appType_1.AppType.scripts,
    'forever_10_mins_discounted_40_upopoy': appType_1.AppType.upopoy,
    'forever_10_mins_discounted_45_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_45_droplets': appType_1.AppType.droplets,
    'forever_10_mins_discounted_45_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_discounted_45_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_discounted_45_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_45_int': appType_1.AppType.int,
    'forever_10_mins_discounted_45_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_discounted_45_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_discounted_45_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_discounted_45_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_discounted_45_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_discounted_45_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_discounted_45_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_discounted_45_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_45_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_45_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_discounted_45_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_discounted_45_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_45_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_45_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_discounted_45_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_discounted_45_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_discounted_45_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_discounted_45_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_discounted_45_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_discounted_45_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_discounted_45_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_discounted_45_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_discounted_45_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_discounted_45_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_discounted_45_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_discounted_45_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_45_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_45_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_discounted_45_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_discounted_45_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_discounted_45_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_discounted_45_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_discounted_45_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_45_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_discounted_45_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_45_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_discounted_45_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_discounted_45_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_discounted_45_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_discounted_45_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_discounted_45_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_discounted_45_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_discounted_45_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_discounted_45_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_discounted_45_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_45_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_45_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_discounted_45_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_45_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_discounted_45_scripts': appType_1.AppType.scripts,
    'forever_10_mins_discounted_45_upopoy': appType_1.AppType.upopoy,
    'forever_10_mins_discounted_50_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_50_droplets': appType_1.AppType.droplets,
    'forever_10_mins_discounted_50_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_discounted_50_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_discounted_50_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_50_int': appType_1.AppType.int,
    'forever_10_mins_discounted_50_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_discounted_50_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_discounted_50_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_discounted_50_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_discounted_50_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_discounted_50_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_discounted_50_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_discounted_50_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_50_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_50_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_discounted_50_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_discounted_50_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_50_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_50_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_discounted_50_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_discounted_50_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_discounted_50_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_discounted_50_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_discounted_50_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_discounted_50_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_discounted_50_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_discounted_50_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_discounted_50_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_discounted_50_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_discounted_50_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_discounted_50_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_50_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_50_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_discounted_50_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_discounted_50_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_discounted_50_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_discounted_50_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_discounted_50_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_50_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_discounted_50_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_50_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_discounted_50_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_discounted_50_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_discounted_50_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_discounted_50_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_discounted_50_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_discounted_50_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_discounted_50_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_discounted_50_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_discounted_50_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_50_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_50_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_discounted_50_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_50_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_discounted_50_scripts': appType_1.AppType.scripts,
    'forever_10_mins_discounted_50_upopoy': appType_1.AppType.upopoy,
    'forever_10_mins_discounted_60_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_60_droplets': appType_1.AppType.droplets,
    'forever_10_mins_discounted_60_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_discounted_60_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_discounted_60_int': appType_1.AppType.int,
    'forever_10_mins_discounted_60_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_discounted_60_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_discounted_60_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_discounted_60_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_discounted_60_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_discounted_60_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_discounted_60_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_discounted_60_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_60_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_60_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_discounted_60_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_discounted_60_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_60_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_60_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_discounted_60_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_discounted_60_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_discounted_60_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_discounted_60_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_discounted_60_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_discounted_60_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_discounted_60_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_discounted_60_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_discounted_60_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_discounted_60_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_discounted_60_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_discounted_60_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_60_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_60_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_discounted_60_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_discounted_60_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_discounted_60_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_discounted_60_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_discounted_60_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_60_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_discounted_60_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_60_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_discounted_60_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_discounted_60_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_discounted_60_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_discounted_60_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_discounted_60_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_discounted_60_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_discounted_60_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_discounted_60_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_discounted_60_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_60_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_60_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_discounted_60_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_60_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_discounted_60_scripts': appType_1.AppType.scripts,
    'forever_10_mins_discounted_60_upopoy': appType_1.AppType.upopoy,
    'forever_10_mins_discounted_80_bite': appType_1.AppType.bite,
    'forever_10_mins_discounted_80_droplets': appType_1.AppType.droplets,
    'forever_10_mins_discounted_80_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_discounted_80_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_discounted_80_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_80_int': appType_1.AppType.int,
    'forever_10_mins_discounted_80_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_discounted_80_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_discounted_80_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_discounted_80_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_discounted_80_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_discounted_80_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_discounted_80_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_discounted_80_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_80_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_discounted_80_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_discounted_80_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_discounted_80_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_80_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_discounted_80_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_discounted_80_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_discounted_80_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_discounted_80_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_discounted_80_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_discounted_80_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_discounted_80_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_discounted_80_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_discounted_80_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_discounted_80_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_discounted_80_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_discounted_80_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_discounted_80_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_80_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_discounted_80_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_discounted_80_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_discounted_80_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_discounted_80_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_discounted_80_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_discounted_80_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_80_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_discounted_80_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_discounted_80_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_discounted_80_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_discounted_80_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_discounted_80_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_discounted_80_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_discounted_80_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_discounted_80_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_discounted_80_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_discounted_80_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_discounted_80_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_80_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_discounted_80_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_discounted_80_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_discounted_80_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_discounted_80_scripts': appType_1.AppType.scripts,
    'forever_10_mins_discounted_80_upopoy': appType_1.AppType.upopoy,
    'forever_10_mins_droplets': appType_1.AppType.droplets,
    'forever_10_mins_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_10_mins_global_eagle': appType_1.AppType.global_eagle,
    'forever_10_mins_int': appType_1.AppType.int,
    'forever_10_mins_lang_ain': appType_1.AppType.lang_ain,
    'forever_10_mins_lang_ar': appType_1.AppType.lang_ar,
    'forever_10_mins_lang_bs': appType_1.AppType.lang_bs,
    'forever_10_mins_lang_da': appType_1.AppType.lang_da,
    'forever_10_mins_lang_de': appType_1.AppType.lang_de,
    'forever_10_mins_lang_el': appType_1.AppType.lang_el,
    'forever_10_mins_lang_en': appType_1.AppType.lang_en,
    'forever_10_mins_lang_en2': appType_1.AppType.lang_enus,
    'forever_10_mins_lang_enus1': appType_1.AppType.lang_enus,
    'forever_10_mins_lang_eo': appType_1.AppType.lang_eo,
    'forever_10_mins_lang_es': appType_1.AppType.lang_es,
    'forever_10_mins_lang_es2': appType_1.AppType.lang_esmx,
    'forever_10_mins_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_10_mins_lang_et': appType_1.AppType.lang_et,
    'forever_10_mins_lang_fa': appType_1.AppType.lang_fa,
    'forever_10_mins_lang_fi': appType_1.AppType.lang_fi,
    'forever_10_mins_lang_fr': appType_1.AppType.lang_fr,
    'forever_10_mins_lang_haw': appType_1.AppType.lang_haw,
    'forever_10_mins_lang_he': appType_1.AppType.lang_he,
    'forever_10_mins_lang_hi': appType_1.AppType.lang_hi,
    'forever_10_mins_lang_hr': appType_1.AppType.lang_hr,
    'forever_10_mins_lang_hu': appType_1.AppType.lang_hu,
    'forever_10_mins_lang_ic': appType_1.AppType.lang_ic,
    'forever_10_mins_lang_id': appType_1.AppType.lang_id,
    'forever_10_mins_lang_it': appType_1.AppType.lang_it,
    'forever_10_mins_lang_ja': appType_1.AppType.lang_ja,
    'forever_10_mins_lang_jp': appType_1.AppType.lang_ja,
    'forever_10_mins_lang_ko': appType_1.AppType.lang_ko,
    'forever_10_mins_lang_mi': appType_1.AppType.lang_mi,
    'forever_10_mins_lang_nl': appType_1.AppType.lang_nl,
    'forever_10_mins_lang_no': appType_1.AppType.lang_no,
    'forever_10_mins_lang_pl': appType_1.AppType.lang_pl,
    'forever_10_mins_lang_pt': appType_1.AppType.lang_pt,
    'forever_10_mins_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_10_mins_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_10_mins_lang_ru': appType_1.AppType.lang_ru,
    'forever_10_mins_lang_sm': appType_1.AppType.lang_sm,
    'forever_10_mins_lang_sr': appType_1.AppType.lang_sr,
    'forever_10_mins_lang_sv': appType_1.AppType.lang_sv,
    'forever_10_mins_lang_th': appType_1.AppType.lang_th,
    'forever_10_mins_lang_tl': appType_1.AppType.lang_tl,
    'forever_10_mins_lang_tr': appType_1.AppType.lang_tr,
    'forever_10_mins_lang_vi': appType_1.AppType.lang_vi,
    'forever_10_mins_lang_zh': appType_1.AppType.lang_zh,
    'forever_10_mins_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_10_mins_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_10_mins_local_ar': appType_1.AppType.local_ar,
    'forever_10_mins_local_hu': appType_1.AppType.local_hu,
    'forever_10_mins_local_zh': appType_1.AppType.local_zh,
    'forever_10_mins_scripts': appType_1.AppType.scripts,
    'forever_10_mins_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_40_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_40_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_40_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_40_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_40_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_40_int': appType_1.AppType.int,
    'forever_all_languages_discounted_40_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_40_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_40_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_40_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_40_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_40_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_40_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_40_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_40_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_40_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_40_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_40_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_40_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_40_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_40_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_40_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_40_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_40_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_40_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_40_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_40_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_40_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_40_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_40_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_40_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_40_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_40_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_40_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_40_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_40_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_40_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_40_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_40_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_40_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_40_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_40_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_40_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_40_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_40_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_40_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_40_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_40_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_40_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_40_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_40_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_40_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_40_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_40_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_40_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_40_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_40_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_discounted_45_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_45_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_45_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_45_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_45_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_45_int': appType_1.AppType.int,
    'forever_all_languages_discounted_45_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_45_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_45_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_45_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_45_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_45_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_45_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_45_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_45_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_45_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_45_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_45_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_45_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_45_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_45_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_45_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_45_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_45_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_45_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_45_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_45_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_45_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_45_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_45_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_45_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_45_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_45_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_45_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_45_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_45_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_45_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_45_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_45_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_45_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_45_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_45_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_45_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_45_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_45_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_45_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_45_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_45_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_45_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_45_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_45_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_45_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_45_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_45_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_45_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_45_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_45_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_discounted_50_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_50_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_50_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_50_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_50_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_50_int': appType_1.AppType.int,
    'forever_all_languages_discounted_50_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_50_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_50_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_50_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_50_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_50_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_50_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_50_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_50_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_50_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_50_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_50_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_50_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_50_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_50_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_50_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_50_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_50_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_50_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_50_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_50_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_50_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_50_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_50_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_50_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_50_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_50_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_50_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_50_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_50_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_50_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_50_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_50_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_50_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_50_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_50_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_50_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_50_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_50_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_50_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_50_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_50_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_50_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_50_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_50_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_50_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_50_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_50_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_50_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_50_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_50_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_discounted_55_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_55_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_55_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_55_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_55_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_55_int': appType_1.AppType.int,
    'forever_all_languages_discounted_55_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_55_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_55_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_55_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_55_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_55_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_55_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_55_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_55_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_55_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_55_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_55_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_55_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_55_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_55_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_55_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_55_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_55_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_55_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_55_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_55_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_55_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_55_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_55_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_55_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_55_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_55_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_55_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_55_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_55_lang_pt': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_55_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_55_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_55_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_55_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_55_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_55_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_55_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_55_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_55_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_55_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_55_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_55_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_55_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_55_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_55_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_discounted_60_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_60_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_60_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_60_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_60_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_60_int': appType_1.AppType.int,
    'forever_all_languages_discounted_60_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_60_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_60_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_60_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_60_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_60_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_60_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_60_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_60_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_60_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_60_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_60_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_60_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_60_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_60_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_60_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_60_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_60_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_60_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_60_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_60_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_60_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_60_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_60_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_60_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_60_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_60_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_60_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_60_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_60_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_60_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_60_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_60_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_60_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_60_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_60_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_60_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_60_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_60_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_60_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_60_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_60_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_60_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_60_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_60_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_60_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_60_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_60_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_60_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_60_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_60_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_discounted_80_bite': appType_1.AppType.bite,
    'forever_all_languages_discounted_80_droplets': appType_1.AppType.droplets,
    'forever_all_languages_discounted_80_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_discounted_80_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_discounted_80_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_80_int': appType_1.AppType.int,
    'forever_all_languages_discounted_80_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_discounted_80_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_discounted_80_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_discounted_80_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_discounted_80_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_discounted_80_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_discounted_80_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_discounted_80_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_80_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_discounted_80_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_discounted_80_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_discounted_80_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_80_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_discounted_80_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_discounted_80_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_discounted_80_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_discounted_80_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_discounted_80_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_discounted_80_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_discounted_80_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_discounted_80_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_discounted_80_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_discounted_80_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_discounted_80_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_discounted_80_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_discounted_80_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_80_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_discounted_80_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_discounted_80_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_discounted_80_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_discounted_80_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_discounted_80_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_discounted_80_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_80_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_discounted_80_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_discounted_80_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_discounted_80_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_discounted_80_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_discounted_80_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_discounted_80_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_discounted_80_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_discounted_80_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_discounted_80_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_discounted_80_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_discounted_80_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_80_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_discounted_80_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_discounted_80_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_discounted_80_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_discounted_80_scripts': appType_1.AppType.scripts,
    'forever_all_languages_discounted_80_upopoy': appType_1.AppType.upopoy,
    'forever_all_languages_droplets': appType_1.AppType.droplets,
    'forever_all_languages_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_all_languages_global_eagle': appType_1.AppType.global_eagle,
    'forever_all_languages_hu': appType_1.AppType.local_hu,
    'forever_all_languages_int': appType_1.AppType.int,
    'forever_all_languages_lang_ain': appType_1.AppType.lang_ain,
    'forever_all_languages_lang_ar': appType_1.AppType.lang_ar,
    'forever_all_languages_lang_bs': appType_1.AppType.lang_bs,
    'forever_all_languages_lang_da': appType_1.AppType.lang_da,
    'forever_all_languages_lang_de': appType_1.AppType.lang_de,
    'forever_all_languages_lang_el': appType_1.AppType.lang_el,
    'forever_all_languages_lang_en': appType_1.AppType.lang_en,
    'forever_all_languages_lang_en2': appType_1.AppType.lang_enus,
    'forever_all_languages_lang_enus1': appType_1.AppType.lang_enus,
    'forever_all_languages_lang_eo': appType_1.AppType.lang_eo,
    'forever_all_languages_lang_es': appType_1.AppType.lang_es,
    'forever_all_languages_lang_es2': appType_1.AppType.lang_esmx,
    'forever_all_languages_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_all_languages_lang_et': appType_1.AppType.lang_et,
    'forever_all_languages_lang_fa': appType_1.AppType.lang_fa,
    'forever_all_languages_lang_fi': appType_1.AppType.lang_fi,
    'forever_all_languages_lang_fr': appType_1.AppType.lang_fr,
    'forever_all_languages_lang_haw': appType_1.AppType.lang_haw,
    'forever_all_languages_lang_he': appType_1.AppType.lang_he,
    'forever_all_languages_lang_hi': appType_1.AppType.lang_hi,
    'forever_all_languages_lang_hr': appType_1.AppType.lang_hr,
    'forever_all_languages_lang_hu': appType_1.AppType.lang_hu,
    'forever_all_languages_lang_ic': appType_1.AppType.lang_ic,
    'forever_all_languages_lang_id': appType_1.AppType.lang_id,
    'forever_all_languages_lang_it': appType_1.AppType.lang_it,
    'forever_all_languages_lang_ja': appType_1.AppType.lang_ja,
    'forever_all_languages_lang_jp': appType_1.AppType.lang_ja,
    'forever_all_languages_lang_ko': appType_1.AppType.lang_ko,
    'forever_all_languages_lang_mi': appType_1.AppType.lang_mi,
    'forever_all_languages_lang_nl': appType_1.AppType.lang_nl,
    'forever_all_languages_lang_no': appType_1.AppType.lang_no,
    'forever_all_languages_lang_pl': appType_1.AppType.lang_pl,
    'forever_all_languages_lang_pt': appType_1.AppType.lang_pt,
    'forever_all_languages_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_all_languages_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_all_languages_lang_ru': appType_1.AppType.lang_ru,
    'forever_all_languages_lang_sm': appType_1.AppType.lang_sm,
    'forever_all_languages_lang_sr': appType_1.AppType.lang_sr,
    'forever_all_languages_lang_sv': appType_1.AppType.lang_sv,
    'forever_all_languages_lang_th': appType_1.AppType.lang_th,
    'forever_all_languages_lang_tl': appType_1.AppType.lang_tl,
    'forever_all_languages_lang_tr': appType_1.AppType.lang_tr,
    'forever_all_languages_lang_vi': appType_1.AppType.lang_vi,
    'forever_all_languages_lang_zh': appType_1.AppType.lang_zh,
    'forever_all_languages_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_all_languages_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_all_languages_local_ar': appType_1.AppType.local_ar,
    'forever_all_languages_local_hu': appType_1.AppType.local_hu,
    'forever_all_languages_local_zh': appType_1.AppType.local_zh,
    'forever_all_languages_scripts': appType_1.AppType.scripts,
    'forever_all_languages_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_40_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_40_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_discounted_40_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_discounted_40_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_discounted_40_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_40_int': appType_1.AppType.int,
    'forever_unlimited_time_discounted_40_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_discounted_40_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_discounted_40_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_discounted_40_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_discounted_40_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_discounted_40_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_discounted_40_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_discounted_40_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_40_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_40_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_discounted_40_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_discounted_40_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_40_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_40_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_discounted_40_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_discounted_40_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_discounted_40_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_discounted_40_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_discounted_40_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_discounted_40_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_discounted_40_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_discounted_40_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_discounted_40_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_discounted_40_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_discounted_40_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_discounted_40_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_40_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_40_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_discounted_40_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_discounted_40_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_discounted_40_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_discounted_40_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_discounted_40_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_40_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_discounted_40_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_40_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_discounted_40_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_discounted_40_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_discounted_40_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_discounted_40_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_discounted_40_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_discounted_40_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_discounted_40_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_discounted_40_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_discounted_40_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_40_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_40_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_discounted_40_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_40_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_discounted_40_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_discounted_40_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_discounted_45_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_45_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_discounted_45_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_discounted_45_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_discounted_45_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_45_int': appType_1.AppType.int,
    'forever_unlimited_time_discounted_45_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_discounted_45_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_discounted_45_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_discounted_45_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_discounted_45_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_discounted_45_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_discounted_45_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_discounted_45_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_45_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_45_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_discounted_45_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_discounted_45_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_45_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_45_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_discounted_45_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_discounted_45_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_discounted_45_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_discounted_45_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_discounted_45_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_discounted_45_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_discounted_45_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_discounted_45_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_discounted_45_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_discounted_45_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_discounted_45_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_discounted_45_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_45_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_45_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_discounted_45_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_discounted_45_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_discounted_45_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_discounted_45_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_discounted_45_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_45_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_discounted_45_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_45_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_discounted_45_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_discounted_45_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_discounted_45_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_discounted_45_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_discounted_45_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_discounted_45_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_discounted_45_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_discounted_45_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_discounted_45_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_45_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_45_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_discounted_45_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_45_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_discounted_45_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_discounted_45_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_discounted_50_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_50_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_discounted_50_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_discounted_50_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_discounted_50_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_50_int': appType_1.AppType.int,
    'forever_unlimited_time_discounted_50_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_discounted_50_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_discounted_50_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_discounted_50_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_discounted_50_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_discounted_50_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_discounted_50_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_discounted_50_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_50_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_50_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_discounted_50_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_discounted_50_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_50_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_50_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_discounted_50_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_discounted_50_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_discounted_50_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_discounted_50_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_discounted_50_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_discounted_50_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_discounted_50_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_discounted_50_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_discounted_50_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_discounted_50_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_discounted_50_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_discounted_50_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_50_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_50_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_discounted_50_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_discounted_50_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_discounted_50_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_discounted_50_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_discounted_50_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_50_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_discounted_50_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_50_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_discounted_50_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_discounted_50_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_discounted_50_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_discounted_50_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_discounted_50_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_discounted_50_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_discounted_50_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_discounted_50_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_discounted_50_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_50_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_50_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_discounted_50_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_50_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_discounted_50_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_discounted_50_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_discounted_60_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_60_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_discounted_60_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_discounted_60_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_discounted_60_int': appType_1.AppType.int,
    'forever_unlimited_time_discounted_60_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_discounted_60_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_discounted_60_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_discounted_60_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_discounted_60_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_discounted_60_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_discounted_60_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_discounted_60_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_60_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_60_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_discounted_60_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_discounted_60_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_60_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_60_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_discounted_60_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_discounted_60_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_discounted_60_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_discounted_60_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_discounted_60_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_discounted_60_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_discounted_60_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_discounted_60_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_discounted_60_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_discounted_60_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_discounted_60_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_discounted_60_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_60_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_60_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_discounted_60_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_discounted_60_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_discounted_60_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_discounted_60_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_discounted_60_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_60_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_discounted_60_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_60_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_discounted_60_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_discounted_60_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_discounted_60_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_discounted_60_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_discounted_60_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_discounted_60_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_discounted_60_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_discounted_60_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_discounted_60_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_60_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_60_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_discounted_60_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_60_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_discounted_60_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_discounted_60_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_discounted_80_bite': appType_1.AppType.bite,
    'forever_unlimited_time_discounted_80_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_discounted_80_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_discounted_80_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_discounted_80_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_80_int': appType_1.AppType.int,
    'forever_unlimited_time_discounted_80_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_discounted_80_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_discounted_80_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_discounted_80_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_discounted_80_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_discounted_80_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_discounted_80_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_discounted_80_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_80_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_discounted_80_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_discounted_80_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_discounted_80_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_80_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_discounted_80_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_discounted_80_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_discounted_80_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_discounted_80_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_discounted_80_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_discounted_80_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_discounted_80_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_discounted_80_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_discounted_80_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_discounted_80_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_discounted_80_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_discounted_80_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_discounted_80_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_80_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_discounted_80_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_discounted_80_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_discounted_80_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_discounted_80_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_discounted_80_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_discounted_80_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_80_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_discounted_80_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_discounted_80_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_discounted_80_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_discounted_80_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_discounted_80_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_discounted_80_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_discounted_80_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_discounted_80_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_discounted_80_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_discounted_80_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_discounted_80_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_80_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_discounted_80_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_discounted_80_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_discounted_80_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_discounted_80_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_discounted_80_upopoy': appType_1.AppType.upopoy,
    'forever_unlimited_time_droplets': appType_1.AppType.droplets,
    'forever_unlimited_time_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'forever_unlimited_time_global_eagle': appType_1.AppType.global_eagle,
    'forever_unlimited_time_int': appType_1.AppType.int,
    'forever_unlimited_time_lang_ain': appType_1.AppType.lang_ain,
    'forever_unlimited_time_lang_ar': appType_1.AppType.lang_ar,
    'forever_unlimited_time_lang_bs': appType_1.AppType.lang_bs,
    'forever_unlimited_time_lang_da': appType_1.AppType.lang_da,
    'forever_unlimited_time_lang_de': appType_1.AppType.lang_de,
    'forever_unlimited_time_lang_el': appType_1.AppType.lang_el,
    'forever_unlimited_time_lang_en': appType_1.AppType.lang_en,
    'forever_unlimited_time_lang_en2': appType_1.AppType.lang_enus,
    'forever_unlimited_time_lang_enus1': appType_1.AppType.lang_enus,
    'forever_unlimited_time_lang_eo': appType_1.AppType.lang_eo,
    'forever_unlimited_time_lang_es': appType_1.AppType.lang_es,
    'forever_unlimited_time_lang_es2': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_lang_esmx': appType_1.AppType.lang_esmx,
    'forever_unlimited_time_lang_et': appType_1.AppType.lang_et,
    'forever_unlimited_time_lang_fa': appType_1.AppType.lang_fa,
    'forever_unlimited_time_lang_fi': appType_1.AppType.lang_fi,
    'forever_unlimited_time_lang_fr': appType_1.AppType.lang_fr,
    'forever_unlimited_time_lang_haw': appType_1.AppType.lang_haw,
    'forever_unlimited_time_lang_he': appType_1.AppType.lang_he,
    'forever_unlimited_time_lang_hi': appType_1.AppType.lang_hi,
    'forever_unlimited_time_lang_hr': appType_1.AppType.lang_hr,
    'forever_unlimited_time_lang_hu': appType_1.AppType.lang_hu,
    'forever_unlimited_time_lang_ic': appType_1.AppType.lang_ic,
    'forever_unlimited_time_lang_id': appType_1.AppType.lang_id,
    'forever_unlimited_time_lang_it': appType_1.AppType.lang_it,
    'forever_unlimited_time_lang_ja': appType_1.AppType.lang_ja,
    'forever_unlimited_time_lang_jp': appType_1.AppType.lang_ja,
    'forever_unlimited_time_lang_ko': appType_1.AppType.lang_ko,
    'forever_unlimited_time_lang_mi': appType_1.AppType.lang_mi,
    'forever_unlimited_time_lang_nl': appType_1.AppType.lang_nl,
    'forever_unlimited_time_lang_no': appType_1.AppType.lang_no,
    'forever_unlimited_time_lang_pl': appType_1.AppType.lang_pl,
    'forever_unlimited_time_lang_pt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_lang_pt2': appType_1.AppType.lang_ptbr,
    'forever_unlimited_time_lang_ptpt': appType_1.AppType.lang_pt,
    'forever_unlimited_time_lang_ru': appType_1.AppType.lang_ru,
    'forever_unlimited_time_lang_sm': appType_1.AppType.lang_sm,
    'forever_unlimited_time_lang_sr': appType_1.AppType.lang_sr,
    'forever_unlimited_time_lang_sv': appType_1.AppType.lang_sv,
    'forever_unlimited_time_lang_th': appType_1.AppType.lang_th,
    'forever_unlimited_time_lang_tl': appType_1.AppType.lang_tl,
    'forever_unlimited_time_lang_tr': appType_1.AppType.lang_tr,
    'forever_unlimited_time_lang_vi': appType_1.AppType.lang_vi,
    'forever_unlimited_time_lang_zh': appType_1.AppType.lang_zh,
    'forever_unlimited_time_lang_zh2': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_lang_zhyue': appType_1.AppType.lang_zhyue,
    'forever_unlimited_time_local_ar': appType_1.AppType.local_ar,
    'forever_unlimited_time_local_hu': appType_1.AppType.local_hu,
    'forever_unlimited_time_local_zh': appType_1.AppType.local_zh,
    'forever_unlimited_time_scripts': appType_1.AppType.scripts,
    'forever_unlimited_time_upopoy': appType_1.AppType.upopoy,
    'premium_halfyear_40_bite': appType_1.AppType.bite,
    'premium_halfyear_40_droplets': appType_1.AppType.droplets,
    'premium_halfyear_40_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_halfyear_40_global_eagle': appType_1.AppType.global_eagle,
    'premium_halfyear_40_hu': appType_1.AppType.local_hu,
    'premium_halfyear_40_int': appType_1.AppType.int,
    'premium_halfyear_40_lang_ain': appType_1.AppType.lang_ain,
    'premium_halfyear_40_lang_ar': appType_1.AppType.lang_ar,
    'premium_halfyear_40_lang_bs': appType_1.AppType.lang_bs,
    'premium_halfyear_40_lang_da': appType_1.AppType.lang_da,
    'premium_halfyear_40_lang_de': appType_1.AppType.lang_de,
    'premium_halfyear_40_lang_el': appType_1.AppType.lang_el,
    'premium_halfyear_40_lang_en': appType_1.AppType.lang_en,
    'premium_halfyear_40_lang_en2': appType_1.AppType.lang_enus,
    'premium_halfyear_40_lang_enus1': appType_1.AppType.lang_enus,
    'premium_halfyear_40_lang_eo': appType_1.AppType.lang_eo,
    'premium_halfyear_40_lang_es': appType_1.AppType.lang_es,
    'premium_halfyear_40_lang_es2': appType_1.AppType.lang_esmx,
    'premium_halfyear_40_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_halfyear_40_lang_et': appType_1.AppType.lang_et,
    'premium_halfyear_40_lang_fa': appType_1.AppType.lang_fa,
    'premium_halfyear_40_lang_fi': appType_1.AppType.lang_fi,
    'premium_halfyear_40_lang_fr': appType_1.AppType.lang_fr,
    'premium_halfyear_40_lang_haw': appType_1.AppType.lang_haw,
    'premium_halfyear_40_lang_he': appType_1.AppType.lang_he,
    'premium_halfyear_40_lang_hi': appType_1.AppType.lang_hi,
    'premium_halfyear_40_lang_hr': appType_1.AppType.lang_hr,
    'premium_halfyear_40_lang_hu': appType_1.AppType.lang_hu,
    'premium_halfyear_40_lang_ic': appType_1.AppType.lang_ic,
    'premium_halfyear_40_lang_id': appType_1.AppType.lang_id,
    'premium_halfyear_40_lang_it': appType_1.AppType.lang_it,
    'premium_halfyear_40_lang_ja': appType_1.AppType.lang_ja,
    'premium_halfyear_40_lang_jp': appType_1.AppType.lang_ja,
    'premium_halfyear_40_lang_ko': appType_1.AppType.lang_ko,
    'premium_halfyear_40_lang_mi': appType_1.AppType.lang_mi,
    'premium_halfyear_40_lang_nl': appType_1.AppType.lang_nl,
    'premium_halfyear_40_lang_no': appType_1.AppType.lang_no,
    'premium_halfyear_40_lang_pl': appType_1.AppType.lang_pl,
    'premium_halfyear_40_lang_pt': appType_1.AppType.lang_pt,
    'premium_halfyear_40_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_halfyear_40_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_halfyear_40_lang_ru': appType_1.AppType.lang_ru,
    'premium_halfyear_40_lang_sm': appType_1.AppType.lang_sm,
    'premium_halfyear_40_lang_sr': appType_1.AppType.lang_sr,
    'premium_halfyear_40_lang_sv': appType_1.AppType.lang_sv,
    'premium_halfyear_40_lang_th': appType_1.AppType.lang_th,
    'premium_halfyear_40_lang_tl': appType_1.AppType.lang_tl,
    'premium_halfyear_40_lang_tr': appType_1.AppType.lang_tr,
    'premium_halfyear_40_lang_vi': appType_1.AppType.lang_vi,
    'premium_halfyear_40_lang_zh': appType_1.AppType.lang_zh,
    'premium_halfyear_40_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_halfyear_40_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_halfyear_40_local_ar': appType_1.AppType.local_ar,
    'premium_halfyear_40_local_hu': appType_1.AppType.local_hu,
    'premium_halfyear_40_local_zh': appType_1.AppType.local_zh,
    'premium_halfyear_40_scripts': appType_1.AppType.scripts,
    'premium_halfyear_40_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_160_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_160_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_160_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_160_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_160_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_160_int_v2': appType_1.AppType.int,
    'premium_lifetime_160_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_160_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_160_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_160_lang_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_160_lang_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_160_lang_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_160_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_160_lang_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_160_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_160_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_160_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_160_lang_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_160_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_160_lang_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_160_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_160_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_160_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_160_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_160_lang_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_160_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_160_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_160_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_160_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_160_lang_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_160_lang_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_160_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_160_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_160_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_160_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_160_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_160_lang_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_160_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_160_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_160_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_160_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_160_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_160_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_160_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_160_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_160_lang_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_160_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_160_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_160_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_160_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_160_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_160_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_160_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_160_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_160_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_160_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_160_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_180_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_180_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_180_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_180_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_180_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_180_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_180_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_180_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_180_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_180_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_180_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_180_enus1_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_180_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_180_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_180_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_180_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_180_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_180_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_180_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_180_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_180_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_180_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_180_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_180_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_180_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_180_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_180_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_180_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_180_int_v2': appType_1.AppType.int,
    'premium_lifetime_180_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_180_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_180_jp_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_180_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_180_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_180_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_180_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_180_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_180_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_180_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_180_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_180_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_180_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_180_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_180_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_180_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_180_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_180_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_180_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_180_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_180_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_180_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_180_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_180_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_180_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_180_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_180_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_35_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_35_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_35_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_35_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_35_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_35_int_v2': appType_1.AppType.int,
    'premium_lifetime_35_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_35_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_35_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_35_lang_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_35_lang_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_35_lang_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_35_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_35_lang_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_35_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_35_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_35_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_35_lang_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_35_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_35_lang_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_35_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_35_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_35_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_35_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_35_lang_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_35_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_35_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_35_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_35_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_35_lang_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_35_lang_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_35_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_35_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_35_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_35_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_35_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_35_lang_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_35_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_35_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_35_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_35_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_35_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_35_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_35_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_35_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_35_lang_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_35_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_35_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_35_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_35_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_35_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_35_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_35_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_35_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_35_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_35_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_35_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_55_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_55_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_55_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_55_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_55_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_55_int_v2': appType_1.AppType.int,
    'premium_lifetime_55_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_55_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_55_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_55_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_55_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_55_lang_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_55_lang_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_55_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_55_lang_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_55_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_55_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_55_lang_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_55_lang_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_55_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_55_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_55_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_55_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_55_lang_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_55_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_55_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_55_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_55_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_55_lang_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_55_lang_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_55_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_55_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_55_lang_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_55_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_55_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_55_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_55_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_55_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_55_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_55_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_55_lang_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_55_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_55_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_55_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_55_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_55_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_55_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_55_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_55_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_55_plus1_bite': appType_1.AppType.bite,
    'premium_lifetime_55_plus1_droplets': appType_1.AppType.droplets,
    'premium_lifetime_55_plus1_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_55_plus1_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_55_plus1_hu': appType_1.AppType.local_hu,
    'premium_lifetime_55_plus1_int': appType_1.AppType.int,
    'premium_lifetime_55_plus1_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_55_plus1_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_55_plus1_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_55_plus1_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_55_plus1_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_55_plus1_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_55_plus1_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_55_plus1_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_55_plus1_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_55_plus1_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_55_plus1_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_55_plus1_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_55_plus1_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_55_plus1_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_55_plus1_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_55_plus1_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_55_plus1_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_55_plus1_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_55_plus1_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_55_plus1_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_55_plus1_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_55_plus1_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_55_plus1_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_55_plus1_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_55_plus1_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_55_plus1_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_55_plus1_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_55_plus1_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_55_plus1_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_55_plus1_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_55_plus1_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_55_plus1_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_55_plus1_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_55_plus1_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_55_plus1_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_55_plus1_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_55_plus1_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_55_plus1_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_55_plus1_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_55_plus1_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_55_plus1_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_55_plus1_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_55_plus1_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_55_plus1_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_55_plus1_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_55_plus1_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_55_plus1_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_55_plus1_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_55_plus1_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_55_plus1_scripts': appType_1.AppType.scripts,
    'premium_lifetime_55_plus1_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_55_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_55_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_65_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_65_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_65_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_65_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_65_int_v2': appType_1.AppType.int,
    'premium_lifetime_65_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_65_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_65_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_65_lang_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_65_lang_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_65_lang_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_65_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_65_lang_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_65_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_65_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_65_lang_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_65_lang_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_65_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_65_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_65_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_65_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_65_lang_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_65_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_65_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_65_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_65_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_65_lang_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_65_lang_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_65_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_65_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_65_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_65_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_65_lang_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_65_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_65_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_65_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_65_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_65_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_65_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_65_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_65_lang_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_65_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_65_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_65_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_65_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_65_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_65_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_65_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_65_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_65_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_65_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_80_bite_v2': appType_1.AppType.bite,
    'premium_lifetime_80_de_v2': appType_1.AppType.lang_de,
    'premium_lifetime_80_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_80_droplets_v2': appType_1.AppType.droplets,
    'premium_lifetime_80_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_lifetime_80_int_v2': appType_1.AppType.int,
    'premium_lifetime_80_ja_v2': appType_1.AppType.lang_ja,
    'premium_lifetime_80_ko_v2': appType_1.AppType.lang_ko,
    'premium_lifetime_80_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_lifetime_80_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_lifetime_80_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_lifetime_80_lang_da_v2': appType_1.AppType.lang_da,
    'premium_lifetime_80_lang_el_v2': appType_1.AppType.lang_el,
    'premium_lifetime_80_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_lifetime_80_lang_en_v2': appType_1.AppType.lang_en,
    'premium_lifetime_80_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_lifetime_80_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_lifetime_80_lang_es_v2': appType_1.AppType.lang_es,
    'premium_lifetime_80_lang_et_v2': appType_1.AppType.lang_et,
    'premium_lifetime_80_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_lifetime_80_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_lifetime_80_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_lifetime_80_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_lifetime_80_lang_he_v2': appType_1.AppType.lang_he,
    'premium_lifetime_80_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_lifetime_80_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_lifetime_80_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_lifetime_80_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_lifetime_80_lang_id_v2': appType_1.AppType.lang_id,
    'premium_lifetime_80_lang_it_v2': appType_1.AppType.lang_it,
    'premium_lifetime_80_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_lifetime_80_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_lifetime_80_lang_no_v2': appType_1.AppType.lang_no,
    'premium_lifetime_80_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_lifetime_80_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_80_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_lifetime_80_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_lifetime_80_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_lifetime_80_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_lifetime_80_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_lifetime_80_lang_th_v2': appType_1.AppType.lang_th,
    'premium_lifetime_80_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_lifetime_80_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_lifetime_80_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_lifetime_80_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_80_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_lifetime_80_local_ar_v2': appType_1.AppType.local_ar,
    'premium_lifetime_80_local_hu_v2': appType_1.AppType.local_hu,
    'premium_lifetime_80_local_zh_v2': appType_1.AppType.local_zh,
    'premium_lifetime_80_scripts_v2': appType_1.AppType.scripts,
    'premium_lifetime_80_upopoy_v2': appType_1.AppType.upopoy,
    'premium_lifetime_discount_40_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_40_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_40_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_40_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_40_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_40_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_40_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_40_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_40_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_40_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_40_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_40_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_40_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_40_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_40_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_40_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_40_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_40_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_40_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_40_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_40_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_40_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_40_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_40_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_40_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_40_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_40_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_40_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_40_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_40_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_40_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_40_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_40_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_40_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_40_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_40_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_40_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_40_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_40_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_40_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_40_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_40_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_40_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_40_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_40_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_40_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_40_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_40_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_40_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_40_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_40_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_40_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_40_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_40_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_40_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_40_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_40_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_40_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_40_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_40_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_40_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_40_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_40_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_40_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_40_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_40_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_40_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_40_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_40_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_40_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_40_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_40_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_40_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_40_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_40_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_40_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_40_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_40_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_40_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_40_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_40_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_40_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_40_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_40_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_40_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_40_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_40_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_40_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_40_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_40_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_40_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_40_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_40_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_40_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_40_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_40_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_40_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_40_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_40_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_40_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_40_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_40_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_40_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_40_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_40_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_40_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_40_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_40_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_40_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_40_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_40_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_40_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_40_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_40_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_40_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_40_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_40_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_40_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_40_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_40_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_40_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_40_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_40_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_40_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_40_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_40_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_40_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_40_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_40_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_40_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_40_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_40_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_40_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_40_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_40_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_40_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_40_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_40_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_40_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_40_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_40_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_40_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_40_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_40_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_40_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_40_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_40_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_40_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_40_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_40_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_40_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_40_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_40_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_40_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_40_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_40_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_40_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_40_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_40_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_40_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_40_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_40_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_40_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_40_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_40_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_40_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_40_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_40_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_40_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_40_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_40_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_40_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_40_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_40_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_40_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_40_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_40_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_40_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_40_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_40_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_40_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_40_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_40_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_40_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_40_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_40_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_bogo_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_bogo_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_bogo_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_bogo_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_bogo_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_bogo_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_bogo_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_bogo_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_bogo_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_bogo_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_bogo_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_bogo_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_bogo_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_bogo_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_bogo_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_bogo_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_bogo_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_bogo_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_bogo_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_bogo_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_bogo_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_bogo_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_bogo_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_bogo_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_bogo_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_bogo_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_bogo_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_bogo_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_bogo_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_bogo_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_bogo_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_bogo_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_bogo_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_bogo_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_bogo_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_bogo_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_bogo_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_bogo_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_bogo_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_bogo_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_bogo_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_bogo_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_bogo_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_bogo_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_bogo_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_bogo_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_bogo_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_bogo_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_bogo_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_bogo_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_bogo_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_bogo_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_bogo_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_bogo_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_bogo_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_bogo_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_bogo_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_bogo_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_bogo_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_bogo_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_bogo_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_bogo_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_bogo_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_bogo_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_bogo_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_bogo_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_bogo_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_bogo_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_bogo_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_bogo_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_bogo_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_bogo_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_bogo_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_bogo_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_bogo_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_bogo_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_bogo_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_bogo_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_bogo_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_bogo_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_bogo_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_bogo_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_bogo_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_bogo_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_bogo_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_bogo_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_bogo_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_bogo_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_bogo_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_bogo_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_bogo_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_bogo_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_bogo_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_bogo_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_bogo_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_bogo_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_bogo_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_bogo_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_bogo_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_bogo_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_bogo_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_bogo_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_bogo_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_bogo_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_bogo_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_bogo_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_bogo_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_bogo_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_bogo_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_bogo_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_bogo_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_bogo_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_bogo_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_bogo_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_bogo_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_bogo_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_bogo_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_bogo_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_bogo_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_bogo_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_bogo_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_bogo_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_bogo_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_bogo_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_bogo_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_bogo_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_bogo_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_bogo_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_bogo_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_bogo_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_bogo_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_bogo_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_bogo_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_bogo_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_bogo_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_bogo_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_bogo_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_bogo_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_bogo_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_bogo_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_bogo_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_bogo_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_bogo_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_bogo_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_bogo_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_bogo_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_bogo_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_bogo_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_bogo_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_bogo_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_bogo_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_bogo_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_bogo_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_bogo_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_bogo_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_bogo_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_bogo_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_bogo_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_bogo_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_bogo_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_bogo_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_bogo_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_bogo_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_bogo_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_bogo_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_45_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_45_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_45_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_45_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_45_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_45_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_45_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_45_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_45_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_45_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_45_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_45_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_45_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_45_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_45_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_45_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_45_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_45_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_45_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_45_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_45_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_45_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_45_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_45_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_45_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_45_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_45_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_45_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_45_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_45_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_45_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_45_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_45_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_45_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_45_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_45_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_45_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_45_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_45_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_45_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_45_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_45_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_45_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_45_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_45_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_45_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_45_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_45_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_45_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_45_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_45_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_50_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_50_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_50_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_50_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_50_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_50_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_50_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_50_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_50_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_50_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_50_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_50_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_50_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_50_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_50_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_50_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_50_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_50_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_50_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_50_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_50_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_50_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_50_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_50_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_50_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_50_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_50_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_50_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_50_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_50_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_50_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_50_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_50_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_50_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_50_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_50_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_50_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_50_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_50_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_50_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_50_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_50_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_50_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_50_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_50_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_50_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_50_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_50_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_50_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_50_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_50_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_50_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_50_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_50_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_50_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_50_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_50_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_50_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_50_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_50_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_50_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_50_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_50_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_50_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_50_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_50_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_50_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_50_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_50_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_50_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_50_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_50_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_50_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_50_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_50_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_50_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_50_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_50_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_50_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_50_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_50_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_50_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_50_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_50_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_50_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_50_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_50_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_50_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_50_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_50_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_50_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_50_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_50_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_50_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_50_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_50_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_50_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_50_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_50_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_50_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_50_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_50_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_50_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_50_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_50_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_50_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_50_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_50_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_50_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_50_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_50_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_50_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_50_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_50_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_50_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_50_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_50_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_50_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_50_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_50_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_50_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_50_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_50_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_50_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_50_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_50_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_50_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_50_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_50_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_50_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_50_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_50_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_50_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_50_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_50_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_50_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_50_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_50_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_50_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_50_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_50_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_50_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_50_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_50_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_50_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_50_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_50_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_50_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_50_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_50_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_50_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_50_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_50_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_50_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_50_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_50_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_50_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_50_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_50_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_50_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_50_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_50_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_50_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_50_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_50_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_50_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_50_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_50_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_50_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_50_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_50_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_50_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_50_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_50_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_50_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_50_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_50_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_50_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_50_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_50_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_50_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_50_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_50_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_50_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_50_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_50_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_55_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_55_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_55_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_55_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_55_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_55_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_55_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_55_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_55_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_55_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_55_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_55_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_55_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_55_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_55_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_55_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_55_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_55_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_55_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_55_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_55_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_55_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_55_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_55_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_55_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_55_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_55_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_55_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_55_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_55_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_55_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_55_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_55_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_55_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_55_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_55_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_55_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_55_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_55_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_55_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_55_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_55_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_55_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_55_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_55_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_55_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_55_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_55_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_55_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_55_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_55_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_55_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_55_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_55_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_55_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_55_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_55_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_55_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_55_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_55_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_55_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_55_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_55_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_55_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_55_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_55_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_55_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_55_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_55_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_55_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_55_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_55_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_55_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_55_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_55_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_55_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_55_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_55_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_55_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_55_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_55_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_55_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_55_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_55_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_55_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_55_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_55_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_55_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_55_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_55_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_55_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_55_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_55_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_55_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_55_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_55_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_55_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_55_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_55_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_55_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_55_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_55_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_55_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_55_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_55_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_55_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_55_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_55_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_55_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_55_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_55_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_55_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_55_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_55_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_55_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_55_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_55_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_55_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_55_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_55_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_55_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_55_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_55_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_55_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_55_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_55_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_55_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_55_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_55_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_55_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_55_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_55_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_55_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_55_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_55_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_55_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_55_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_55_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_55_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_55_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_55_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_55_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_55_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_55_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_55_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_55_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_55_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_55_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_55_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_55_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_55_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_55_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_55_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_55_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_55_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_55_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_55_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_55_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_55_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_55_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_55_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_55_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_55_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_55_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_55_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_55_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_55_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_55_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_55_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_55_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_55_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_55_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_55_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_55_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_55_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_55_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_55_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_55_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_55_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_55_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_55_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_55_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_55_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_55_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_55_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_55_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_60_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_60_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_60_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_60_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_60_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_60_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_60_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_60_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_60_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_60_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_60_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_60_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_60_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_60_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_60_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_60_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_60_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_60_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_60_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_60_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_60_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_60_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_60_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_60_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_60_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_60_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_60_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_60_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_60_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_60_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_60_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_60_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_60_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_60_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_60_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_60_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_60_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_60_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_60_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_60_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_60_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_60_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_60_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_60_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_60_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_60_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_60_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_60_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_60_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_60_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_60_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_60_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_60_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_60_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_60_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_60_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_60_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_60_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_60_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_60_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_60_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_60_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_60_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_60_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_60_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_60_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_60_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_60_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_60_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_60_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_60_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_60_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_60_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_60_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_60_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_60_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_60_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_60_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_60_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_60_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_60_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_60_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_60_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_60_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_60_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_60_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_60_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_60_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_60_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_60_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_60_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_60_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_60_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_60_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_60_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_60_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_60_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_60_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_60_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_60_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_60_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_60_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_60_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_60_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_60_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_60_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_60_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_60_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_60_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_60_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_60_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_60_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_60_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_60_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_60_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_60_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_60_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_60_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_60_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_60_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_60_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_60_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_60_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_60_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_60_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_60_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_60_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_60_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_60_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_60_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_60_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_60_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_60_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_60_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_60_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_60_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_60_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_60_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_60_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_60_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_60_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_60_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_60_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_60_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_60_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_60_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_60_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_60_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_60_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_60_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_60_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_60_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_60_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_60_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_60_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_60_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_60_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_60_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_60_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_60_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_60_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_60_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_60_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_60_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_60_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_60_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_60_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_60_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_60_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_60_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_60_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_60_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_60_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_60_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_60_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_60_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_60_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_60_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_60_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_60_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_60_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_60_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_60_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_60_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_60_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_60_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_65_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_65_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_65_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_65_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_65_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_discount_65_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_65_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_65_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_65_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_65_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_65_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_65_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_65_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_65_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_65_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_65_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_65_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_65_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_65_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_65_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_65_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_65_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_65_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_65_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_65_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_65_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_65_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_65_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_65_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_65_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_65_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_65_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_65_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_65_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_65_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_65_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_65_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_65_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_65_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_65_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_65_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_65_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_65_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_65_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_65_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_65_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_65_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_65_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_65_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_65_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_discount_65_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_65_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_65_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_65_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_65_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_65_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_65_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_65_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_65_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_65_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_65_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_65_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_65_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_65_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_65_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_65_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_65_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_65_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_65_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_65_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_65_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_65_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_65_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_65_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_65_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_65_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_65_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_65_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_65_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_65_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_65_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_65_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_65_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_65_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_65_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_65_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_65_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_65_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_65_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_65_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_65_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_65_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_65_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_65_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_65_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_discount_65_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_65_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_65_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_65_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_65_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_65_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_65_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_65_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_65_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_65_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_65_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_65_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_65_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_65_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_65_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_65_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_65_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_65_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_65_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_65_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_65_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_65_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_65_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_65_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_65_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_65_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_65_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_65_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_65_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_65_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_65_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_65_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_65_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_65_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_65_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_65_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_65_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_65_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_65_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_65_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_discount_65_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_discount_65_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_discount_65_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_discount_65_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_discount_65_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_discount_65_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_discount_65_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_discount_65_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_discount_65_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_discount_65_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_discount_65_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_discount_65_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_discount_65_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_discount_65_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_discount_65_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_discount_65_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_discount_65_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_discount_65_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_discount_65_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_discount_65_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_discount_65_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_discount_65_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_discount_65_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_discount_65_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_discount_65_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_discount_65_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_discount_65_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_discount_65_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_discount_65_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_discount_65_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_discount_65_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_discount_65_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_discount_65_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_discount_65_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_discount_65_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_discount_65_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_discount_65_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_discount_65_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_discount_65_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_discount_65_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_discount_65_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_discount_65_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_discount_65_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_discount_65_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_discount_65_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_discount_65_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_discount_65_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_discount_65_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_discount_65_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_discount_65_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_discount_65_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_full_price_tier_a_bite': appType_1.AppType.bite,
    'premium_lifetime_full_price_tier_a_droplets': appType_1.AppType.droplets,
    'premium_lifetime_full_price_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_full_price_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_full_price_tier_a_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_a_int': appType_1.AppType.int,
    'premium_lifetime_full_price_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_full_price_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_full_price_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_full_price_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_full_price_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_full_price_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_full_price_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_full_price_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_full_price_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_full_price_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_full_price_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_full_price_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_full_price_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_full_price_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_full_price_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_full_price_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_full_price_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_full_price_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_full_price_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_full_price_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_full_price_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_full_price_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_full_price_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_full_price_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_full_price_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_full_price_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_full_price_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_full_price_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_full_price_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_full_price_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_full_price_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_full_price_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_full_price_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_full_price_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_full_price_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_full_price_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_full_price_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_full_price_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_full_price_tier_a_scripts': appType_1.AppType.scripts,
    'premium_lifetime_full_price_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_full_price_tier_b_bite': appType_1.AppType.bite,
    'premium_lifetime_full_price_tier_b_droplets': appType_1.AppType.droplets,
    'premium_lifetime_full_price_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_full_price_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_full_price_tier_b_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_b_int': appType_1.AppType.int,
    'premium_lifetime_full_price_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_full_price_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_full_price_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_full_price_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_full_price_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_full_price_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_full_price_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_full_price_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_full_price_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_full_price_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_full_price_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_full_price_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_full_price_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_full_price_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_full_price_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_full_price_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_full_price_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_full_price_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_full_price_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_full_price_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_full_price_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_full_price_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_full_price_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_full_price_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_full_price_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_full_price_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_full_price_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_full_price_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_full_price_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_full_price_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_full_price_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_full_price_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_full_price_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_full_price_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_full_price_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_full_price_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_full_price_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_full_price_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_full_price_tier_b_scripts': appType_1.AppType.scripts,
    'premium_lifetime_full_price_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_full_price_tier_c_bite': appType_1.AppType.bite,
    'premium_lifetime_full_price_tier_c_droplets': appType_1.AppType.droplets,
    'premium_lifetime_full_price_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_full_price_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_full_price_tier_c_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_c_int': appType_1.AppType.int,
    'premium_lifetime_full_price_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_full_price_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_full_price_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_full_price_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_full_price_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_full_price_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_full_price_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_full_price_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_full_price_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_full_price_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_full_price_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_full_price_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_full_price_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_full_price_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_full_price_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_full_price_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_full_price_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_full_price_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_full_price_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_full_price_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_full_price_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_full_price_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_full_price_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_full_price_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_full_price_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_full_price_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_full_price_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_full_price_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_full_price_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_full_price_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_full_price_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_full_price_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_full_price_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_full_price_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_full_price_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_full_price_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_full_price_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_full_price_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_full_price_tier_c_scripts': appType_1.AppType.scripts,
    'premium_lifetime_full_price_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_lifetime_full_price_tier_d_bite': appType_1.AppType.bite,
    'premium_lifetime_full_price_tier_d_droplets': appType_1.AppType.droplets,
    'premium_lifetime_full_price_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_lifetime_full_price_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_lifetime_full_price_tier_d_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_d_int': appType_1.AppType.int,
    'premium_lifetime_full_price_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_lifetime_full_price_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_lifetime_full_price_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_lifetime_full_price_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_lifetime_full_price_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_lifetime_full_price_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_lifetime_full_price_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_lifetime_full_price_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_lifetime_full_price_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_lifetime_full_price_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_lifetime_full_price_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_lifetime_full_price_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_lifetime_full_price_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_lifetime_full_price_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_lifetime_full_price_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_lifetime_full_price_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_lifetime_full_price_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_lifetime_full_price_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_lifetime_full_price_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_lifetime_full_price_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_lifetime_full_price_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_lifetime_full_price_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_lifetime_full_price_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_lifetime_full_price_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_lifetime_full_price_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_lifetime_full_price_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_lifetime_full_price_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_lifetime_full_price_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_lifetime_full_price_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_lifetime_full_price_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_lifetime_full_price_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_lifetime_full_price_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_lifetime_full_price_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_lifetime_full_price_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_lifetime_full_price_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_lifetime_full_price_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_lifetime_full_price_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_lifetime_full_price_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_lifetime_full_price_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_lifetime_full_price_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_lifetime_full_price_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_lifetime_full_price_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_lifetime_full_price_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_lifetime_full_price_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_lifetime_full_price_tier_d_scripts': appType_1.AppType.scripts,
    'premium_lifetime_full_price_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_monthly_10_bite_v2': appType_1.AppType.bite,
    'premium_monthly_10_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_10_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_10_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_10_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_10_int_v2': appType_1.AppType.int,
    'premium_monthly_10_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_10_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_10_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_10_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_10_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_10_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_10_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_10_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_10_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_10_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_10_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_10_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_10_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_10_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_10_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_10_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_10_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_10_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_10_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_10_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_10_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_10_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_10_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_10_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_10_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_10_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_10_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_10_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_10_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_10_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_10_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_10_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_10_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_10_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_10_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_10_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_10_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_10_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_10_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_10_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_10_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_10_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_10_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_10_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_10_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_10_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_10_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_10_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_10_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_10_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_10_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_13_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_13_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_13_bite_v2': appType_1.AppType.bite,
    'premium_monthly_13_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_13_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_13_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_13_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_13_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_13_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_13_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_13_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_13_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_13_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_13_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_13_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_13_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_13_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_13_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_13_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_13_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_13_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_13_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_13_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_13_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_13_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_13_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_13_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_13_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_13_int_v2': appType_1.AppType.int,
    'premium_monthly_13_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_13_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_13_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_13_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_13_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_13_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_13_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_13_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_13_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_13_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_13_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_13_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_13_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_13_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_13_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_13_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_13_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_13_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_13_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_13_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_13_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_13_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_13_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_13_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_13_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_13_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_13_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_15_bite_v2': appType_1.AppType.bite,
    'premium_monthly_15_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_15_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_15_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_15_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_15_int_v2': appType_1.AppType.int,
    'premium_monthly_15_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_15_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_15_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_15_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_15_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_15_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_15_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_15_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_15_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_15_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_15_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_15_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_15_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_15_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_15_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_15_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_15_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_15_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_15_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_15_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_15_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_15_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_15_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_15_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_15_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_15_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_15_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_15_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_15_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_15_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_15_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_15_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_15_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_15_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_15_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_15_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_15_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_15_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_15_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_15_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_15_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_15_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_15_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_15_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_15_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_15_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_15_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_15_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_15_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_15_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_15_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_3_bite_v2': appType_1.AppType.bite,
    'premium_monthly_3_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_3_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_3_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_3_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_3_int_v2': appType_1.AppType.int,
    'premium_monthly_3_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_3_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_3_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_3_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_3_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_3_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_3_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_3_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_3_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_3_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_3_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_3_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_3_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_3_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_3_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_3_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_3_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_3_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_3_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_3_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_3_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_3_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_3_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_3_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_3_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_3_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_3_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_3_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_3_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_3_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_3_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_3_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_3_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_3_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_3_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_3_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_3_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_3_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_3_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_3_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_3_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_3_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_3_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_3_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_3_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_3_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_3_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_3_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_3_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_3_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_3_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_full_price_tier_a_bite_v2': appType_1.AppType.bite,
    'premium_monthly_full_price_tier_a_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_full_price_tier_a_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_full_price_tier_a_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_full_price_tier_a_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_a_int_v2': appType_1.AppType.int,
    'premium_monthly_full_price_tier_a_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_full_price_tier_a_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_full_price_tier_a_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_full_price_tier_a_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_full_price_tier_a_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_full_price_tier_a_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_full_price_tier_a_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_a_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_full_price_tier_a_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_a_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_full_price_tier_a_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_a_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_full_price_tier_a_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_a_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_full_price_tier_a_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_full_price_tier_a_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_full_price_tier_a_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_full_price_tier_a_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_full_price_tier_a_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_full_price_tier_a_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_full_price_tier_a_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_full_price_tier_a_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_full_price_tier_a_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_full_price_tier_a_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_full_price_tier_a_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_full_price_tier_a_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_a_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_a_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_full_price_tier_a_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_full_price_tier_a_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_full_price_tier_a_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_full_price_tier_a_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_full_price_tier_a_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_full_price_tier_a_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_a_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_a_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_full_price_tier_a_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_full_price_tier_a_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_full_price_tier_a_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_full_price_tier_a_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_full_price_tier_a_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_full_price_tier_a_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_full_price_tier_a_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_full_price_tier_a_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_a_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_full_price_tier_a_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_a_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_full_price_tier_a_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_a_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_full_price_tier_a_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_full_price_tier_a_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_full_price_tier_b_bite_v2': appType_1.AppType.bite,
    'premium_monthly_full_price_tier_b_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_full_price_tier_b_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_full_price_tier_b_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_full_price_tier_b_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_b_int_v2': appType_1.AppType.int,
    'premium_monthly_full_price_tier_b_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_full_price_tier_b_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_full_price_tier_b_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_full_price_tier_b_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_full_price_tier_b_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_full_price_tier_b_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_full_price_tier_b_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_b_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_full_price_tier_b_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_b_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_full_price_tier_b_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_b_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_full_price_tier_b_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_b_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_full_price_tier_b_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_full_price_tier_b_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_full_price_tier_b_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_full_price_tier_b_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_full_price_tier_b_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_full_price_tier_b_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_full_price_tier_b_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_full_price_tier_b_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_full_price_tier_b_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_full_price_tier_b_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_full_price_tier_b_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_full_price_tier_b_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_b_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_b_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_full_price_tier_b_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_full_price_tier_b_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_full_price_tier_b_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_full_price_tier_b_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_full_price_tier_b_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_full_price_tier_b_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_b_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_b_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_full_price_tier_b_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_full_price_tier_b_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_full_price_tier_b_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_full_price_tier_b_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_full_price_tier_b_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_full_price_tier_b_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_full_price_tier_b_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_full_price_tier_b_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_b_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_full_price_tier_b_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_b_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_full_price_tier_b_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_b_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_full_price_tier_b_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_full_price_tier_b_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_full_price_tier_c_bite_v2': appType_1.AppType.bite,
    'premium_monthly_full_price_tier_c_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_full_price_tier_c_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_full_price_tier_c_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_full_price_tier_c_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_c_int_v2': appType_1.AppType.int,
    'premium_monthly_full_price_tier_c_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_full_price_tier_c_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_full_price_tier_c_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_full_price_tier_c_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_full_price_tier_c_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_full_price_tier_c_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_full_price_tier_c_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_c_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_full_price_tier_c_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_c_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_full_price_tier_c_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_c_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_full_price_tier_c_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_c_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_full_price_tier_c_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_full_price_tier_c_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_full_price_tier_c_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_full_price_tier_c_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_full_price_tier_c_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_full_price_tier_c_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_full_price_tier_c_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_full_price_tier_c_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_full_price_tier_c_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_full_price_tier_c_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_full_price_tier_c_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_full_price_tier_c_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_c_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_c_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_full_price_tier_c_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_full_price_tier_c_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_full_price_tier_c_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_full_price_tier_c_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_full_price_tier_c_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_full_price_tier_c_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_c_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_c_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_full_price_tier_c_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_full_price_tier_c_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_full_price_tier_c_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_full_price_tier_c_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_full_price_tier_c_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_full_price_tier_c_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_full_price_tier_c_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_full_price_tier_c_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_c_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_full_price_tier_c_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_c_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_full_price_tier_c_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_c_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_full_price_tier_c_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_full_price_tier_c_upopoy_v2': appType_1.AppType.upopoy,
    'premium_monthly_full_price_tier_d_bite_v2': appType_1.AppType.bite,
    'premium_monthly_full_price_tier_d_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_monthly_full_price_tier_d_droplets_v2': appType_1.AppType.droplets,
    'premium_monthly_full_price_tier_d_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_monthly_full_price_tier_d_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_d_int_v2': appType_1.AppType.int,
    'premium_monthly_full_price_tier_d_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_monthly_full_price_tier_d_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_monthly_full_price_tier_d_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_monthly_full_price_tier_d_lang_da_v2': appType_1.AppType.lang_da,
    'premium_monthly_full_price_tier_d_lang_de_v2': appType_1.AppType.lang_de,
    'premium_monthly_full_price_tier_d_lang_el_v2': appType_1.AppType.lang_el,
    'premium_monthly_full_price_tier_d_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_d_lang_en_v2': appType_1.AppType.lang_en,
    'premium_monthly_full_price_tier_d_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_monthly_full_price_tier_d_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_monthly_full_price_tier_d_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_d_lang_es_v2': appType_1.AppType.lang_es,
    'premium_monthly_full_price_tier_d_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_monthly_full_price_tier_d_lang_et_v2': appType_1.AppType.lang_et,
    'premium_monthly_full_price_tier_d_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_monthly_full_price_tier_d_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_monthly_full_price_tier_d_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_monthly_full_price_tier_d_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_monthly_full_price_tier_d_lang_he_v2': appType_1.AppType.lang_he,
    'premium_monthly_full_price_tier_d_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_monthly_full_price_tier_d_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_monthly_full_price_tier_d_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_monthly_full_price_tier_d_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_monthly_full_price_tier_d_lang_id_v2': appType_1.AppType.lang_id,
    'premium_monthly_full_price_tier_d_lang_it_v2': appType_1.AppType.lang_it,
    'premium_monthly_full_price_tier_d_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_d_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_monthly_full_price_tier_d_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_monthly_full_price_tier_d_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_monthly_full_price_tier_d_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_monthly_full_price_tier_d_lang_no_v2': appType_1.AppType.lang_no,
    'premium_monthly_full_price_tier_d_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_monthly_full_price_tier_d_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_monthly_full_price_tier_d_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_d_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_monthly_full_price_tier_d_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_monthly_full_price_tier_d_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_monthly_full_price_tier_d_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_monthly_full_price_tier_d_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_monthly_full_price_tier_d_lang_th_v2': appType_1.AppType.lang_th,
    'premium_monthly_full_price_tier_d_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_monthly_full_price_tier_d_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_monthly_full_price_tier_d_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_monthly_full_price_tier_d_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_d_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_monthly_full_price_tier_d_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_monthly_full_price_tier_d_local_ar_v2': appType_1.AppType.local_ar,
    'premium_monthly_full_price_tier_d_local_hu_v2': appType_1.AppType.local_hu,
    'premium_monthly_full_price_tier_d_local_zh_v2': appType_1.AppType.local_zh,
    'premium_monthly_full_price_tier_d_scripts_v2': appType_1.AppType.scripts,
    'premium_monthly_full_price_tier_d_upopoy_v2': appType_1.AppType.upopoy,
    'premium_quarterly_20_bite': appType_1.AppType.bite,
    'premium_quarterly_20_droplets': appType_1.AppType.droplets,
    'premium_quarterly_20_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_20_global_eagle': appType_1.AppType.global_eagle,
    'premium_quarterly_20_hu': appType_1.AppType.local_hu,
    'premium_quarterly_20_int': appType_1.AppType.int,
    'premium_quarterly_20_lang_ain': appType_1.AppType.lang_ain,
    'premium_quarterly_20_lang_ar': appType_1.AppType.lang_ar,
    'premium_quarterly_20_lang_bs': appType_1.AppType.lang_bs,
    'premium_quarterly_20_lang_da': appType_1.AppType.lang_da,
    'premium_quarterly_20_lang_de': appType_1.AppType.lang_de,
    'premium_quarterly_20_lang_el': appType_1.AppType.lang_el,
    'premium_quarterly_20_lang_en': appType_1.AppType.lang_en,
    'premium_quarterly_20_lang_en2': appType_1.AppType.lang_enus,
    'premium_quarterly_20_lang_enus1': appType_1.AppType.lang_enus,
    'premium_quarterly_20_lang_eo': appType_1.AppType.lang_eo,
    'premium_quarterly_20_lang_es': appType_1.AppType.lang_es,
    'premium_quarterly_20_lang_es2': appType_1.AppType.lang_esmx,
    'premium_quarterly_20_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_quarterly_20_lang_et': appType_1.AppType.lang_et,
    'premium_quarterly_20_lang_fa': appType_1.AppType.lang_fa,
    'premium_quarterly_20_lang_fi': appType_1.AppType.lang_fi,
    'premium_quarterly_20_lang_fr': appType_1.AppType.lang_fr,
    'premium_quarterly_20_lang_haw': appType_1.AppType.lang_haw,
    'premium_quarterly_20_lang_he': appType_1.AppType.lang_he,
    'premium_quarterly_20_lang_hi': appType_1.AppType.lang_hi,
    'premium_quarterly_20_lang_hr': appType_1.AppType.lang_hr,
    'premium_quarterly_20_lang_hu': appType_1.AppType.lang_hu,
    'premium_quarterly_20_lang_ic': appType_1.AppType.lang_ic,
    'premium_quarterly_20_lang_id': appType_1.AppType.lang_id,
    'premium_quarterly_20_lang_it': appType_1.AppType.lang_it,
    'premium_quarterly_20_lang_ja': appType_1.AppType.lang_ja,
    'premium_quarterly_20_lang_jp': appType_1.AppType.lang_ja,
    'premium_quarterly_20_lang_ko': appType_1.AppType.lang_ko,
    'premium_quarterly_20_lang_mi': appType_1.AppType.lang_mi,
    'premium_quarterly_20_lang_nl': appType_1.AppType.lang_nl,
    'premium_quarterly_20_lang_no': appType_1.AppType.lang_no,
    'premium_quarterly_20_lang_pl': appType_1.AppType.lang_pl,
    'premium_quarterly_20_lang_pt': appType_1.AppType.lang_pt,
    'premium_quarterly_20_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_quarterly_20_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_quarterly_20_lang_ru': appType_1.AppType.lang_ru,
    'premium_quarterly_20_lang_sm': appType_1.AppType.lang_sm,
    'premium_quarterly_20_lang_sr': appType_1.AppType.lang_sr,
    'premium_quarterly_20_lang_sv': appType_1.AppType.lang_sv,
    'premium_quarterly_20_lang_th': appType_1.AppType.lang_th,
    'premium_quarterly_20_lang_tl': appType_1.AppType.lang_tl,
    'premium_quarterly_20_lang_tr': appType_1.AppType.lang_tr,
    'premium_quarterly_20_lang_vi': appType_1.AppType.lang_vi,
    'premium_quarterly_20_lang_zh': appType_1.AppType.lang_zh,
    'premium_quarterly_20_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_20_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_quarterly_20_local_ar': appType_1.AppType.local_ar,
    'premium_quarterly_20_local_hu': appType_1.AppType.local_hu,
    'premium_quarterly_20_local_zh': appType_1.AppType.local_zh,
    'premium_quarterly_20_scripts': appType_1.AppType.scripts,
    'premium_quarterly_20_upopoy': appType_1.AppType.upopoy,
    'premium_quarterly_30_bite_v3': appType_1.AppType.bite,
    'premium_quarterly_30_droplets_demo_apple_store_v3': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_30_droplets_v3': appType_1.AppType.droplets,
    'premium_quarterly_30_global_eagle_v3': appType_1.AppType.global_eagle,
    'premium_quarterly_30_hu_v3': appType_1.AppType.local_hu,
    'premium_quarterly_30_int_v3': appType_1.AppType.int,
    'premium_quarterly_30_lang_ain_v3': appType_1.AppType.lang_ain,
    'premium_quarterly_30_lang_ar_v3': appType_1.AppType.lang_ar,
    'premium_quarterly_30_lang_bs_v3': appType_1.AppType.lang_bs,
    'premium_quarterly_30_lang_da_v3': appType_1.AppType.lang_da,
    'premium_quarterly_30_lang_de_v3': appType_1.AppType.lang_de,
    'premium_quarterly_30_lang_el_v3': appType_1.AppType.lang_el,
    'premium_quarterly_30_lang_en2_v3': appType_1.AppType.lang_enus,
    'premium_quarterly_30_lang_en_v3': appType_1.AppType.lang_en,
    'premium_quarterly_30_lang_enus1_v3': appType_1.AppType.lang_enus,
    'premium_quarterly_30_lang_eo_v3': appType_1.AppType.lang_eo,
    'premium_quarterly_30_lang_es2_v3': appType_1.AppType.lang_esmx,
    'premium_quarterly_30_lang_es_v3': appType_1.AppType.lang_es,
    'premium_quarterly_30_lang_esmx_v3': appType_1.AppType.lang_esmx,
    'premium_quarterly_30_lang_et_v3': appType_1.AppType.lang_et,
    'premium_quarterly_30_lang_fa_v3': appType_1.AppType.lang_fa,
    'premium_quarterly_30_lang_fi_v3': appType_1.AppType.lang_fi,
    'premium_quarterly_30_lang_fr_v3': appType_1.AppType.lang_fr,
    'premium_quarterly_30_lang_haw_v3': appType_1.AppType.lang_haw,
    'premium_quarterly_30_lang_he_v3': appType_1.AppType.lang_he,
    'premium_quarterly_30_lang_hi_v3': appType_1.AppType.lang_hi,
    'premium_quarterly_30_lang_hr_v3': appType_1.AppType.lang_hr,
    'premium_quarterly_30_lang_hu_v3': appType_1.AppType.lang_hu,
    'premium_quarterly_30_lang_ic_v3': appType_1.AppType.lang_ic,
    'premium_quarterly_30_lang_id_v3': appType_1.AppType.lang_id,
    'premium_quarterly_30_lang_it_v3': appType_1.AppType.lang_it,
    'premium_quarterly_30_lang_ja_v3': appType_1.AppType.lang_ja,
    'premium_quarterly_30_lang_jp_v3': appType_1.AppType.lang_ja,
    'premium_quarterly_30_lang_ko_v3': appType_1.AppType.lang_ko,
    'premium_quarterly_30_lang_mi_v3': appType_1.AppType.lang_mi,
    'premium_quarterly_30_lang_nl_v3': appType_1.AppType.lang_nl,
    'premium_quarterly_30_lang_no_v3': appType_1.AppType.lang_no,
    'premium_quarterly_30_lang_pl_v3': appType_1.AppType.lang_pl,
    'premium_quarterly_30_lang_pt2_v3': appType_1.AppType.lang_ptbr,
    'premium_quarterly_30_lang_pt_v3': appType_1.AppType.lang_pt,
    'premium_quarterly_30_lang_ptpt_v3': appType_1.AppType.lang_pt,
    'premium_quarterly_30_lang_ru_v3': appType_1.AppType.lang_ru,
    'premium_quarterly_30_lang_sm_v3': appType_1.AppType.lang_sm,
    'premium_quarterly_30_lang_sr_v3': appType_1.AppType.lang_sr,
    'premium_quarterly_30_lang_sv_v3': appType_1.AppType.lang_sv,
    'premium_quarterly_30_lang_th_v3': appType_1.AppType.lang_th,
    'premium_quarterly_30_lang_tl_v3': appType_1.AppType.lang_tl,
    'premium_quarterly_30_lang_tr_v3': appType_1.AppType.lang_tr,
    'premium_quarterly_30_lang_vi_v3': appType_1.AppType.lang_vi,
    'premium_quarterly_30_lang_zh2_v3': appType_1.AppType.lang_zhyue,
    'premium_quarterly_30_lang_zh_v3': appType_1.AppType.lang_zh,
    'premium_quarterly_30_lang_zhyue_v3': appType_1.AppType.lang_zhyue,
    'premium_quarterly_30_local_ar_v3': appType_1.AppType.local_ar,
    'premium_quarterly_30_local_hu_v3': appType_1.AppType.local_hu,
    'premium_quarterly_30_local_zh_v3': appType_1.AppType.local_zh,
    'premium_quarterly_30_scripts_v3': appType_1.AppType.scripts,
    'premium_quarterly_30_upopoy_v3': appType_1.AppType.upopoy,
    'premium_quarterly_full_price_tier_a_bite_v2': appType_1.AppType.bite,
    'premium_quarterly_full_price_tier_a_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_full_price_tier_a_droplets_v2': appType_1.AppType.droplets,
    'premium_quarterly_full_price_tier_a_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_quarterly_full_price_tier_a_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_a_int_v2': appType_1.AppType.int,
    'premium_quarterly_full_price_tier_a_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_quarterly_full_price_tier_a_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_quarterly_full_price_tier_a_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_quarterly_full_price_tier_a_lang_da_v2': appType_1.AppType.lang_da,
    'premium_quarterly_full_price_tier_a_lang_de_v2': appType_1.AppType.lang_de,
    'premium_quarterly_full_price_tier_a_lang_el_v2': appType_1.AppType.lang_el,
    'premium_quarterly_full_price_tier_a_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_a_lang_en_v2': appType_1.AppType.lang_en,
    'premium_quarterly_full_price_tier_a_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_a_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_quarterly_full_price_tier_a_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_a_lang_es_v2': appType_1.AppType.lang_es,
    'premium_quarterly_full_price_tier_a_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_a_lang_et_v2': appType_1.AppType.lang_et,
    'premium_quarterly_full_price_tier_a_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_quarterly_full_price_tier_a_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_quarterly_full_price_tier_a_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_quarterly_full_price_tier_a_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_quarterly_full_price_tier_a_lang_he_v2': appType_1.AppType.lang_he,
    'premium_quarterly_full_price_tier_a_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_quarterly_full_price_tier_a_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_quarterly_full_price_tier_a_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_quarterly_full_price_tier_a_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_quarterly_full_price_tier_a_lang_id_v2': appType_1.AppType.lang_id,
    'premium_quarterly_full_price_tier_a_lang_it_v2': appType_1.AppType.lang_it,
    'premium_quarterly_full_price_tier_a_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_a_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_a_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_quarterly_full_price_tier_a_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_quarterly_full_price_tier_a_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_quarterly_full_price_tier_a_lang_no_v2': appType_1.AppType.lang_no,
    'premium_quarterly_full_price_tier_a_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_quarterly_full_price_tier_a_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_quarterly_full_price_tier_a_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_a_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_a_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_quarterly_full_price_tier_a_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_quarterly_full_price_tier_a_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_quarterly_full_price_tier_a_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_quarterly_full_price_tier_a_lang_th_v2': appType_1.AppType.lang_th,
    'premium_quarterly_full_price_tier_a_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_quarterly_full_price_tier_a_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_quarterly_full_price_tier_a_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_quarterly_full_price_tier_a_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_a_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_quarterly_full_price_tier_a_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_a_local_ar_v2': appType_1.AppType.local_ar,
    'premium_quarterly_full_price_tier_a_local_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_a_local_zh_v2': appType_1.AppType.local_zh,
    'premium_quarterly_full_price_tier_a_scripts_v2': appType_1.AppType.scripts,
    'premium_quarterly_full_price_tier_a_upopoy_v2': appType_1.AppType.upopoy,
    'premium_quarterly_full_price_tier_b_bite_v2': appType_1.AppType.bite,
    'premium_quarterly_full_price_tier_b_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_full_price_tier_b_droplets_v2': appType_1.AppType.droplets,
    'premium_quarterly_full_price_tier_b_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_quarterly_full_price_tier_b_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_b_int_v2': appType_1.AppType.int,
    'premium_quarterly_full_price_tier_b_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_quarterly_full_price_tier_b_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_quarterly_full_price_tier_b_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_quarterly_full_price_tier_b_lang_da_v2': appType_1.AppType.lang_da,
    'premium_quarterly_full_price_tier_b_lang_de_v2': appType_1.AppType.lang_de,
    'premium_quarterly_full_price_tier_b_lang_el_v2': appType_1.AppType.lang_el,
    'premium_quarterly_full_price_tier_b_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_b_lang_en_v2': appType_1.AppType.lang_en,
    'premium_quarterly_full_price_tier_b_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_b_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_quarterly_full_price_tier_b_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_b_lang_es_v2': appType_1.AppType.lang_es,
    'premium_quarterly_full_price_tier_b_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_b_lang_et_v2': appType_1.AppType.lang_et,
    'premium_quarterly_full_price_tier_b_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_quarterly_full_price_tier_b_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_quarterly_full_price_tier_b_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_quarterly_full_price_tier_b_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_quarterly_full_price_tier_b_lang_he_v2': appType_1.AppType.lang_he,
    'premium_quarterly_full_price_tier_b_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_quarterly_full_price_tier_b_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_quarterly_full_price_tier_b_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_quarterly_full_price_tier_b_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_quarterly_full_price_tier_b_lang_id_v2': appType_1.AppType.lang_id,
    'premium_quarterly_full_price_tier_b_lang_it_v2': appType_1.AppType.lang_it,
    'premium_quarterly_full_price_tier_b_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_b_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_b_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_quarterly_full_price_tier_b_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_quarterly_full_price_tier_b_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_quarterly_full_price_tier_b_lang_no_v2': appType_1.AppType.lang_no,
    'premium_quarterly_full_price_tier_b_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_quarterly_full_price_tier_b_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_quarterly_full_price_tier_b_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_b_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_b_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_quarterly_full_price_tier_b_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_quarterly_full_price_tier_b_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_quarterly_full_price_tier_b_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_quarterly_full_price_tier_b_lang_th_v2': appType_1.AppType.lang_th,
    'premium_quarterly_full_price_tier_b_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_quarterly_full_price_tier_b_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_quarterly_full_price_tier_b_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_quarterly_full_price_tier_b_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_b_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_quarterly_full_price_tier_b_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_b_local_ar_v2': appType_1.AppType.local_ar,
    'premium_quarterly_full_price_tier_b_local_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_b_local_zh_v2': appType_1.AppType.local_zh,
    'premium_quarterly_full_price_tier_b_scripts_v2': appType_1.AppType.scripts,
    'premium_quarterly_full_price_tier_b_upopoy_v2': appType_1.AppType.upopoy,
    'premium_quarterly_full_price_tier_c_bite_v2': appType_1.AppType.bite,
    'premium_quarterly_full_price_tier_c_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_full_price_tier_c_droplets_v2': appType_1.AppType.droplets,
    'premium_quarterly_full_price_tier_c_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_quarterly_full_price_tier_c_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_c_int_v2': appType_1.AppType.int,
    'premium_quarterly_full_price_tier_c_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_quarterly_full_price_tier_c_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_quarterly_full_price_tier_c_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_quarterly_full_price_tier_c_lang_da_v2': appType_1.AppType.lang_da,
    'premium_quarterly_full_price_tier_c_lang_de_v2': appType_1.AppType.lang_de,
    'premium_quarterly_full_price_tier_c_lang_el_v2': appType_1.AppType.lang_el,
    'premium_quarterly_full_price_tier_c_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_c_lang_en_v2': appType_1.AppType.lang_en,
    'premium_quarterly_full_price_tier_c_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_c_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_quarterly_full_price_tier_c_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_c_lang_es_v2': appType_1.AppType.lang_es,
    'premium_quarterly_full_price_tier_c_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_c_lang_et_v2': appType_1.AppType.lang_et,
    'premium_quarterly_full_price_tier_c_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_quarterly_full_price_tier_c_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_quarterly_full_price_tier_c_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_quarterly_full_price_tier_c_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_quarterly_full_price_tier_c_lang_he_v2': appType_1.AppType.lang_he,
    'premium_quarterly_full_price_tier_c_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_quarterly_full_price_tier_c_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_quarterly_full_price_tier_c_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_quarterly_full_price_tier_c_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_quarterly_full_price_tier_c_lang_id_v2': appType_1.AppType.lang_id,
    'premium_quarterly_full_price_tier_c_lang_it_v2': appType_1.AppType.lang_it,
    'premium_quarterly_full_price_tier_c_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_c_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_c_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_quarterly_full_price_tier_c_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_quarterly_full_price_tier_c_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_quarterly_full_price_tier_c_lang_no_v2': appType_1.AppType.lang_no,
    'premium_quarterly_full_price_tier_c_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_quarterly_full_price_tier_c_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_quarterly_full_price_tier_c_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_c_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_c_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_quarterly_full_price_tier_c_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_quarterly_full_price_tier_c_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_quarterly_full_price_tier_c_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_quarterly_full_price_tier_c_lang_th_v2': appType_1.AppType.lang_th,
    'premium_quarterly_full_price_tier_c_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_quarterly_full_price_tier_c_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_quarterly_full_price_tier_c_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_quarterly_full_price_tier_c_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_c_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_quarterly_full_price_tier_c_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_c_local_ar_v2': appType_1.AppType.local_ar,
    'premium_quarterly_full_price_tier_c_local_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_c_local_zh_v2': appType_1.AppType.local_zh,
    'premium_quarterly_full_price_tier_c_scripts_v2': appType_1.AppType.scripts,
    'premium_quarterly_full_price_tier_c_upopoy_v2': appType_1.AppType.upopoy,
    'premium_quarterly_full_price_tier_d_bite_v2': appType_1.AppType.bite,
    'premium_quarterly_full_price_tier_d_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_quarterly_full_price_tier_d_droplets_v2': appType_1.AppType.droplets,
    'premium_quarterly_full_price_tier_d_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_quarterly_full_price_tier_d_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_d_int_v2': appType_1.AppType.int,
    'premium_quarterly_full_price_tier_d_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_quarterly_full_price_tier_d_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_quarterly_full_price_tier_d_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_quarterly_full_price_tier_d_lang_da_v2': appType_1.AppType.lang_da,
    'premium_quarterly_full_price_tier_d_lang_de_v2': appType_1.AppType.lang_de,
    'premium_quarterly_full_price_tier_d_lang_el_v2': appType_1.AppType.lang_el,
    'premium_quarterly_full_price_tier_d_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_d_lang_en_v2': appType_1.AppType.lang_en,
    'premium_quarterly_full_price_tier_d_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_quarterly_full_price_tier_d_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_quarterly_full_price_tier_d_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_d_lang_es_v2': appType_1.AppType.lang_es,
    'premium_quarterly_full_price_tier_d_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_quarterly_full_price_tier_d_lang_et_v2': appType_1.AppType.lang_et,
    'premium_quarterly_full_price_tier_d_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_quarterly_full_price_tier_d_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_quarterly_full_price_tier_d_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_quarterly_full_price_tier_d_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_quarterly_full_price_tier_d_lang_he_v2': appType_1.AppType.lang_he,
    'premium_quarterly_full_price_tier_d_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_quarterly_full_price_tier_d_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_quarterly_full_price_tier_d_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_quarterly_full_price_tier_d_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_quarterly_full_price_tier_d_lang_id_v2': appType_1.AppType.lang_id,
    'premium_quarterly_full_price_tier_d_lang_it_v2': appType_1.AppType.lang_it,
    'premium_quarterly_full_price_tier_d_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_d_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_quarterly_full_price_tier_d_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_quarterly_full_price_tier_d_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_quarterly_full_price_tier_d_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_quarterly_full_price_tier_d_lang_no_v2': appType_1.AppType.lang_no,
    'premium_quarterly_full_price_tier_d_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_quarterly_full_price_tier_d_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_quarterly_full_price_tier_d_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_d_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_quarterly_full_price_tier_d_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_quarterly_full_price_tier_d_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_quarterly_full_price_tier_d_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_quarterly_full_price_tier_d_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_quarterly_full_price_tier_d_lang_th_v2': appType_1.AppType.lang_th,
    'premium_quarterly_full_price_tier_d_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_quarterly_full_price_tier_d_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_quarterly_full_price_tier_d_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_quarterly_full_price_tier_d_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_d_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_quarterly_full_price_tier_d_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_quarterly_full_price_tier_d_local_ar_v2': appType_1.AppType.local_ar,
    'premium_quarterly_full_price_tier_d_local_hu_v2': appType_1.AppType.local_hu,
    'premium_quarterly_full_price_tier_d_local_zh_v2': appType_1.AppType.local_zh,
    'premium_quarterly_full_price_tier_d_scripts_v2': appType_1.AppType.scripts,
    'premium_quarterly_full_price_tier_d_upopoy_v2': appType_1.AppType.upopoy,
    'premium_weekly_3_bite': appType_1.AppType.bite,
    'premium_weekly_3_droplets': appType_1.AppType.droplets,
    'premium_weekly_3_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_weekly_3_global_eagle': appType_1.AppType.global_eagle,
    'premium_weekly_3_hu': appType_1.AppType.local_hu,
    'premium_weekly_3_int': appType_1.AppType.int,
    'premium_weekly_3_lang_ain': appType_1.AppType.lang_ain,
    'premium_weekly_3_lang_ar': appType_1.AppType.lang_ar,
    'premium_weekly_3_lang_bs': appType_1.AppType.lang_bs,
    'premium_weekly_3_lang_da': appType_1.AppType.lang_da,
    'premium_weekly_3_lang_de': appType_1.AppType.lang_de,
    'premium_weekly_3_lang_el': appType_1.AppType.lang_el,
    'premium_weekly_3_lang_en': appType_1.AppType.lang_en,
    'premium_weekly_3_lang_en2': appType_1.AppType.lang_enus,
    'premium_weekly_3_lang_enus1': appType_1.AppType.lang_enus,
    'premium_weekly_3_lang_eo': appType_1.AppType.lang_eo,
    'premium_weekly_3_lang_es': appType_1.AppType.lang_es,
    'premium_weekly_3_lang_es2': appType_1.AppType.lang_esmx,
    'premium_weekly_3_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_weekly_3_lang_et': appType_1.AppType.lang_et,
    'premium_weekly_3_lang_fa': appType_1.AppType.lang_fa,
    'premium_weekly_3_lang_fi': appType_1.AppType.lang_fi,
    'premium_weekly_3_lang_fr': appType_1.AppType.lang_fr,
    'premium_weekly_3_lang_haw': appType_1.AppType.lang_haw,
    'premium_weekly_3_lang_he': appType_1.AppType.lang_he,
    'premium_weekly_3_lang_hi': appType_1.AppType.lang_hi,
    'premium_weekly_3_lang_hr': appType_1.AppType.lang_hr,
    'premium_weekly_3_lang_hu': appType_1.AppType.lang_hu,
    'premium_weekly_3_lang_ic': appType_1.AppType.lang_ic,
    'premium_weekly_3_lang_id': appType_1.AppType.lang_id,
    'premium_weekly_3_lang_it': appType_1.AppType.lang_it,
    'premium_weekly_3_lang_ja': appType_1.AppType.lang_ja,
    'premium_weekly_3_lang_jp': appType_1.AppType.lang_ja,
    'premium_weekly_3_lang_ko': appType_1.AppType.lang_ko,
    'premium_weekly_3_lang_mi': appType_1.AppType.lang_mi,
    'premium_weekly_3_lang_nl': appType_1.AppType.lang_nl,
    'premium_weekly_3_lang_no': appType_1.AppType.lang_no,
    'premium_weekly_3_lang_pl': appType_1.AppType.lang_pl,
    'premium_weekly_3_lang_pt': appType_1.AppType.lang_pt,
    'premium_weekly_3_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_weekly_3_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_weekly_3_lang_ru': appType_1.AppType.lang_ru,
    'premium_weekly_3_lang_sm': appType_1.AppType.lang_sm,
    'premium_weekly_3_lang_sr': appType_1.AppType.lang_sr,
    'premium_weekly_3_lang_sv': appType_1.AppType.lang_sv,
    'premium_weekly_3_lang_th': appType_1.AppType.lang_th,
    'premium_weekly_3_lang_tl': appType_1.AppType.lang_tl,
    'premium_weekly_3_lang_tr': appType_1.AppType.lang_tr,
    'premium_weekly_3_lang_vi': appType_1.AppType.lang_vi,
    'premium_weekly_3_lang_zh': appType_1.AppType.lang_zh,
    'premium_weekly_3_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_weekly_3_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_weekly_3_local_ar': appType_1.AppType.local_ar,
    'premium_weekly_3_local_hu': appType_1.AppType.local_hu,
    'premium_weekly_3_local_zh': appType_1.AppType.local_zh,
    'premium_weekly_3_scripts': appType_1.AppType.scripts,
    'premium_weekly_3_upopoy': appType_1.AppType.upopoy,
    'premium_weekly_5_bite': appType_1.AppType.bite,
    'premium_weekly_5_droplets': appType_1.AppType.droplets,
    'premium_weekly_5_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_weekly_5_global_eagle': appType_1.AppType.global_eagle,
    'premium_weekly_5_hu': appType_1.AppType.local_hu,
    'premium_weekly_5_int': appType_1.AppType.int,
    'premium_weekly_5_lang_ain': appType_1.AppType.lang_ain,
    'premium_weekly_5_lang_ar': appType_1.AppType.lang_ar,
    'premium_weekly_5_lang_bs': appType_1.AppType.lang_bs,
    'premium_weekly_5_lang_da': appType_1.AppType.lang_da,
    'premium_weekly_5_lang_de': appType_1.AppType.lang_de,
    'premium_weekly_5_lang_el': appType_1.AppType.lang_el,
    'premium_weekly_5_lang_en': appType_1.AppType.lang_en,
    'premium_weekly_5_lang_en2': appType_1.AppType.lang_enus,
    'premium_weekly_5_lang_enus1': appType_1.AppType.lang_enus,
    'premium_weekly_5_lang_eo': appType_1.AppType.lang_eo,
    'premium_weekly_5_lang_es': appType_1.AppType.lang_es,
    'premium_weekly_5_lang_es2': appType_1.AppType.lang_esmx,
    'premium_weekly_5_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_weekly_5_lang_et': appType_1.AppType.lang_et,
    'premium_weekly_5_lang_fa': appType_1.AppType.lang_fa,
    'premium_weekly_5_lang_fi': appType_1.AppType.lang_fi,
    'premium_weekly_5_lang_fr': appType_1.AppType.lang_fr,
    'premium_weekly_5_lang_haw': appType_1.AppType.lang_haw,
    'premium_weekly_5_lang_he': appType_1.AppType.lang_he,
    'premium_weekly_5_lang_hi': appType_1.AppType.lang_hi,
    'premium_weekly_5_lang_hr': appType_1.AppType.lang_hr,
    'premium_weekly_5_lang_hu': appType_1.AppType.lang_hu,
    'premium_weekly_5_lang_ic': appType_1.AppType.lang_ic,
    'premium_weekly_5_lang_id': appType_1.AppType.lang_id,
    'premium_weekly_5_lang_it': appType_1.AppType.lang_it,
    'premium_weekly_5_lang_ja': appType_1.AppType.lang_ja,
    'premium_weekly_5_lang_jp': appType_1.AppType.lang_ja,
    'premium_weekly_5_lang_ko': appType_1.AppType.lang_ko,
    'premium_weekly_5_lang_mi': appType_1.AppType.lang_mi,
    'premium_weekly_5_lang_nl': appType_1.AppType.lang_nl,
    'premium_weekly_5_lang_no': appType_1.AppType.lang_no,
    'premium_weekly_5_lang_pl': appType_1.AppType.lang_pl,
    'premium_weekly_5_lang_pt': appType_1.AppType.lang_pt,
    'premium_weekly_5_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_weekly_5_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_weekly_5_lang_ru': appType_1.AppType.lang_ru,
    'premium_weekly_5_lang_sm': appType_1.AppType.lang_sm,
    'premium_weekly_5_lang_sr': appType_1.AppType.lang_sr,
    'premium_weekly_5_lang_sv': appType_1.AppType.lang_sv,
    'premium_weekly_5_lang_th': appType_1.AppType.lang_th,
    'premium_weekly_5_lang_tl': appType_1.AppType.lang_tl,
    'premium_weekly_5_lang_tr': appType_1.AppType.lang_tr,
    'premium_weekly_5_lang_vi': appType_1.AppType.lang_vi,
    'premium_weekly_5_lang_zh': appType_1.AppType.lang_zh,
    'premium_weekly_5_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_weekly_5_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_weekly_5_local_ar': appType_1.AppType.local_ar,
    'premium_weekly_5_local_hu': appType_1.AppType.local_hu,
    'premium_weekly_5_local_zh': appType_1.AppType.local_zh,
    'premium_weekly_5_scripts': appType_1.AppType.scripts,
    'premium_weekly_5_upopoy': appType_1.AppType.upopoy,
    'premium_weekly_7_bite': appType_1.AppType.bite,
    'premium_weekly_7_droplets': appType_1.AppType.droplets,
    'premium_weekly_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_weekly_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_weekly_7_hu': appType_1.AppType.local_hu,
    'premium_weekly_7_int': appType_1.AppType.int,
    'premium_weekly_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_weekly_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_weekly_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_weekly_7_lang_da': appType_1.AppType.lang_da,
    'premium_weekly_7_lang_de': appType_1.AppType.lang_de,
    'premium_weekly_7_lang_el': appType_1.AppType.lang_el,
    'premium_weekly_7_lang_en': appType_1.AppType.lang_en,
    'premium_weekly_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_weekly_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_weekly_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_weekly_7_lang_es': appType_1.AppType.lang_es,
    'premium_weekly_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_weekly_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_weekly_7_lang_et': appType_1.AppType.lang_et,
    'premium_weekly_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_weekly_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_weekly_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_weekly_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_weekly_7_lang_he': appType_1.AppType.lang_he,
    'premium_weekly_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_weekly_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_weekly_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_weekly_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_weekly_7_lang_id': appType_1.AppType.lang_id,
    'premium_weekly_7_lang_it': appType_1.AppType.lang_it,
    'premium_weekly_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_weekly_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_weekly_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_weekly_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_weekly_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_weekly_7_lang_no': appType_1.AppType.lang_no,
    'premium_weekly_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_weekly_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_weekly_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_weekly_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_weekly_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_weekly_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_weekly_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_weekly_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_weekly_7_lang_th': appType_1.AppType.lang_th,
    'premium_weekly_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_weekly_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_weekly_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_weekly_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_weekly_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_weekly_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_weekly_7_local_ar': appType_1.AppType.local_ar,
    'premium_weekly_7_local_hu': appType_1.AppType.local_hu,
    'premium_weekly_7_local_zh': appType_1.AppType.local_zh,
    'premium_weekly_7_scripts': appType_1.AppType.scripts,
    'premium_weekly_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_15_bite_v2': appType_1.AppType.bite,
    'premium_yearly_15_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_15_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_15_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_15_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_15_int_v2': appType_1.AppType.int,
    'premium_yearly_15_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_15_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_15_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_15_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_15_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_15_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_15_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_15_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_15_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_15_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_15_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_15_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_15_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_15_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_15_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_15_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_15_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_15_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_15_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_15_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_15_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_15_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_15_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_15_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_15_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_15_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_15_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_15_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_15_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_15_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_15_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_15_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_15_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_15_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_15_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_15_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_15_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_15_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_15_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_15_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_15_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_15_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_15_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_15_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_15_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_15_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_15_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_15_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_15_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_15_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_15_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_25_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_25_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_25_bite_v2': appType_1.AppType.bite,
    'premium_yearly_25_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_25_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_25_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_25_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_25_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_25_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_25_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_25_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_25_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_25_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_25_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_25_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_25_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_25_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_25_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_25_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_25_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_25_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_25_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_25_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_25_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_25_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_25_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_25_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_25_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_25_int_v2': appType_1.AppType.int,
    'premium_yearly_25_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_25_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_25_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_25_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_25_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_25_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_25_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_25_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_25_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_25_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_25_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_25_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_25_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_25_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_25_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_25_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_25_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_25_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_25_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_25_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_25_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_25_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_25_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_25_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_25_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_25_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_25_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_30_bite': appType_1.AppType.bite,
    'premium_yearly_30_droplets': appType_1.AppType.droplets,
    'premium_yearly_30_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_30_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_30_hu': appType_1.AppType.local_hu,
    'premium_yearly_30_int': appType_1.AppType.int,
    'premium_yearly_30_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_30_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_30_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_30_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_30_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_30_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_30_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_30_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_30_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_30_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_30_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_30_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_30_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_30_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_30_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_30_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_30_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_30_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_30_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_30_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_30_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_30_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_30_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_30_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_30_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_30_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_30_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_30_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_30_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_30_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_30_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_30_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_30_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_30_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_30_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_30_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_30_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_30_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_30_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_30_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_30_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_30_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_30_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_30_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_30_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_30_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_30_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_30_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_30_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_30_scripts': appType_1.AppType.scripts,
    'premium_yearly_30_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_35_bite_v2': appType_1.AppType.bite,
    'premium_yearly_35_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_35_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_35_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_35_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_35_int_v2': appType_1.AppType.int,
    'premium_yearly_35_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_35_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_35_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_35_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_35_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_35_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_35_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_35_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_35_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_35_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_35_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_35_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_35_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_35_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_35_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_35_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_35_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_35_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_35_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_35_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_35_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_35_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_35_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_35_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_35_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_35_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_35_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_35_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_35_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_35_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_35_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_35_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_35_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_35_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_35_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_35_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_35_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_35_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_35_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_35_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_35_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_35_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_35_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_35_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_35_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_35_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_35_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_35_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_35_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_35_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_35_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_36_bite': appType_1.AppType.bite,
    'premium_yearly_36_droplets': appType_1.AppType.droplets,
    'premium_yearly_36_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_36_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_36_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_36_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_36_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_36_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_36_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_36_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_36_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_36_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_36_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_36_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_36_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_36_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_36_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_36_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_36_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_36_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_36_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_36_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_36_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_36_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_36_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_36_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_36_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_36_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_36_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_36_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_36_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_36_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_36_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_36_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_36_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_36_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_36_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_36_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_36_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_36_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_36_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_36_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_36_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_36_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_36_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_36_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_36_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_36_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_36_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_36_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_36_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_36_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_36_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_36_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_36_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_36_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_36_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_36_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_36_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_36_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_36_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_36_hu': appType_1.AppType.local_hu,
    'premium_yearly_36_int': appType_1.AppType.int,
    'premium_yearly_36_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_36_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_36_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_36_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_36_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_36_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_36_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_36_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_36_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_36_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_36_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_36_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_36_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_36_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_36_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_36_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_36_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_36_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_36_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_36_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_36_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_36_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_36_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_36_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_36_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_36_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_36_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_36_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_36_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_36_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_36_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_36_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_36_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_36_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_36_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_36_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_36_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_36_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_36_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_36_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_36_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_36_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_36_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_36_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_36_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_36_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_36_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_36_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_36_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_36_scripts': appType_1.AppType.scripts,
    'premium_yearly_36_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_40_bite_v2': appType_1.AppType.bite,
    'premium_yearly_40_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_40_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_40_first_year_15_bite_v2': appType_1.AppType.bite,
    'premium_yearly_40_first_year_15_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_40_first_year_15_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_40_first_year_15_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_40_first_year_15_int_v2': appType_1.AppType.int,
    'premium_yearly_40_first_year_15_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_40_first_year_15_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_40_first_year_15_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_40_first_year_15_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_40_first_year_15_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_40_first_year_15_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_40_first_year_15_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_40_first_year_15_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_40_first_year_15_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_40_first_year_15_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_40_first_year_15_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_40_first_year_15_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_40_first_year_15_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_40_first_year_15_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_40_first_year_15_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_40_first_year_15_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_40_first_year_15_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_40_first_year_15_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_40_first_year_15_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_40_first_year_15_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_40_first_year_15_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_40_first_year_15_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_40_first_year_15_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_40_first_year_15_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_40_first_year_15_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_40_first_year_15_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_40_first_year_15_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_40_first_year_15_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_40_first_year_15_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_40_first_year_15_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_40_first_year_15_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_40_first_year_15_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_40_first_year_15_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_40_first_year_15_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_40_first_year_15_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_40_first_year_15_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_40_first_year_15_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_40_first_year_15_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_40_first_year_15_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_40_first_year_15_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_first_year_15_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_40_first_year_15_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_40_first_year_15_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_40_first_year_15_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_40_first_year_15_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_40_first_year_15_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_40_first_year_30_bite_v2': appType_1.AppType.bite,
    'premium_yearly_40_first_year_30_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_40_first_year_30_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_40_first_year_30_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_40_first_year_30_int_v2': appType_1.AppType.int,
    'premium_yearly_40_first_year_30_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_40_first_year_30_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_40_first_year_30_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_40_first_year_30_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_40_first_year_30_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_40_first_year_30_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_40_first_year_30_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_40_first_year_30_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_40_first_year_30_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_40_first_year_30_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_40_first_year_30_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_40_first_year_30_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_40_first_year_30_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_40_first_year_30_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_40_first_year_30_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_40_first_year_30_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_40_first_year_30_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_40_first_year_30_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_40_first_year_30_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_40_first_year_30_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_40_first_year_30_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_40_first_year_30_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_40_first_year_30_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_40_first_year_30_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_40_first_year_30_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_40_first_year_30_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_40_first_year_30_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_40_first_year_30_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_40_first_year_30_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_40_first_year_30_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_40_first_year_30_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_40_first_year_30_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_40_first_year_30_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_40_first_year_30_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_40_first_year_30_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_40_first_year_30_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_40_first_year_30_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_40_first_year_30_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_40_first_year_30_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_40_first_year_30_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_first_year_30_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_40_first_year_30_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_40_first_year_30_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_40_first_year_30_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_40_first_year_30_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_40_first_year_30_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_40_freetrial_bite_v3': appType_1.AppType.bite,
    'premium_yearly_40_freetrial_droplets_demo_apple_store_v3': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_40_freetrial_droplets_v3': appType_1.AppType.droplets,
    'premium_yearly_40_freetrial_global_eagle_v3': appType_1.AppType.global_eagle,
    'premium_yearly_40_freetrial_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_40_freetrial_int_v3': appType_1.AppType.int,
    'premium_yearly_40_freetrial_lang_ain_v3': appType_1.AppType.lang_ain,
    'premium_yearly_40_freetrial_lang_ar_v3': appType_1.AppType.lang_ar,
    'premium_yearly_40_freetrial_lang_bs_v3': appType_1.AppType.lang_bs,
    'premium_yearly_40_freetrial_lang_da_v3': appType_1.AppType.lang_da,
    'premium_yearly_40_freetrial_lang_de_v3': appType_1.AppType.lang_de,
    'premium_yearly_40_freetrial_lang_el_v3': appType_1.AppType.lang_el,
    'premium_yearly_40_freetrial_lang_en2_v3': appType_1.AppType.lang_enus,
    'premium_yearly_40_freetrial_lang_en_v3': appType_1.AppType.lang_en,
    'premium_yearly_40_freetrial_lang_enus1_v3': appType_1.AppType.lang_enus,
    'premium_yearly_40_freetrial_lang_eo_v3': appType_1.AppType.lang_eo,
    'premium_yearly_40_freetrial_lang_es2_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_40_freetrial_lang_es_v3': appType_1.AppType.lang_es,
    'premium_yearly_40_freetrial_lang_esmx_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_40_freetrial_lang_et_v3': appType_1.AppType.lang_et,
    'premium_yearly_40_freetrial_lang_fa_v3': appType_1.AppType.lang_fa,
    'premium_yearly_40_freetrial_lang_fi_v3': appType_1.AppType.lang_fi,
    'premium_yearly_40_freetrial_lang_fr_v3': appType_1.AppType.lang_fr,
    'premium_yearly_40_freetrial_lang_haw_v3': appType_1.AppType.lang_haw,
    'premium_yearly_40_freetrial_lang_he_v3': appType_1.AppType.lang_he,
    'premium_yearly_40_freetrial_lang_hi_v3': appType_1.AppType.lang_hi,
    'premium_yearly_40_freetrial_lang_hr_v3': appType_1.AppType.lang_hr,
    'premium_yearly_40_freetrial_lang_hu_v3': appType_1.AppType.lang_hu,
    'premium_yearly_40_freetrial_lang_ic_v3': appType_1.AppType.lang_ic,
    'premium_yearly_40_freetrial_lang_id_v3': appType_1.AppType.lang_id,
    'premium_yearly_40_freetrial_lang_it_v3': appType_1.AppType.lang_it,
    'premium_yearly_40_freetrial_lang_ja_v3': appType_1.AppType.lang_ja,
    'premium_yearly_40_freetrial_lang_jp_v3': appType_1.AppType.lang_ja,
    'premium_yearly_40_freetrial_lang_ko_v3': appType_1.AppType.lang_ko,
    'premium_yearly_40_freetrial_lang_mi_v3': appType_1.AppType.lang_mi,
    'premium_yearly_40_freetrial_lang_nl_v3': appType_1.AppType.lang_nl,
    'premium_yearly_40_freetrial_lang_no_v3': appType_1.AppType.lang_no,
    'premium_yearly_40_freetrial_lang_pl_v3': appType_1.AppType.lang_pl,
    'premium_yearly_40_freetrial_lang_pt2_v3': appType_1.AppType.lang_ptbr,
    'premium_yearly_40_freetrial_lang_pt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_40_freetrial_lang_ptpt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_40_freetrial_lang_ru_v3': appType_1.AppType.lang_ru,
    'premium_yearly_40_freetrial_lang_sm_v3': appType_1.AppType.lang_sm,
    'premium_yearly_40_freetrial_lang_sr_v3': appType_1.AppType.lang_sr,
    'premium_yearly_40_freetrial_lang_sv_v3': appType_1.AppType.lang_sv,
    'premium_yearly_40_freetrial_lang_th_v3': appType_1.AppType.lang_th,
    'premium_yearly_40_freetrial_lang_tl_v3': appType_1.AppType.lang_tl,
    'premium_yearly_40_freetrial_lang_tr_v3': appType_1.AppType.lang_tr,
    'premium_yearly_40_freetrial_lang_vi_v3': appType_1.AppType.lang_vi,
    'premium_yearly_40_freetrial_lang_zh2_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_freetrial_lang_zh_v3': appType_1.AppType.lang_zh,
    'premium_yearly_40_freetrial_lang_zhyue_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_freetrial_local_ar_v3': appType_1.AppType.local_ar,
    'premium_yearly_40_freetrial_local_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_40_freetrial_local_zh_v3': appType_1.AppType.local_zh,
    'premium_yearly_40_freetrial_scripts_v3': appType_1.AppType.scripts,
    'premium_yearly_40_freetrial_upopoy_v3': appType_1.AppType.upopoy,
    'premium_yearly_40_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_40_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_40_int_v2': appType_1.AppType.int,
    'premium_yearly_40_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_40_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_40_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_40_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_40_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_40_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_40_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_40_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_40_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_40_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_40_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_40_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_40_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_40_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_40_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_40_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_40_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_40_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_40_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_40_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_40_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_40_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_40_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_40_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_40_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_40_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_40_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_40_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_40_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_40_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_40_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_40_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_40_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_40_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_40_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_40_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_40_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_40_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_40_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_40_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_40_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_40_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_40_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_40_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_40_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_40_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_40_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_40_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_40_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_40_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_42_bite': appType_1.AppType.bite,
    'premium_yearly_42_droplets': appType_1.AppType.droplets,
    'premium_yearly_42_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_42_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_42_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_42_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_42_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_42_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_42_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_42_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_42_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_42_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_42_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_42_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_42_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_42_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_42_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_42_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_42_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_42_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_42_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_42_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_42_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_42_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_42_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_42_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_42_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_42_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_42_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_42_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_42_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_42_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_42_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_42_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_42_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_42_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_42_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_42_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_42_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_42_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_42_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_42_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_42_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_42_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_42_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_42_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_42_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_42_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_42_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_42_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_42_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_42_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_42_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_42_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_42_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_42_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_42_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_42_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_42_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_42_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_42_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_42_hu': appType_1.AppType.local_hu,
    'premium_yearly_42_int': appType_1.AppType.int,
    'premium_yearly_42_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_42_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_42_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_42_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_42_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_42_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_42_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_42_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_42_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_42_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_42_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_42_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_42_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_42_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_42_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_42_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_42_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_42_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_42_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_42_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_42_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_42_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_42_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_42_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_42_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_42_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_42_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_42_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_42_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_42_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_42_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_42_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_42_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_42_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_42_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_42_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_42_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_42_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_42_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_42_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_42_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_42_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_42_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_42_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_42_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_42_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_42_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_42_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_42_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_42_scripts': appType_1.AppType.scripts,
    'premium_yearly_42_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_45_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_45_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_45_bite_v2': appType_1.AppType.bite,
    'premium_yearly_45_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_45_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_45_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_45_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_45_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_45_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_45_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_45_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_45_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_45_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_45_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_45_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_45_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_45_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_45_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_45_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_45_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_45_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_45_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_45_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_45_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_45_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_45_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_45_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_45_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_45_int_v2': appType_1.AppType.int,
    'premium_yearly_45_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_45_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_45_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_45_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_45_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_45_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_45_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_45_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_45_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_45_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_45_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_45_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_45_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_45_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_45_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_45_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_45_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_45_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_45_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_45_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_45_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_45_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_45_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_45_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_45_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_45_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_45_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_48_bite': appType_1.AppType.bite,
    'premium_yearly_48_droplets': appType_1.AppType.droplets,
    'premium_yearly_48_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_48_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_48_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_48_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_48_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_48_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_48_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_48_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_48_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_48_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_48_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_48_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_48_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_48_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_48_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_48_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_48_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_48_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_48_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_48_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_48_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_48_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_48_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_48_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_48_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_48_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_48_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_48_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_48_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_48_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_48_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_48_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_48_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_48_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_48_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_48_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_48_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_48_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_48_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_48_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_48_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_48_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_48_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_48_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_48_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_48_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_48_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_48_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_48_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_48_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_48_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_48_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_48_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_48_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_48_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_48_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_48_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_48_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_48_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_48_hu': appType_1.AppType.local_hu,
    'premium_yearly_48_int': appType_1.AppType.int,
    'premium_yearly_48_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_48_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_48_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_48_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_48_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_48_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_48_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_48_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_48_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_48_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_48_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_48_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_48_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_48_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_48_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_48_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_48_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_48_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_48_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_48_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_48_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_48_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_48_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_48_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_48_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_48_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_48_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_48_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_48_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_48_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_48_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_48_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_48_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_48_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_48_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_48_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_48_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_48_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_48_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_48_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_48_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_48_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_48_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_48_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_48_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_48_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_48_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_48_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_48_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_48_scripts': appType_1.AppType.scripts,
    'premium_yearly_48_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_50_bite_v3': appType_1.AppType.bite,
    'premium_yearly_50_droplets_demo_apple_store_v3': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_50_droplets_v3': appType_1.AppType.droplets,
    'premium_yearly_50_global_eagle_v3': appType_1.AppType.global_eagle,
    'premium_yearly_50_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_50_int_v3': appType_1.AppType.int,
    'premium_yearly_50_lang_ain_v3': appType_1.AppType.lang_ain,
    'premium_yearly_50_lang_ar_v3': appType_1.AppType.lang_ar,
    'premium_yearly_50_lang_bs_v3': appType_1.AppType.lang_bs,
    'premium_yearly_50_lang_da_v3': appType_1.AppType.lang_da,
    'premium_yearly_50_lang_de_v3': appType_1.AppType.lang_de,
    'premium_yearly_50_lang_el_v3': appType_1.AppType.lang_el,
    'premium_yearly_50_lang_en2_v3': appType_1.AppType.lang_enus,
    'premium_yearly_50_lang_en_v3': appType_1.AppType.lang_en,
    'premium_yearly_50_lang_enus1_v3': appType_1.AppType.lang_enus,
    'premium_yearly_50_lang_eo_v3': appType_1.AppType.lang_eo,
    'premium_yearly_50_lang_es2_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_50_lang_es_v3': appType_1.AppType.lang_es,
    'premium_yearly_50_lang_esmx_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_50_lang_et_v3': appType_1.AppType.lang_et,
    'premium_yearly_50_lang_fa_v3': appType_1.AppType.lang_fa,
    'premium_yearly_50_lang_fi_v3': appType_1.AppType.lang_fi,
    'premium_yearly_50_lang_fr_v3': appType_1.AppType.lang_fr,
    'premium_yearly_50_lang_haw_v3': appType_1.AppType.lang_haw,
    'premium_yearly_50_lang_he_v3': appType_1.AppType.lang_he,
    'premium_yearly_50_lang_hi_v3': appType_1.AppType.lang_hi,
    'premium_yearly_50_lang_hr_v3': appType_1.AppType.lang_hr,
    'premium_yearly_50_lang_hu_v3': appType_1.AppType.lang_hu,
    'premium_yearly_50_lang_ic_v3': appType_1.AppType.lang_ic,
    'premium_yearly_50_lang_id_v3': appType_1.AppType.lang_id,
    'premium_yearly_50_lang_it_v3': appType_1.AppType.lang_it,
    'premium_yearly_50_lang_ja_v3': appType_1.AppType.lang_ja,
    'premium_yearly_50_lang_jp_v3': appType_1.AppType.lang_ja,
    'premium_yearly_50_lang_ko_v3': appType_1.AppType.lang_ko,
    'premium_yearly_50_lang_mi_v3': appType_1.AppType.lang_mi,
    'premium_yearly_50_lang_nl_v3': appType_1.AppType.lang_nl,
    'premium_yearly_50_lang_no_v3': appType_1.AppType.lang_no,
    'premium_yearly_50_lang_pl_v3': appType_1.AppType.lang_pl,
    'premium_yearly_50_lang_pt2_v3': appType_1.AppType.lang_ptbr,
    'premium_yearly_50_lang_pt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_50_lang_ptpt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_50_lang_ru_v3': appType_1.AppType.lang_ru,
    'premium_yearly_50_lang_sm_v3': appType_1.AppType.lang_sm,
    'premium_yearly_50_lang_sr_v3': appType_1.AppType.lang_sr,
    'premium_yearly_50_lang_sv_v3': appType_1.AppType.lang_sv,
    'premium_yearly_50_lang_th_v3': appType_1.AppType.lang_th,
    'premium_yearly_50_lang_tl_v3': appType_1.AppType.lang_tl,
    'premium_yearly_50_lang_tr_v3': appType_1.AppType.lang_tr,
    'premium_yearly_50_lang_vi_v3': appType_1.AppType.lang_vi,
    'premium_yearly_50_lang_zh2_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_50_lang_zh_v3': appType_1.AppType.lang_zh,
    'premium_yearly_50_lang_zhyue_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_50_local_ar_v3': appType_1.AppType.local_ar,
    'premium_yearly_50_local_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_50_local_zh_v3': appType_1.AppType.local_zh,
    'premium_yearly_50_scripts_v3': appType_1.AppType.scripts,
    'premium_yearly_50_upopoy_v3': appType_1.AppType.upopoy,
    'premium_yearly_54_bite': appType_1.AppType.bite,
    'premium_yearly_54_droplets': appType_1.AppType.droplets,
    'premium_yearly_54_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_54_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_54_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_54_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_54_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_54_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_54_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_54_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_54_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_54_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_54_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_54_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_54_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_54_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_54_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_54_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_54_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_54_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_54_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_54_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_54_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_54_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_54_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_54_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_54_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_54_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_54_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_54_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_54_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_54_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_54_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_54_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_54_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_54_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_54_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_54_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_54_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_54_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_54_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_54_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_54_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_54_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_54_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_54_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_54_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_54_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_54_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_54_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_54_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_54_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_54_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_54_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_54_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_54_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_54_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_54_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_54_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_54_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_54_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_54_hu': appType_1.AppType.local_hu,
    'premium_yearly_54_int': appType_1.AppType.int,
    'premium_yearly_54_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_54_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_54_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_54_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_54_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_54_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_54_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_54_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_54_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_54_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_54_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_54_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_54_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_54_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_54_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_54_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_54_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_54_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_54_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_54_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_54_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_54_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_54_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_54_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_54_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_54_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_54_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_54_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_54_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_54_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_54_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_54_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_54_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_54_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_54_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_54_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_54_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_54_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_54_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_54_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_54_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_54_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_54_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_54_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_54_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_54_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_54_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_54_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_54_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_54_scripts': appType_1.AppType.scripts,
    'premium_yearly_54_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_55_bite_v3': appType_1.AppType.bite,
    'premium_yearly_55_droplets_demo_apple_store_v3': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_55_droplets_v3': appType_1.AppType.droplets,
    'premium_yearly_55_global_eagle_v3': appType_1.AppType.global_eagle,
    'premium_yearly_55_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_55_int_v3': appType_1.AppType.int,
    'premium_yearly_55_lang_ain_v3': appType_1.AppType.lang_ain,
    'premium_yearly_55_lang_ar_v3': appType_1.AppType.lang_ar,
    'premium_yearly_55_lang_bs_v3': appType_1.AppType.lang_bs,
    'premium_yearly_55_lang_da_v3': appType_1.AppType.lang_da,
    'premium_yearly_55_lang_de_v3': appType_1.AppType.lang_de,
    'premium_yearly_55_lang_el_v3': appType_1.AppType.lang_el,
    'premium_yearly_55_lang_en2_v3': appType_1.AppType.lang_enus,
    'premium_yearly_55_lang_en_v3': appType_1.AppType.lang_en,
    'premium_yearly_55_lang_enus1_v3': appType_1.AppType.lang_enus,
    'premium_yearly_55_lang_eo_v3': appType_1.AppType.lang_eo,
    'premium_yearly_55_lang_es2_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_55_lang_es_v3': appType_1.AppType.lang_es,
    'premium_yearly_55_lang_esmx_v3': appType_1.AppType.lang_esmx,
    'premium_yearly_55_lang_et_v3': appType_1.AppType.lang_et,
    'premium_yearly_55_lang_fa_v3': appType_1.AppType.lang_fa,
    'premium_yearly_55_lang_fi_v3': appType_1.AppType.lang_fi,
    'premium_yearly_55_lang_fr_v3': appType_1.AppType.lang_fr,
    'premium_yearly_55_lang_haw_v3': appType_1.AppType.lang_haw,
    'premium_yearly_55_lang_he_v3': appType_1.AppType.lang_he,
    'premium_yearly_55_lang_hi_v3': appType_1.AppType.lang_hi,
    'premium_yearly_55_lang_hr_v3': appType_1.AppType.lang_hr,
    'premium_yearly_55_lang_hu_v3': appType_1.AppType.lang_hu,
    'premium_yearly_55_lang_ic_v3': appType_1.AppType.lang_ic,
    'premium_yearly_55_lang_id_v3': appType_1.AppType.lang_id,
    'premium_yearly_55_lang_it_v3': appType_1.AppType.lang_it,
    'premium_yearly_55_lang_ja_v3': appType_1.AppType.lang_ja,
    'premium_yearly_55_lang_jp_v3': appType_1.AppType.lang_ja,
    'premium_yearly_55_lang_ko_v3': appType_1.AppType.lang_ko,
    'premium_yearly_55_lang_mi_v3': appType_1.AppType.lang_mi,
    'premium_yearly_55_lang_nl_v3': appType_1.AppType.lang_nl,
    'premium_yearly_55_lang_no_v3': appType_1.AppType.lang_no,
    'premium_yearly_55_lang_pl_v3': appType_1.AppType.lang_pl,
    'premium_yearly_55_lang_pt2_v3': appType_1.AppType.lang_ptbr,
    'premium_yearly_55_lang_pt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_55_lang_ptpt_v3': appType_1.AppType.lang_pt,
    'premium_yearly_55_lang_ru_v3': appType_1.AppType.lang_ru,
    'premium_yearly_55_lang_sm_v3': appType_1.AppType.lang_sm,
    'premium_yearly_55_lang_sr_v3': appType_1.AppType.lang_sr,
    'premium_yearly_55_lang_sv_v3': appType_1.AppType.lang_sv,
    'premium_yearly_55_lang_th_v3': appType_1.AppType.lang_th,
    'premium_yearly_55_lang_tl_v3': appType_1.AppType.lang_tl,
    'premium_yearly_55_lang_tr_v3': appType_1.AppType.lang_tr,
    'premium_yearly_55_lang_vi_v3': appType_1.AppType.lang_vi,
    'premium_yearly_55_lang_zh2_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_55_lang_zh_v3': appType_1.AppType.lang_zh,
    'premium_yearly_55_lang_zhyue_v3': appType_1.AppType.lang_zhyue,
    'premium_yearly_55_local_ar_v3': appType_1.AppType.local_ar,
    'premium_yearly_55_local_hu_v3': appType_1.AppType.local_hu,
    'premium_yearly_55_local_zh_v3': appType_1.AppType.local_zh,
    'premium_yearly_55_scripts_v3': appType_1.AppType.scripts,
    'premium_yearly_55_upopoy_v3': appType_1.AppType.upopoy,
    'premium_yearly_56_bite': appType_1.AppType.bite,
    'premium_yearly_56_droplets': appType_1.AppType.droplets,
    'premium_yearly_56_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_56_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_56_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_56_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_56_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_56_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_56_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_56_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_56_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_56_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_56_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_56_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_56_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_56_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_56_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_56_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_56_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_56_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_56_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_56_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_56_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_56_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_56_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_56_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_56_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_56_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_56_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_56_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_56_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_56_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_56_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_56_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_56_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_56_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_56_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_56_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_56_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_56_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_56_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_56_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_56_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_56_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_56_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_56_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_56_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_56_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_56_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_56_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_56_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_56_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_56_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_56_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_56_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_56_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_56_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_56_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_56_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_56_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_56_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_56_hu': appType_1.AppType.local_hu,
    'premium_yearly_56_int': appType_1.AppType.int,
    'premium_yearly_56_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_56_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_56_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_56_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_56_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_56_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_56_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_56_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_56_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_56_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_56_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_56_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_56_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_56_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_56_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_56_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_56_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_56_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_56_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_56_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_56_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_56_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_56_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_56_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_56_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_56_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_56_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_56_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_56_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_56_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_56_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_56_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_56_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_56_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_56_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_56_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_56_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_56_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_56_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_56_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_56_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_56_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_56_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_56_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_56_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_56_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_56_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_56_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_56_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_56_scripts': appType_1.AppType.scripts,
    'premium_yearly_56_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_60_bite': appType_1.AppType.bite,
    'premium_yearly_60_droplets': appType_1.AppType.droplets,
    'premium_yearly_60_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_60_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_60_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_60_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_60_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_60_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_60_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_60_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_60_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_60_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_60_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_60_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_60_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_60_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_60_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_60_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_60_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_60_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_60_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_60_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_60_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_60_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_60_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_60_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_60_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_60_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_60_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_60_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_60_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_60_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_60_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_60_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_60_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_60_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_60_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_60_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_60_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_60_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_60_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_60_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_60_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_60_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_60_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_60_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_60_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_60_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_60_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_60_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_60_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_60_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_60_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_60_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_60_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_60_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_60_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_60_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_60_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_60_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_60_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_60_hu': appType_1.AppType.local_hu,
    'premium_yearly_60_int': appType_1.AppType.int,
    'premium_yearly_60_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_60_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_60_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_60_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_60_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_60_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_60_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_60_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_60_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_60_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_60_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_60_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_60_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_60_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_60_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_60_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_60_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_60_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_60_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_60_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_60_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_60_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_60_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_60_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_60_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_60_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_60_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_60_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_60_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_60_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_60_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_60_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_60_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_60_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_60_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_60_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_60_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_60_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_60_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_60_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_60_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_60_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_60_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_60_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_60_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_60_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_60_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_60_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_60_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_60_scripts': appType_1.AppType.scripts,
    'premium_yearly_60_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_64_bite': appType_1.AppType.bite,
    'premium_yearly_64_droplets': appType_1.AppType.droplets,
    'premium_yearly_64_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_64_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_64_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_64_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_64_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_64_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_64_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_64_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_64_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_64_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_64_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_64_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_64_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_64_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_64_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_64_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_64_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_64_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_64_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_64_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_64_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_64_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_64_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_64_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_64_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_64_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_64_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_64_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_64_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_64_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_64_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_64_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_64_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_64_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_64_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_64_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_64_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_64_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_64_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_64_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_64_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_64_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_64_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_64_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_64_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_64_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_64_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_64_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_64_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_64_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_64_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_64_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_64_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_64_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_64_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_64_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_64_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_64_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_64_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_64_hu': appType_1.AppType.local_hu,
    'premium_yearly_64_int': appType_1.AppType.int,
    'premium_yearly_64_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_64_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_64_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_64_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_64_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_64_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_64_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_64_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_64_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_64_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_64_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_64_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_64_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_64_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_64_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_64_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_64_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_64_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_64_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_64_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_64_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_64_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_64_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_64_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_64_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_64_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_64_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_64_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_64_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_64_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_64_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_64_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_64_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_64_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_64_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_64_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_64_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_64_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_64_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_64_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_64_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_64_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_64_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_64_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_64_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_64_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_64_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_64_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_64_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_64_scripts': appType_1.AppType.scripts,
    'premium_yearly_64_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_70_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_70_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_70_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_70_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_70_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_70_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_70_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_70_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_70_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_70_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_70_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_70_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_70_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_70_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_70_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_70_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_70_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_70_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_70_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_70_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_70_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_70_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_70_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_70_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_70_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_70_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_70_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_70_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_70_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_70_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_70_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_70_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_70_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_70_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_70_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_70_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_70_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_70_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_70_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_70_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_70_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_70_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_70_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_70_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_70_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_70_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_70_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_70_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_70_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_70_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_70_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_70_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_14days_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_14days_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_14days_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_14days_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_14days_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_14days_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_14days_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_14days_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_14days_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_14days_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_14days_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_14days_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_14days_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_14days_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_14days_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_14days_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_14days_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_14days_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_14days_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_14days_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_14days_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_14days_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_14days_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_14days_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_14days_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_14days_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_14days_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_14days_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_14days_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_14days_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_14days_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_14days_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_14days_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_14days_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_14days_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_14days_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_14days_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_14days_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_14days_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_14days_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_14days_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_14days_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_14days_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_14days_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_14days_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_14days_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_14days_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_14days_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_14days_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_14days_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_14days_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_14days_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_14days_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_14days_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_14days_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_14days_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_14days_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_3days_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_3days_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_3days_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_3days_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_3days_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_3days_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_3days_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_3days_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_3days_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_3days_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_3days_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_3days_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_3days_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_3days_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_3days_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_3days_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_3days_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_3days_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_3days_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_3days_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_3days_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_3days_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_3days_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_3days_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_3days_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_3days_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_3days_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_3days_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_3days_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_3days_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_3days_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_3days_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_3days_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_3days_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_3days_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_3days_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_3days_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_3days_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_3days_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_3days_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_3days_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_3days_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_3days_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_3days_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_3days_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_3days_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_3days_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_3days_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_3days_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_3days_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_3days_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_3days_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_3days_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_3days_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_3days_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_3days_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_3days_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ain_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ain_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ain_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ain_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ain_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ain_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ain_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ain_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ain_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ain_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ain_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ain_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ain_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ain_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ain_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ain_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ain_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ain_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ain_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ain_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ain_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ain_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ain_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ain_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ain_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ain_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ain_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ain_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ain_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ain_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ain_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ain_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ain_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ain_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ain_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ain_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ain_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ain_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ain_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ain_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ain_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ain_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ain_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ain_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ain_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ain_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ain_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ain_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ain_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ain_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ain_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ain_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ain_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ain_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ain_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ain_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ain_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ar_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ar_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ar_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ar_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ar_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ar_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ar_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ar_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ar_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ar_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ar_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ar_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ar_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ar_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ar_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ar_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ar_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ar_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ar_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ar_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ar_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ar_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ar_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ar_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ar_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ar_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ar_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ar_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ar_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ar_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ar_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ar_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ar_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ar_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ar_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ar_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ar_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ar_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ar_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ar_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ar_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ar_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ar_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ar_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ar_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ar_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ar_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ar_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ar_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ar_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ar_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ar_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ar_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ar_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ar_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ar_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ar_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ase_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ase_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ase_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ase_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ase_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ase_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ase_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ase_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ase_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ase_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ase_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ase_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ase_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ase_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ase_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ase_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ase_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ase_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ase_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ase_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ase_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ase_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ase_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ase_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ase_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ase_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ase_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ase_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ase_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ase_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ase_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ase_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ase_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ase_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ase_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ase_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ase_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ase_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ase_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ase_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ase_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ase_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ase_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ase_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ase_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ase_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ase_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ase_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ase_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ase_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ase_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ase_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ase_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ase_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ase_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ase_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ase_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_bs_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_bs_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_bs_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_bs_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_bs_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_bs_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_bs_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_bs_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_bs_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_bs_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_bs_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_bs_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_bs_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_bs_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_bs_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_bs_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_bs_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_bs_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_bs_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_bs_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_bs_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_bs_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_bs_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_bs_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_bs_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_bs_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_bs_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_bs_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_bs_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_bs_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_bs_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_bs_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_bs_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_bs_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_bs_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_bs_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_bs_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_bs_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_bs_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_bs_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_bs_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_bs_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_bs_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_bs_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_bs_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_bs_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_bs_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_bs_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_bs_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_bs_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_bs_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_bs_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_bs_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_bs_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_bs_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_bs_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_bs_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_cat_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_cat_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_cat_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_cat_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_cat_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_cat_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_cat_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_cat_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_cat_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_cat_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_cat_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_cat_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_cat_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_cat_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_cat_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_cat_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_cat_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_cat_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_cat_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_cat_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_cat_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_cat_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_cat_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_cat_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_cat_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_cat_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_cat_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_cat_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_cat_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_cat_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_cat_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_cat_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_cat_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_cat_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_cat_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_cat_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_cat_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_cat_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_cat_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_cat_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_cat_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_cat_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_cat_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_cat_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_cat_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_cat_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_cat_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_cat_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_cat_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_cat_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_cat_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_cat_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_cat_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_cat_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_cat_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_cat_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_cat_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_da_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_da_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_da_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_da_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_da_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_da_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_da_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_da_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_da_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_da_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_da_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_da_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_da_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_da_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_da_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_da_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_da_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_da_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_da_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_da_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_da_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_da_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_da_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_da_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_da_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_da_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_da_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_da_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_da_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_da_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_da_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_da_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_da_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_da_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_da_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_da_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_da_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_da_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_da_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_da_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_da_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_da_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_da_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_da_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_da_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_da_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_da_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_da_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_da_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_da_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_da_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_da_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_da_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_da_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_da_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_da_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_da_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_de_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_de_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_de_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_de_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_de_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_de_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_de_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_de_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_de_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_de_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_de_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_de_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_de_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_de_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_de_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_de_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_de_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_de_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_de_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_de_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_de_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_de_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_de_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_de_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_de_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_de_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_de_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_de_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_de_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_de_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_de_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_de_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_de_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_de_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_de_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_de_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_de_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_de_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_de_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_de_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_de_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_de_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_de_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_de_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_de_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_de_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_de_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_de_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_de_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_de_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_de_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_de_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_de_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_de_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_de_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_de_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_de_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_el_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_el_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_el_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_el_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_el_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_el_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_el_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_el_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_el_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_el_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_el_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_el_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_el_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_el_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_el_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_el_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_el_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_el_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_el_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_el_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_el_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_el_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_el_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_el_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_el_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_el_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_el_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_el_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_el_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_el_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_el_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_el_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_el_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_el_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_el_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_el_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_el_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_el_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_el_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_el_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_el_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_el_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_el_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_el_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_el_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_el_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_el_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_el_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_el_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_el_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_el_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_el_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_el_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_el_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_el_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_el_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_el_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_en_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_en_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_en_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_en_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_en_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_en_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_en_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_en_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_en_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_en_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_en_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_en_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_en_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_en_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_en_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_en_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_en_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_en_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_en_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_en_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_en_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_en_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_en_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_en_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_en_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_en_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_en_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_en_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_en_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_en_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_en_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_en_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_en_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_en_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_en_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_en_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_en_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_en_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_en_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_en_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_en_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_en_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_en_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_en_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_en_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_en_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_en_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_en_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_en_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_en_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_en_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_en_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_en_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_en_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_en_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_en_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_en_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_engb_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_engb_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_engb_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_engb_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_engb_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_engb_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_engb_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_engb_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_engb_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_engb_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_engb_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_engb_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_engb_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_engb_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_engb_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_engb_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_engb_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_engb_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_engb_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_engb_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_engb_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_engb_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_engb_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_engb_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_engb_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_engb_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_engb_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_engb_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_engb_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_engb_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_engb_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_engb_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_engb_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_engb_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_engb_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_engb_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_engb_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_engb_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_engb_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_engb_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_engb_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_engb_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_engb_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_engb_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_engb_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_engb_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_engb_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_engb_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_engb_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_engb_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_engb_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_engb_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_engb_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_engb_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_engb_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_engb_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_engb_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_eo_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_eo_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_eo_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_eo_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_eo_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_eo_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_eo_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_eo_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_eo_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_eo_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_eo_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_eo_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_eo_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_eo_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_eo_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_eo_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_eo_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_eo_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_eo_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_eo_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_eo_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_eo_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_eo_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_eo_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_eo_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_eo_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_eo_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_eo_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_eo_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_eo_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_eo_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_eo_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_eo_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_eo_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_eo_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_eo_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_eo_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_eo_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_eo_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_eo_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_eo_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_eo_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_eo_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_eo_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_eo_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_eo_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_eo_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_eo_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_eo_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_eo_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_eo_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_eo_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_eo_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_eo_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_eo_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_eo_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_eo_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_es_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_es_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_es_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_es_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_es_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_es_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_es_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_es_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_es_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_es_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_es_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_es_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_es_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_es_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_es_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_es_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_es_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_es_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_es_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_es_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_es_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_es_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_es_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_es_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_es_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_es_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_es_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_es_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_es_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_es_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_es_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_es_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_es_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_es_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_es_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_es_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_es_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_es_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_es_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_es_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_es_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_es_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_es_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_es_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_es_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_es_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_es_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_es_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_es_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_es_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_es_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_es_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_es_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_es_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_es_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_es_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_es_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_esmx_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_esmx_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_esmx_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_esmx_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_esmx_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_esmx_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_esmx_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_esmx_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_esmx_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_esmx_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_esmx_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_esmx_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_esmx_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_esmx_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_esmx_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_esmx_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_esmx_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_esmx_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_esmx_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_esmx_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_esmx_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_esmx_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_esmx_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_esmx_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_esmx_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_esmx_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_esmx_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_esmx_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_esmx_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_esmx_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_esmx_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_esmx_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_esmx_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_esmx_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_esmx_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_esmx_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_esmx_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_esmx_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_esmx_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_esmx_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_esmx_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_esmx_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_esmx_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_esmx_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_esmx_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_esmx_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_esmx_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_esmx_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_esmx_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_esmx_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_esmx_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_esmx_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_esmx_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_esmx_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_esmx_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_esmx_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_esmx_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_et_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_et_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_et_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_et_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_et_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_et_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_et_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_et_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_et_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_et_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_et_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_et_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_et_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_et_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_et_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_et_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_et_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_et_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_et_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_et_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_et_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_et_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_et_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_et_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_et_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_et_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_et_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_et_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_et_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_et_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_et_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_et_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_et_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_et_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_et_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_et_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_et_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_et_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_et_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_et_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_et_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_et_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_et_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_et_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_et_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_et_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_et_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_et_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_et_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_et_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_et_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_et_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_et_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_et_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_et_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_et_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_et_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_fa_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_fa_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_fa_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_fa_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_fa_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fa_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_fa_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_fa_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_fa_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_fa_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_fa_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_fa_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_fa_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fa_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_fa_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fa_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_fa_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fa_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_fa_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fa_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_fa_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_fa_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_fa_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_fa_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_fa_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_fa_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_fa_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_fa_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_fa_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_fa_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_fa_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_fa_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fa_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fa_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_fa_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_fa_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_fa_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_fa_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_fa_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_fa_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fa_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fa_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_fa_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_fa_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_fa_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_fa_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_fa_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_fa_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_fa_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_fa_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fa_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_fa_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fa_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_fa_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fa_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_fa_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_fa_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_fi_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_fi_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_fi_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_fi_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_fi_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fi_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_fi_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_fi_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_fi_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_fi_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_fi_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_fi_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_fi_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fi_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_fi_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fi_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_fi_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fi_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_fi_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fi_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_fi_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_fi_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_fi_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_fi_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_fi_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_fi_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_fi_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_fi_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_fi_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_fi_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_fi_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_fi_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fi_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fi_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_fi_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_fi_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_fi_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_fi_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_fi_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_fi_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fi_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fi_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_fi_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_fi_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_fi_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_fi_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_fi_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_fi_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_fi_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_fi_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fi_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_fi_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fi_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_fi_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fi_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_fi_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_fi_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_fr_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_fr_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_fr_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_fr_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_fr_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fr_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_fr_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_fr_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_fr_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_fr_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_fr_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_fr_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_fr_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fr_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_fr_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_fr_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_fr_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fr_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_fr_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_fr_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_fr_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_fr_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_fr_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_fr_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_fr_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_fr_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_fr_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_fr_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_fr_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_fr_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_fr_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_fr_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fr_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_fr_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_fr_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_fr_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_fr_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_fr_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_fr_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_fr_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fr_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_fr_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_fr_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_fr_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_fr_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_fr_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_fr_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_fr_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_fr_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_fr_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fr_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_fr_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_fr_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_fr_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_fr_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_fr_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_fr_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_gle_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_gle_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_gle_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_gle_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_gle_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_gle_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_gle_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_gle_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_gle_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_gle_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_gle_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_gle_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_gle_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_gle_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_gle_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_gle_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_gle_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_gle_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_gle_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_gle_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_gle_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_gle_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_gle_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_gle_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_gle_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_gle_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_gle_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_gle_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_gle_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_gle_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_gle_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_gle_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_gle_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_gle_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_gle_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_gle_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_gle_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_gle_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_gle_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_gle_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_gle_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_gle_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_gle_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_gle_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_gle_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_gle_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_gle_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_gle_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_gle_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_gle_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_gle_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_gle_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_gle_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_gle_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_gle_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_gle_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_gle_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_glg_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_glg_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_glg_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_glg_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_glg_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_glg_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_glg_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_glg_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_glg_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_glg_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_glg_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_glg_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_glg_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_glg_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_glg_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_glg_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_glg_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_glg_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_glg_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_glg_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_glg_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_glg_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_glg_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_glg_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_glg_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_glg_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_glg_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_glg_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_glg_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_glg_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_glg_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_glg_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_glg_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_glg_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_glg_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_glg_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_glg_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_glg_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_glg_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_glg_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_glg_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_glg_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_glg_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_glg_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_glg_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_glg_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_glg_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_glg_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_glg_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_glg_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_glg_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_glg_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_glg_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_glg_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_glg_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_glg_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_glg_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_haw_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_haw_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_haw_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_haw_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_haw_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_haw_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_haw_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_haw_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_haw_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_haw_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_haw_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_haw_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_haw_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_haw_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_haw_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_haw_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_haw_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_haw_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_haw_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_haw_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_haw_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_haw_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_haw_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_haw_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_haw_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_haw_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_haw_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_haw_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_haw_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_haw_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_haw_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_haw_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_haw_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_haw_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_haw_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_haw_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_haw_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_haw_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_haw_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_haw_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_haw_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_haw_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_haw_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_haw_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_haw_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_haw_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_haw_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_haw_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_haw_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_haw_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_haw_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_haw_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_haw_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_haw_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_haw_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_haw_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_haw_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_he_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_he_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_he_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_he_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_he_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_he_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_he_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_he_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_he_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_he_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_he_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_he_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_he_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_he_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_he_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_he_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_he_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_he_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_he_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_he_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_he_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_he_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_he_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_he_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_he_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_he_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_he_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_he_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_he_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_he_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_he_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_he_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_he_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_he_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_he_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_he_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_he_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_he_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_he_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_he_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_he_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_he_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_he_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_he_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_he_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_he_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_he_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_he_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_he_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_he_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_he_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_he_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_he_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_he_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_he_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_he_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_he_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_hi_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_hi_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_hi_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_hi_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_hi_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hi_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_hi_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_hi_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_hi_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_hi_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_hi_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_hi_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_hi_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hi_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_hi_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hi_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_hi_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hi_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_hi_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hi_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_hi_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_hi_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_hi_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_hi_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_hi_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_hi_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_hi_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_hi_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_hi_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_hi_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_hi_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_hi_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hi_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hi_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_hi_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_hi_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_hi_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_hi_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_hi_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_hi_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hi_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hi_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_hi_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_hi_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_hi_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_hi_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_hi_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_hi_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_hi_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_hi_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hi_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_hi_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hi_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_hi_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hi_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_hi_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_hi_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_hr_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_hr_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_hr_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_hr_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_hr_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hr_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_hr_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_hr_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_hr_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_hr_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_hr_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_hr_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_hr_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hr_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_hr_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hr_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_hr_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hr_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_hr_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hr_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_hr_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_hr_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_hr_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_hr_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_hr_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_hr_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_hr_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_hr_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_hr_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_hr_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_hr_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_hr_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hr_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hr_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_hr_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_hr_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_hr_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_hr_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_hr_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_hr_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hr_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hr_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_hr_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_hr_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_hr_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_hr_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_hr_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_hr_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_hr_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_hr_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hr_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_hr_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hr_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_hr_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hr_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_hr_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_hr_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_hu_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_hu_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_hu_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_hu_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_hu_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hu_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_hu_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_hu_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_hu_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_hu_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_hu_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_hu_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_hu_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hu_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_hu_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_hu_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_hu_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hu_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_hu_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_hu_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_hu_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_hu_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_hu_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_hu_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_hu_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_hu_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_hu_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_hu_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_hu_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_hu_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_hu_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_hu_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hu_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_hu_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_hu_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_hu_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_hu_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_hu_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_hu_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_hu_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hu_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_hu_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_hu_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_hu_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_hu_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_hu_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_hu_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_hu_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_hu_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_hu_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hu_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_hu_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_hu_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_hu_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_hu_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_hu_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_hu_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ic_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ic_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ic_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ic_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ic_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ic_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ic_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ic_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ic_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ic_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ic_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ic_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ic_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ic_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ic_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ic_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ic_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ic_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ic_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ic_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ic_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ic_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ic_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ic_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ic_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ic_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ic_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ic_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ic_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ic_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ic_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ic_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ic_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ic_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ic_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ic_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ic_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ic_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ic_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ic_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ic_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ic_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ic_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ic_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ic_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ic_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ic_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ic_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ic_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ic_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ic_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ic_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ic_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ic_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ic_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ic_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ic_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_id_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_id_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_id_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_id_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_id_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_id_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_id_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_id_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_id_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_id_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_id_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_id_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_id_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_id_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_id_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_id_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_id_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_id_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_id_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_id_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_id_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_id_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_id_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_id_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_id_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_id_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_id_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_id_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_id_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_id_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_id_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_id_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_id_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_id_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_id_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_id_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_id_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_id_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_id_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_id_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_id_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_id_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_id_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_id_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_id_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_id_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_id_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_id_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_id_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_id_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_id_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_id_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_id_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_id_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_id_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_id_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_id_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ig_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ig_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ig_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ig_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ig_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ig_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ig_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ig_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ig_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ig_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ig_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ig_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ig_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ig_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ig_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ig_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ig_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ig_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ig_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ig_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ig_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ig_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ig_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ig_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ig_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ig_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ig_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ig_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ig_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ig_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ig_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ig_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ig_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ig_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ig_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ig_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ig_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ig_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ig_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ig_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ig_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ig_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ig_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ig_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ig_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ig_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ig_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ig_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ig_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ig_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ig_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ig_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ig_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ig_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ig_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ig_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ig_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_it_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_it_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_it_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_it_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_it_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_it_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_it_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_it_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_it_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_it_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_it_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_it_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_it_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_it_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_it_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_it_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_it_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_it_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_it_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_it_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_it_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_it_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_it_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_it_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_it_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_it_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_it_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_it_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_it_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_it_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_it_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_it_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_it_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_it_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_it_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_it_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_it_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_it_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_it_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_it_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_it_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_it_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_it_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_it_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_it_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_it_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_it_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_it_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_it_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_it_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_it_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_it_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_it_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_it_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_it_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_it_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_it_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_jp_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_jp_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_jp_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_jp_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_jp_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_jp_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_jp_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_jp_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_jp_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_jp_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_jp_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_jp_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_jp_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_jp_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_jp_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_jp_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_jp_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_jp_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_jp_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_jp_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_jp_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_jp_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_jp_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_jp_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_jp_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_jp_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_jp_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_jp_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_jp_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_jp_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_jp_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_jp_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_jp_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_jp_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_jp_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_jp_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_jp_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_jp_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_jp_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_jp_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_jp_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_jp_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_jp_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_jp_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_jp_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_jp_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_jp_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_jp_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_jp_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_jp_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_jp_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_jp_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_jp_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_jp_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_jp_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_jp_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_jp_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ko_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ko_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ko_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ko_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ko_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ko_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ko_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ko_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ko_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ko_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ko_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ko_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ko_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ko_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ko_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ko_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ko_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ko_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ko_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ko_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ko_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ko_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ko_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ko_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ko_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ko_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ko_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ko_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ko_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ko_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ko_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ko_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ko_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ko_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ko_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ko_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ko_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ko_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ko_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ko_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ko_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ko_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ko_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ko_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ko_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ko_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ko_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ko_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ko_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ko_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ko_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ko_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ko_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ko_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ko_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ko_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ko_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_lang_enus_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_mi_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_mi_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_mi_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_mi_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_mi_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_mi_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_mi_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_mi_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_mi_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_mi_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_mi_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_mi_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_mi_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_mi_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_mi_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_mi_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_mi_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_mi_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_mi_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_mi_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_mi_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_mi_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_mi_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_mi_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_mi_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_mi_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_mi_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_mi_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_mi_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_mi_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_mi_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_mi_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_mi_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_mi_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_mi_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_mi_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_mi_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_mi_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_mi_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_mi_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_mi_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_mi_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_mi_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_mi_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_mi_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_mi_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_mi_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_mi_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_mi_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_mi_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_mi_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_mi_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_mi_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_mi_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_mi_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_mi_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_mi_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_nl_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_nl_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_nl_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_nl_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_nl_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_nl_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_nl_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_nl_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_nl_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_nl_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_nl_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_nl_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_nl_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_nl_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_nl_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_nl_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_nl_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_nl_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_nl_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_nl_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_nl_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_nl_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_nl_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_nl_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_nl_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_nl_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_nl_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_nl_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_nl_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_nl_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_nl_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_nl_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_nl_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_nl_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_nl_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_nl_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_nl_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_nl_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_nl_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_nl_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_nl_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_nl_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_nl_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_nl_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_nl_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_nl_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_nl_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_nl_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_nl_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_nl_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_nl_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_nl_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_nl_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_nl_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_nl_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_nl_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_nl_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_no_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_no_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_no_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_no_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_no_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_no_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_no_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_no_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_no_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_no_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_no_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_no_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_no_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_no_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_no_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_no_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_no_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_no_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_no_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_no_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_no_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_no_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_no_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_no_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_no_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_no_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_no_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_no_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_no_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_no_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_no_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_no_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_no_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_no_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_no_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_no_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_no_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_no_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_no_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_no_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_no_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_no_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_no_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_no_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_no_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_no_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_no_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_no_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_no_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_no_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_no_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_no_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_no_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_no_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_no_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_no_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_no_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_pa_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_pa_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_pa_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_pa_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_pa_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pa_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_pa_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_pa_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_pa_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_pa_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_pa_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_pa_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_pa_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pa_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_pa_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pa_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_pa_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pa_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_pa_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pa_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_pa_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_pa_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_pa_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_pa_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_pa_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_pa_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_pa_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_pa_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_pa_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_pa_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_pa_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_pa_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pa_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pa_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_pa_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_pa_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_pa_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_pa_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_pa_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_pa_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pa_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pa_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_pa_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_pa_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_pa_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_pa_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_pa_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_pa_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_pa_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_pa_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pa_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_pa_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pa_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_pa_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pa_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_pa_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_pa_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_pl_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_pl_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_pl_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_pl_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_pl_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pl_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_pl_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_pl_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_pl_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_pl_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_pl_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_pl_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_pl_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pl_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_pl_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pl_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_pl_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pl_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_pl_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pl_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_pl_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_pl_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_pl_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_pl_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_pl_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_pl_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_pl_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_pl_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_pl_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_pl_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_pl_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_pl_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pl_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pl_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_pl_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_pl_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_pl_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_pl_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_pl_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_pl_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pl_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pl_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_pl_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_pl_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_pl_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_pl_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_pl_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_pl_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_pl_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_pl_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pl_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_pl_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pl_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_pl_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pl_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_pl_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_pl_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_pt_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_pt_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_pt_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_pt_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_pt_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pt_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_pt_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_pt_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_pt_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_pt_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_pt_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_pt_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_pt_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pt_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_pt_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_pt_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_pt_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pt_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_pt_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_pt_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_pt_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_pt_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_pt_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_pt_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_pt_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_pt_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_pt_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_pt_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_pt_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_pt_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_pt_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_pt_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pt_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_pt_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_pt_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_pt_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_pt_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_pt_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_pt_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_pt_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pt_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_pt_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_pt_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_pt_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_pt_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_pt_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_pt_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_pt_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_pt_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_pt_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pt_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_pt_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_pt_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_pt_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_pt_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_pt_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_pt_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ptpt_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ptpt_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ptpt_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ptpt_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ptpt_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ptpt_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ptpt_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ptpt_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ptpt_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ptpt_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ptpt_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ptpt_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ptpt_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ptpt_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ptpt_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ptpt_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ptpt_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ptpt_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ptpt_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ptpt_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ptpt_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ptpt_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ptpt_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ptpt_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ptpt_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ptpt_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ptpt_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ptpt_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ptpt_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ptpt_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ptpt_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ptpt_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ptpt_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ptpt_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ptpt_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ptpt_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ptpt_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ptpt_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ptpt_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ptpt_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ptpt_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ptpt_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ptpt_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ptpt_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ptpt_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ptpt_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ptpt_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ptpt_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ptpt_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ptpt_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ptpt_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ptpt_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ptpt_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ptpt_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ptpt_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ptpt_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ptpt_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ro_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ro_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ro_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ro_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ro_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ro_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ro_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ro_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ro_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ro_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ro_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ro_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ro_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ro_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ro_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ro_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ro_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ro_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ro_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ro_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ro_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ro_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ro_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ro_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ro_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ro_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ro_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ro_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ro_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ro_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ro_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ro_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ro_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ro_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ro_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ro_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ro_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ro_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ro_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ro_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ro_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ro_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ro_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ro_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ro_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ro_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ro_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ro_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ro_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ro_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ro_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ro_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ro_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ro_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ro_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ro_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ro_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ru_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ru_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ru_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ru_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ru_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ru_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ru_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ru_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ru_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ru_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ru_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ru_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ru_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ru_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ru_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ru_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ru_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ru_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ru_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ru_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ru_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ru_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ru_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ru_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ru_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ru_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ru_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ru_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ru_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ru_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ru_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ru_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ru_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ru_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ru_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ru_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ru_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ru_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ru_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ru_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ru_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ru_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ru_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ru_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ru_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ru_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ru_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ru_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ru_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ru_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ru_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ru_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ru_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ru_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ru_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ru_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ru_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_sa_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_sa_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_sa_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_sa_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_sa_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sa_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_sa_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_sa_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_sa_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_sa_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_sa_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_sa_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_sa_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sa_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_sa_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sa_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_sa_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sa_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_sa_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sa_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_sa_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_sa_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_sa_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_sa_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_sa_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_sa_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_sa_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_sa_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_sa_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_sa_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_sa_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_sa_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sa_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sa_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_sa_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_sa_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_sa_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_sa_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_sa_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_sa_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sa_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sa_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_sa_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_sa_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_sa_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_sa_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_sa_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_sa_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_sa_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_sa_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sa_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_sa_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sa_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_sa_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sa_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_sa_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sa_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sm_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_sm_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_sm_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_sm_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_sm_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sm_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_sm_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_sm_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_sm_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_sm_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_sm_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_sm_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_sm_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sm_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_sm_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sm_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_sm_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sm_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_sm_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sm_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_sm_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_sm_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_sm_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_sm_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_sm_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_sm_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_sm_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_sm_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_sm_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_sm_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_sm_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_sm_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sm_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sm_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_sm_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_sm_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_sm_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_sm_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_sm_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_sm_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sm_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sm_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_sm_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_sm_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_sm_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_sm_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_sm_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_sm_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_sm_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_sm_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sm_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_sm_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sm_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_sm_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sm_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_sm_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sm_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_sr_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_sr_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_sr_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_sr_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_sr_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sr_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_sr_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_sr_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_sr_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_sr_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_sr_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_sr_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_sr_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sr_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_sr_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sr_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_sr_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sr_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_sr_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sr_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_sr_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_sr_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_sr_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_sr_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_sr_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_sr_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_sr_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_sr_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_sr_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_sr_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_sr_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_sr_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sr_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sr_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_sr_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_sr_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_sr_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_sr_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_sr_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_sr_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sr_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sr_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_sr_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_sr_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_sr_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_sr_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_sr_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_sr_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_sr_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_sr_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sr_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_sr_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sr_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_sr_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sr_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_sr_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sr_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_sv_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_sv_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_sv_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_sv_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_sv_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sv_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_sv_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_sv_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_sv_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_sv_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_sv_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_sv_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_sv_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sv_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_sv_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sv_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_sv_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sv_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_sv_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sv_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_sv_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_sv_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_sv_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_sv_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_sv_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_sv_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_sv_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_sv_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_sv_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_sv_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_sv_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_sv_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sv_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sv_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_sv_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_sv_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_sv_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_sv_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_sv_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_sv_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sv_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sv_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_sv_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_sv_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_sv_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_sv_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_sv_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_sv_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_sv_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_sv_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sv_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_sv_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sv_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_sv_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sv_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_sv_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sv_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_sw_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_sw_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_sw_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_sw_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_sw_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sw_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_sw_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_sw_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_sw_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_sw_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_sw_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_sw_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_sw_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sw_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_sw_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_sw_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_sw_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sw_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_sw_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_sw_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_sw_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_sw_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_sw_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_sw_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_sw_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_sw_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_sw_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_sw_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_sw_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_sw_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_sw_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_sw_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sw_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_sw_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_sw_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_sw_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_sw_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_sw_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_sw_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_sw_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sw_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_sw_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_sw_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_sw_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_sw_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_sw_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_sw_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_sw_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_sw_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_sw_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sw_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_sw_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_sw_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_sw_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_sw_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_sw_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_sw_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_th_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_th_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_th_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_th_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_th_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_th_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_th_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_th_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_th_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_th_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_th_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_th_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_th_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_th_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_th_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_th_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_th_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_th_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_th_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_th_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_th_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_th_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_th_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_th_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_th_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_th_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_th_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_th_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_th_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_th_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_th_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_th_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_th_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_th_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_th_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_th_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_th_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_th_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_th_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_th_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_th_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_th_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_th_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_th_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_th_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_th_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_th_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_th_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_th_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_th_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_th_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_th_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_th_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_th_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_th_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_th_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_th_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_tl_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_tl_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_tl_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_tl_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_tl_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_tl_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_tl_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_tl_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_tl_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_tl_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_tl_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_tl_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_tl_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_tl_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_tl_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_tl_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_tl_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_tl_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_tl_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_tl_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_tl_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_tl_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_tl_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_tl_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_tl_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_tl_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_tl_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_tl_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_tl_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_tl_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_tl_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_tl_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_tl_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_tl_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_tl_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_tl_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_tl_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_tl_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_tl_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_tl_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_tl_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_tl_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_tl_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_tl_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_tl_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_tl_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_tl_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_tl_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_tl_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_tl_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_tl_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_tl_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_tl_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_tl_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_tl_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_tl_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_tl_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_tr_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_tr_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_tr_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_tr_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_tr_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_tr_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_tr_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_tr_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_tr_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_tr_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_tr_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_tr_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_tr_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_tr_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_tr_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_tr_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_tr_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_tr_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_tr_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_tr_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_tr_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_tr_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_tr_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_tr_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_tr_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_tr_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_tr_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_tr_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_tr_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_tr_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_tr_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_tr_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_tr_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_tr_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_tr_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_tr_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_tr_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_tr_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_tr_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_tr_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_tr_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_tr_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_tr_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_tr_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_tr_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_tr_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_tr_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_tr_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_tr_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_tr_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_tr_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_tr_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_tr_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_tr_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_tr_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_tr_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_tr_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_ua_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_ua_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_ua_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_ua_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_ua_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ua_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_ua_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_ua_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_ua_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_ua_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_ua_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_ua_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_ua_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ua_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_ua_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_ua_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_ua_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ua_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_ua_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_ua_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_ua_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_ua_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_ua_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_ua_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_ua_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_ua_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_ua_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_ua_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_ua_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_ua_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_ua_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_ua_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ua_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_ua_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_ua_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_ua_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_ua_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_ua_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_ua_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_ua_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ua_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_ua_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_ua_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_ua_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_ua_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_ua_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_ua_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_ua_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_ua_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_ua_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ua_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_ua_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_ua_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_ua_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_ua_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_ua_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_ua_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_vi_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_vi_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_vi_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_vi_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_vi_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_vi_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_vi_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_vi_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_vi_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_vi_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_vi_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_vi_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_vi_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_vi_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_vi_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_vi_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_vi_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_vi_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_vi_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_vi_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_vi_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_vi_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_vi_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_vi_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_vi_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_vi_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_vi_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_vi_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_vi_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_vi_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_vi_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_vi_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_vi_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_vi_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_vi_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_vi_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_vi_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_vi_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_vi_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_vi_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_vi_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_vi_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_vi_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_vi_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_vi_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_vi_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_vi_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_vi_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_vi_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_vi_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_vi_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_vi_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_vi_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_vi_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_vi_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_vi_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_vi_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_yo_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_yo_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_yo_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_yo_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_yo_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_yo_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_yo_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_yo_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_yo_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_yo_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_yo_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_yo_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_yo_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_yo_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_yo_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_yo_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_yo_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_yo_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_yo_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_yo_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_yo_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_yo_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_yo_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_yo_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_yo_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_yo_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_yo_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_yo_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_yo_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_yo_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_yo_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_yo_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_yo_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_yo_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_yo_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_yo_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_yo_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_yo_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_yo_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_yo_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_yo_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_yo_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_yo_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_yo_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_yo_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_yo_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_yo_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_yo_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_yo_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_yo_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_yo_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_yo_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_yo_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_yo_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_yo_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_yo_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_yo_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_zh_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_zh_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_zh_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_zh_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_zh_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_zh_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_zh_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_zh_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_zh_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_zh_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_zh_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_zh_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_zh_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_zh_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_zh_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_zh_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_zh_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_zh_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_zh_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_zh_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_zh_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_zh_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_zh_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_zh_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_zh_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_zh_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_zh_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_zh_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_zh_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_zh_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_zh_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_zh_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_zh_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_zh_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_zh_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_zh_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_zh_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_zh_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_zh_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_zh_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_zh_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_zh_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_zh_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_zh_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_zh_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_zh_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_zh_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_zh_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_zh_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_zh_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_zh_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_zh_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_zh_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_zh_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_zh_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_zh_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_zh_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_freetrial_zhyue_bite_v2': appType_1.AppType.bite,
    'premium_yearly_70_freetrial_zhyue_droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_70_freetrial_zhyue_droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_70_freetrial_zhyue_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_freetrial_zhyue_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_zhyue_int_v2': appType_1.AppType.int,
    'premium_yearly_70_freetrial_zhyue_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_freetrial_zhyue_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_freetrial_zhyue_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_freetrial_zhyue_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_freetrial_zhyue_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_freetrial_zhyue_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_freetrial_zhyue_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_zhyue_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_freetrial_zhyue_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_freetrial_zhyue_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_freetrial_zhyue_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_zhyue_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_freetrial_zhyue_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_freetrial_zhyue_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_freetrial_zhyue_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_freetrial_zhyue_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_freetrial_zhyue_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_freetrial_zhyue_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_freetrial_zhyue_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_freetrial_zhyue_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_freetrial_zhyue_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_freetrial_zhyue_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_freetrial_zhyue_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_freetrial_zhyue_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_freetrial_zhyue_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_freetrial_zhyue_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_zhyue_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_freetrial_zhyue_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_freetrial_zhyue_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_freetrial_zhyue_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_freetrial_zhyue_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_freetrial_zhyue_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_freetrial_zhyue_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_freetrial_zhyue_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_zhyue_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_freetrial_zhyue_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_freetrial_zhyue_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_freetrial_zhyue_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_freetrial_zhyue_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_freetrial_zhyue_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_freetrial_zhyue_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_freetrial_zhyue_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_freetrial_zhyue_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_freetrial_zhyue_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_zhyue_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_freetrial_zhyue_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_freetrial_zhyue_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_freetrial_zhyue_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_freetrial_zhyue_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_freetrial_zhyue_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_freetrial_zhyue_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_70_global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_70_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_int_v2': appType_1.AppType.int,
    'premium_yearly_70_lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_70_lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_70_lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_70_lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_70_lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_70_lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_70_lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_70_lang_enus1_v2': appType_1.AppType.lang_enus,
    'premium_yearly_70_lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_70_lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_70_lang_esmx_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_70_lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_70_lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_70_lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_70_lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_70_lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_70_lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_70_lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_70_lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_70_lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_70_lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_70_lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_70_lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_70_lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_lang_jp_v2': appType_1.AppType.lang_ja,
    'premium_yearly_70_lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_70_lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_70_lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_70_lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_70_lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_70_lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_70_lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_lang_ptpt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_70_lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_70_lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_70_lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_70_lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_70_lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_70_lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_70_lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_70_lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_70_lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_70_lang_zhyue_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_70_local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_70_local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_70_local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_70_scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_70_upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_72_bite': appType_1.AppType.bite,
    'premium_yearly_72_droplets': appType_1.AppType.droplets,
    'premium_yearly_72_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_72_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_72_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_72_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_72_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_72_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_72_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_72_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_72_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_72_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_72_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_72_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_72_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_72_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_72_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_72_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_72_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_72_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_72_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_72_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_72_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_72_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_72_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_72_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_72_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_72_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_72_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_72_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_72_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_72_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_72_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_72_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_72_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_72_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_72_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_72_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_72_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_72_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_72_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_72_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_72_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_72_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_72_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_72_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_72_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_72_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_72_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_72_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_72_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_72_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_72_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_72_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_72_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_72_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_72_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_72_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_72_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_72_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_72_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_72_hu': appType_1.AppType.local_hu,
    'premium_yearly_72_int': appType_1.AppType.int,
    'premium_yearly_72_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_72_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_72_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_72_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_72_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_72_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_72_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_72_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_72_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_72_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_72_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_72_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_72_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_72_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_72_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_72_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_72_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_72_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_72_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_72_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_72_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_72_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_72_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_72_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_72_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_72_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_72_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_72_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_72_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_72_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_72_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_72_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_72_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_72_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_72_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_72_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_72_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_72_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_72_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_72_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_72_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_72_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_72_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_72_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_72_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_72_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_72_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_72_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_72_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_72_scripts': appType_1.AppType.scripts,
    'premium_yearly_72_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_80_bite': appType_1.AppType.bite,
    'premium_yearly_80_droplets': appType_1.AppType.droplets,
    'premium_yearly_80_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_80_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_80_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_80_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_80_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_80_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_80_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_80_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_80_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_80_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_80_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_80_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_80_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_80_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_80_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_80_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_80_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_80_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_80_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_80_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_80_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_80_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_80_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_80_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_80_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_80_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_80_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_80_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_80_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_80_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_80_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_80_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_80_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_80_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_80_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_80_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_80_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_80_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_80_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_80_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_80_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_80_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_80_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_80_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_80_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_80_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_80_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_80_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_80_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_80_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_80_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_80_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_80_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_80_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_80_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_80_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_80_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_80_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_80_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_80_hu': appType_1.AppType.local_hu,
    'premium_yearly_80_int': appType_1.AppType.int,
    'premium_yearly_80_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_80_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_80_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_80_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_80_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_80_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_80_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_80_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_80_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_80_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_80_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_80_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_80_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_80_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_80_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_80_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_80_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_80_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_80_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_80_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_80_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_80_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_80_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_80_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_80_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_80_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_80_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_80_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_80_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_80_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_80_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_80_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_80_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_80_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_80_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_80_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_80_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_80_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_80_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_80_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_80_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_80_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_80_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_80_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_80_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_80_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_80_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_80_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_80_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_80_scripts': appType_1.AppType.scripts,
    'premium_yearly_80_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_90_bite': appType_1.AppType.bite,
    'premium_yearly_90_droplets': appType_1.AppType.droplets,
    'premium_yearly_90_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_90_free_trial_7bite': appType_1.AppType.bite,
    'premium_yearly_90_free_trial_7bite_v2': appType_1.AppType.bite,
    'premium_yearly_90_free_trial_7droplets': appType_1.AppType.droplets,
    'premium_yearly_90_free_trial_7droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_90_free_trial_7droplets_demo_apple_store_v2': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_90_free_trial_7droplets_v2': appType_1.AppType.droplets,
    'premium_yearly_90_free_trial_7global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_90_free_trial_7global_eagle_v2': appType_1.AppType.global_eagle,
    'premium_yearly_90_free_trial_7hu': appType_1.AppType.local_hu,
    'premium_yearly_90_free_trial_7int': appType_1.AppType.int,
    'premium_yearly_90_free_trial_7int_v2': appType_1.AppType.int,
    'premium_yearly_90_free_trial_7lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_90_free_trial_7lang_ain_v2': appType_1.AppType.lang_ain,
    'premium_yearly_90_free_trial_7lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_90_free_trial_7lang_ar_v2': appType_1.AppType.lang_ar,
    'premium_yearly_90_free_trial_7lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_90_free_trial_7lang_bs_v2': appType_1.AppType.lang_bs,
    'premium_yearly_90_free_trial_7lang_da': appType_1.AppType.lang_da,
    'premium_yearly_90_free_trial_7lang_da_v2': appType_1.AppType.lang_da,
    'premium_yearly_90_free_trial_7lang_de': appType_1.AppType.lang_de,
    'premium_yearly_90_free_trial_7lang_de_v2': appType_1.AppType.lang_de,
    'premium_yearly_90_free_trial_7lang_el': appType_1.AppType.lang_el,
    'premium_yearly_90_free_trial_7lang_el_v2': appType_1.AppType.lang_el,
    'premium_yearly_90_free_trial_7lang_en': appType_1.AppType.lang_en,
    'premium_yearly_90_free_trial_7lang_en2_v2': appType_1.AppType.lang_enus,
    'premium_yearly_90_free_trial_7lang_en_v2': appType_1.AppType.lang_en,
    'premium_yearly_90_free_trial_7lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_90_free_trial_7lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_90_free_trial_7lang_eo_v2': appType_1.AppType.lang_eo,
    'premium_yearly_90_free_trial_7lang_es': appType_1.AppType.lang_es,
    'premium_yearly_90_free_trial_7lang_es2_v2': appType_1.AppType.lang_esmx,
    'premium_yearly_90_free_trial_7lang_es_v2': appType_1.AppType.lang_es,
    'premium_yearly_90_free_trial_7lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_90_free_trial_7lang_et': appType_1.AppType.lang_et,
    'premium_yearly_90_free_trial_7lang_et_v2': appType_1.AppType.lang_et,
    'premium_yearly_90_free_trial_7lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_90_free_trial_7lang_fa_v2': appType_1.AppType.lang_fa,
    'premium_yearly_90_free_trial_7lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_90_free_trial_7lang_fi_v2': appType_1.AppType.lang_fi,
    'premium_yearly_90_free_trial_7lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_90_free_trial_7lang_fr_v2': appType_1.AppType.lang_fr,
    'premium_yearly_90_free_trial_7lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_90_free_trial_7lang_haw_v2': appType_1.AppType.lang_haw,
    'premium_yearly_90_free_trial_7lang_he': appType_1.AppType.lang_he,
    'premium_yearly_90_free_trial_7lang_he_v2': appType_1.AppType.lang_he,
    'premium_yearly_90_free_trial_7lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_90_free_trial_7lang_hi_v2': appType_1.AppType.lang_hi,
    'premium_yearly_90_free_trial_7lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_90_free_trial_7lang_hr_v2': appType_1.AppType.lang_hr,
    'premium_yearly_90_free_trial_7lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_90_free_trial_7lang_hu_v2': appType_1.AppType.lang_hu,
    'premium_yearly_90_free_trial_7lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_90_free_trial_7lang_ic_v2': appType_1.AppType.lang_ic,
    'premium_yearly_90_free_trial_7lang_id': appType_1.AppType.lang_id,
    'premium_yearly_90_free_trial_7lang_id_v2': appType_1.AppType.lang_id,
    'premium_yearly_90_free_trial_7lang_it': appType_1.AppType.lang_it,
    'premium_yearly_90_free_trial_7lang_it_v2': appType_1.AppType.lang_it,
    'premium_yearly_90_free_trial_7lang_ja_v2': appType_1.AppType.lang_ja,
    'premium_yearly_90_free_trial_7lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_90_free_trial_7lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_90_free_trial_7lang_ko_v2': appType_1.AppType.lang_ko,
    'premium_yearly_90_free_trial_7lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_90_free_trial_7lang_mi_v2': appType_1.AppType.lang_mi,
    'premium_yearly_90_free_trial_7lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_90_free_trial_7lang_nl_v2': appType_1.AppType.lang_nl,
    'premium_yearly_90_free_trial_7lang_no': appType_1.AppType.lang_no,
    'premium_yearly_90_free_trial_7lang_no_v2': appType_1.AppType.lang_no,
    'premium_yearly_90_free_trial_7lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_90_free_trial_7lang_pl_v2': appType_1.AppType.lang_pl,
    'premium_yearly_90_free_trial_7lang_pt': appType_1.AppType.lang_ptbr,
    'premium_yearly_90_free_trial_7lang_pt2_v2': appType_1.AppType.lang_ptbr,
    'premium_yearly_90_free_trial_7lang_pt_v2': appType_1.AppType.lang_pt,
    'premium_yearly_90_free_trial_7lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_90_free_trial_7lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_90_free_trial_7lang_ru_v2': appType_1.AppType.lang_ru,
    'premium_yearly_90_free_trial_7lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_90_free_trial_7lang_sm_v2': appType_1.AppType.lang_sm,
    'premium_yearly_90_free_trial_7lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_90_free_trial_7lang_sr_v2': appType_1.AppType.lang_sr,
    'premium_yearly_90_free_trial_7lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_90_free_trial_7lang_sv_v2': appType_1.AppType.lang_sv,
    'premium_yearly_90_free_trial_7lang_th': appType_1.AppType.lang_th,
    'premium_yearly_90_free_trial_7lang_th_v2': appType_1.AppType.lang_th,
    'premium_yearly_90_free_trial_7lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_90_free_trial_7lang_tl_v2': appType_1.AppType.lang_tl,
    'premium_yearly_90_free_trial_7lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_90_free_trial_7lang_tr_v2': appType_1.AppType.lang_tr,
    'premium_yearly_90_free_trial_7lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_90_free_trial_7lang_vi_v2': appType_1.AppType.lang_vi,
    'premium_yearly_90_free_trial_7lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_90_free_trial_7lang_zh2_v2': appType_1.AppType.lang_zhyue,
    'premium_yearly_90_free_trial_7lang_zh_v2': appType_1.AppType.lang_zh,
    'premium_yearly_90_free_trial_7lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_90_free_trial_7local_ar': appType_1.AppType.local_ar,
    'premium_yearly_90_free_trial_7local_ar_v2': appType_1.AppType.local_ar,
    'premium_yearly_90_free_trial_7local_hu_v2': appType_1.AppType.local_hu,
    'premium_yearly_90_free_trial_7local_zh': appType_1.AppType.local_zh,
    'premium_yearly_90_free_trial_7local_zh_v2': appType_1.AppType.local_zh,
    'premium_yearly_90_free_trial_7scripts': appType_1.AppType.scripts,
    'premium_yearly_90_free_trial_7scripts_v2': appType_1.AppType.scripts,
    'premium_yearly_90_free_trial_7upopoy': appType_1.AppType.upopoy,
    'premium_yearly_90_free_trial_7upopoy_v2': appType_1.AppType.upopoy,
    'premium_yearly_90_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_90_hu': appType_1.AppType.local_hu,
    'premium_yearly_90_int': appType_1.AppType.int,
    'premium_yearly_90_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_90_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_90_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_90_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_90_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_90_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_90_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_90_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_90_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_90_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_90_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_90_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_90_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_90_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_90_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_90_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_90_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_90_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_90_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_90_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_90_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_90_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_90_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_90_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_90_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_90_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_90_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_90_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_90_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_90_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_90_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_90_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_90_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_90_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_90_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_90_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_90_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_90_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_90_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_90_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_90_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_90_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_90_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_90_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_90_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_90_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_90_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_90_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_90_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_90_scripts': appType_1.AppType.scripts,
    'premium_yearly_90_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_20_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_20_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_20_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_20_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_20_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_20_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_20_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_20_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_20_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_20_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_20_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_20_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_20_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_20_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_20_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_20_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_20_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_20_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_20_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_20_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_20_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_20_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_20_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_20_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_20_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_20_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_20_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_20_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_20_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_20_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_20_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_20_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_20_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_20_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_20_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_20_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_20_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_20_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_20_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_20_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_20_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_20_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_20_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_20_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_20_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_20_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_20_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_20_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_20_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_20_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_20_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_20_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_20_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_20_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_20_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_20_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_20_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_20_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_20_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_20_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_20_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_20_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_20_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_20_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_20_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_20_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_20_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_20_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_20_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_20_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_20_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_20_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_20_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_20_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_20_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_20_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_20_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_20_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_20_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_20_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_20_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_20_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_20_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_20_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_20_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_20_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_20_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_20_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_20_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_20_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_20_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_20_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_20_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_20_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_20_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_20_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_20_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_20_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_20_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_20_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_20_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_20_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_20_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_20_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_20_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_20_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_20_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_20_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_20_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_20_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_20_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_20_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_20_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_20_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_20_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_20_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_20_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_20_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_20_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_20_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_20_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_20_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_20_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_20_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_20_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_20_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_20_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_20_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_20_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_20_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_20_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_20_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_20_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_20_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_20_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_20_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_20_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_20_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_20_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_20_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_20_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_20_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_20_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_20_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_20_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_20_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_20_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_20_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_20_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_20_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_20_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_20_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_20_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_20_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_20_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_20_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_20_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_20_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_20_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_20_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_20_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_20_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_20_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_20_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_20_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_20_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_20_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_20_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_20_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_20_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_20_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_20_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_20_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_20_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_20_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_20_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_20_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_20_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_20_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_20_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_20_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_20_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_20_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_20_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_20_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_20_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_40_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_40_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_40_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_40_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_40_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_40_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_40_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_40_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_40_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_40_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_40_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_40_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_40_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_40_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_40_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_40_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_40_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_40_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_40_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_40_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_40_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_40_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_40_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_40_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_40_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_40_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_40_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_40_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_40_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_40_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_40_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_40_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_40_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_40_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_40_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_40_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_40_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_40_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_40_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_40_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_40_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_40_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_40_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_40_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_40_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_40_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_40_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_40_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_40_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_40_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_40_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_40_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_40_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_40_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_40_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_40_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_40_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_40_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_40_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_40_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_40_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_40_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_40_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_40_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_40_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_40_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_40_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_40_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_40_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_40_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_40_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_40_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_40_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_40_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_40_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_40_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_40_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_40_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_40_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_40_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_40_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_40_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_40_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_40_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_40_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_40_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_40_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_40_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_40_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_40_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_40_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_40_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_40_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_40_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_40_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_40_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_40_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_40_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_40_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_40_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_40_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_40_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_40_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_40_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_40_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_40_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_40_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_40_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_40_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_40_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_40_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_40_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_40_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_40_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_40_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_40_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_40_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_40_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_40_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_40_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_40_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_40_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_40_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_40_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_40_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_40_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_40_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_40_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_40_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_40_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_40_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_40_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_40_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_40_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_40_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_40_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_40_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_40_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_40_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_40_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_40_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_40_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_40_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_40_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_40_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_40_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_40_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_40_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_40_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_40_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_40_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_40_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_40_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_40_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_40_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_40_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_40_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_40_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_40_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_40_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_40_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_40_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_40_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_40_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_40_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_40_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_40_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_40_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_40_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_40_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_40_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_40_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_40_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_40_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_40_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_40_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_40_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_40_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_40_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_40_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_40_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_40_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_40_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_40_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_40_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_40_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_45_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_45_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_45_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_45_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_45_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_45_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_45_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_45_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_45_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_45_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_45_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_45_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_45_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_45_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_45_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_45_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_45_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_45_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_45_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_45_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_45_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_45_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_45_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_45_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_45_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_45_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_45_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_45_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_45_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_45_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_45_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_45_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_45_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_45_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_45_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_45_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_45_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_45_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_45_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_45_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_45_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_45_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_45_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_45_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_45_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_45_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_45_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_45_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_45_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_45_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_45_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_45_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_45_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_45_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_45_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_45_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_45_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_45_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_45_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_45_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_45_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_45_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_45_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_45_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_45_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_45_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_45_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_45_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_45_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_45_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_45_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_45_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_45_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_45_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_45_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_45_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_45_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_45_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_45_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_45_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_45_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_45_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_45_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_45_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_45_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_45_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_45_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_45_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_45_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_45_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_45_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_45_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_45_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_45_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_45_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_45_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_45_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_45_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_45_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_45_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_45_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_45_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_45_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_45_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_45_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_45_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_45_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_45_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_45_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_45_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_45_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_45_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_45_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_45_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_45_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_45_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_45_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_45_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_45_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_45_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_45_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_45_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_45_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_45_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_45_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_45_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_45_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_45_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_45_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_45_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_45_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_45_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_45_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_45_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_45_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_45_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_45_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_45_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_45_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_45_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_45_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_45_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_45_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_45_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_45_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_45_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_45_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_45_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_45_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_45_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_45_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_45_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_45_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_45_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_45_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_45_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_45_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_45_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_45_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_45_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_45_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_45_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_45_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_45_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_45_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_45_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_45_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_45_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_45_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_45_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_45_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_45_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_45_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_45_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_45_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_45_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_45_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_45_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_45_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_45_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_45_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_45_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_45_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_45_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_45_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_45_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_50_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_50_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_50_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_50_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_50_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_50_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_50_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_50_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_50_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_50_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_50_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_50_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_50_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_50_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_50_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_50_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_50_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_50_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_50_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_50_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_50_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_50_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_50_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_50_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_50_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_50_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_50_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_50_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_50_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_50_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_50_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_50_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_50_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_50_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_50_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_50_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_50_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_50_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_50_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_50_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_50_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_50_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_50_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_50_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_50_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_50_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_50_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_50_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_50_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_50_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_50_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_50_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_50_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_50_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_50_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_50_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_50_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_50_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_50_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_50_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_50_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_50_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_50_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_50_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_50_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_50_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_50_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_50_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_50_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_50_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_50_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_50_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_50_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_50_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_50_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_50_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_50_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_50_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_50_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_50_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_50_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_50_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_50_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_50_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_50_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_50_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_50_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_50_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_50_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_50_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_50_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_50_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_50_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_50_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_50_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_50_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_50_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_50_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_50_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_50_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_50_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_50_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_50_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_50_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_50_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_50_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_50_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_50_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_50_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_50_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_50_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_50_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_50_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_50_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_50_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_50_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_50_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_50_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_50_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_50_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_50_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_50_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_50_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_50_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_50_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_50_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_50_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_50_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_50_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_50_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_50_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_50_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_50_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_50_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_50_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_50_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_50_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_50_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_50_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_50_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_50_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_50_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_50_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_50_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_50_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_50_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_50_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_50_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_50_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_50_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_50_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_50_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_50_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_50_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_50_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_50_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_50_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_50_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_50_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_50_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_50_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_50_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_50_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_50_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_50_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_50_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_50_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_50_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_50_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_50_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_50_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_50_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_50_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_50_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_50_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_50_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_50_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_50_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_50_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_50_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_50_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_50_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_50_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_50_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_50_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_50_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_55_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_55_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_55_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_55_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_55_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_55_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_55_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_55_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_55_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_55_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_55_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_55_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_55_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_55_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_55_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_55_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_55_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_55_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_55_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_55_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_55_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_55_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_55_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_55_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_55_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_55_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_55_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_55_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_55_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_55_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_55_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_55_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_55_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_55_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_55_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_55_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_55_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_55_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_55_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_55_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_55_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_55_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_55_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_55_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_55_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_55_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_55_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_55_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_55_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_55_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_55_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_55_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_55_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_55_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_55_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_55_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_55_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_55_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_55_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_55_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_55_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_55_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_55_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_55_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_55_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_55_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_55_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_55_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_55_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_55_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_55_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_55_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_55_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_55_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_55_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_55_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_55_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_55_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_55_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_55_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_55_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_55_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_55_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_55_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_55_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_55_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_55_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_55_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_55_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_55_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_55_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_55_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_55_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_55_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_55_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_55_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_55_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_55_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_55_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_55_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_55_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_55_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_55_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_55_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_55_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_55_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_55_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_55_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_55_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_55_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_55_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_55_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_55_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_55_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_55_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_55_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_55_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_55_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_55_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_55_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_55_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_55_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_55_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_55_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_55_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_55_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_55_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_55_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_55_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_55_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_55_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_55_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_55_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_55_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_55_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_55_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_55_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_55_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_55_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_55_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_55_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_55_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_55_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_55_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_55_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_55_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_55_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_55_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_55_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_55_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_55_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_55_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_55_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_55_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_55_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_55_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_55_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_55_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_55_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_55_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_55_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_55_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_55_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_55_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_55_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_55_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_55_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_55_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_55_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_55_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_55_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_55_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_55_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_55_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_55_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_55_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_55_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_55_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_55_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_55_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_55_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_55_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_55_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_55_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_55_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_55_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_60_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_60_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_60_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_60_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_60_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_60_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_60_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_60_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_60_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_60_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_60_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_60_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_60_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_60_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_60_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_60_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_60_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_60_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_60_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_60_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_60_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_60_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_60_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_60_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_60_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_60_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_60_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_60_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_60_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_60_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_60_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_60_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_60_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_60_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_60_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_60_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_60_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_60_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_60_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_60_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_60_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_60_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_60_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_60_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_60_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_60_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_60_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_60_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_60_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_60_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_60_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_60_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_60_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_60_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_60_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_60_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_60_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_60_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_60_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_60_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_60_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_60_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_60_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_60_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_60_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_60_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_60_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_60_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_60_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_60_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_60_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_60_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_60_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_60_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_60_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_60_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_60_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_60_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_60_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_60_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_60_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_60_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_60_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_60_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_60_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_60_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_60_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_60_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_60_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_60_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_60_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_60_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_60_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_60_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_60_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_60_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_60_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_60_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_60_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_60_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_60_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_60_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_60_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_60_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_60_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_60_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_60_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_60_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_60_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_60_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_60_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_60_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_60_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_60_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_60_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_60_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_60_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_60_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_60_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_60_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_60_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_60_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_60_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_60_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_60_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_60_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_60_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_60_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_60_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_60_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_60_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_60_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_60_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_60_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_60_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_60_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_60_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_60_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_60_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_60_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_60_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_60_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_60_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_60_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_60_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_60_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_60_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_60_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_60_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_60_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_60_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_60_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_60_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_60_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_60_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_60_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_60_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_60_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_60_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_60_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_60_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_60_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_60_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_60_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_60_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_60_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_60_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_60_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_60_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_60_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_60_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_60_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_60_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_60_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_60_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_60_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_60_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_60_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_60_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_60_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_60_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_60_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_60_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_60_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_60_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_60_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_65_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_discount_65_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_65_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_65_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_65_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_a_int': appType_1.AppType.int,
    'premium_yearly_discount_65_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_65_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_65_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_65_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_65_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_65_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_65_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_65_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_65_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_65_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_65_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_65_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_65_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_65_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_65_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_65_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_65_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_65_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_65_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_65_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_65_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_65_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_65_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_65_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_65_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_65_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_65_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_65_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_65_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_65_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_65_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_65_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_65_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_65_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_65_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_65_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_65_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_65_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_65_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_65_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_65_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_discount_65_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_65_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_65_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_65_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_b_int': appType_1.AppType.int,
    'premium_yearly_discount_65_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_65_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_65_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_65_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_65_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_65_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_65_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_65_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_65_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_65_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_65_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_65_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_65_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_65_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_65_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_65_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_65_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_65_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_65_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_65_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_65_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_65_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_65_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_65_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_65_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_65_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_65_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_65_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_65_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_65_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_65_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_65_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_65_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_65_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_65_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_65_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_65_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_65_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_65_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_65_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_65_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_discount_65_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_65_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_65_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_65_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_c_int': appType_1.AppType.int,
    'premium_yearly_discount_65_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_65_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_65_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_65_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_65_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_65_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_65_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_65_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_65_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_65_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_65_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_65_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_65_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_65_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_65_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_65_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_65_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_65_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_65_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_65_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_65_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_65_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_65_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_65_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_65_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_65_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_65_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_65_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_65_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_65_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_65_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_65_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_65_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_65_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_65_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_65_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_65_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_65_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_65_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_65_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_discount_65_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_discount_65_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_discount_65_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_discount_65_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_discount_65_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_d_int': appType_1.AppType.int,
    'premium_yearly_discount_65_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_discount_65_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_discount_65_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_discount_65_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_discount_65_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_discount_65_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_discount_65_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_discount_65_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_discount_65_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_discount_65_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_discount_65_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_discount_65_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_discount_65_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_discount_65_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_discount_65_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_discount_65_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_discount_65_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_discount_65_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_discount_65_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_discount_65_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_discount_65_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_discount_65_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_discount_65_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_discount_65_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_discount_65_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_discount_65_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_discount_65_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_discount_65_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_discount_65_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_discount_65_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_discount_65_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_discount_65_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_discount_65_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_discount_65_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_discount_65_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_discount_65_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_discount_65_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_discount_65_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_discount_65_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_discount_65_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_discount_65_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_discount_65_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_discount_65_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_discount_65_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_discount_65_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_discount_65_tier_d_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_a_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_a_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_a_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_a_free_trial_14_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_a_free_trial_14_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_a_free_trial_14_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_a_free_trial_14_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_a_free_trial_14_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_free_trial_14_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_free_trial_14_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_free_trial_14_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_a_free_trial_14_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_free_trial_14_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_a_free_trial_14_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_a_free_trial_14_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_a_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_a_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_a_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_a_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_a_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_a_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_a_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_a_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_a_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_a_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_a_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_a_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_a_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_a_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_a_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_a_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_a_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_a_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_a_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_a_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_a_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_a_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_a_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_a_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_a_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_a_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_a_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_a_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_a_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_a_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_a_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_a_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_a_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_a_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_a_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_a_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_a_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_a_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_a_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_a_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_a_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_a_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_a_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_a_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_a_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_a_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_a_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_a_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_a_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_a_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_a_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_a_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_a_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_a_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_a_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_a_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_b_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_b_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_b_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_b_free_trial_14_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_b_free_trial_14_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_b_free_trial_14_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_b_free_trial_14_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_b_free_trial_14_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_free_trial_14_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_free_trial_14_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_free_trial_14_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_b_free_trial_14_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_free_trial_14_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_b_free_trial_14_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_b_free_trial_14_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_b_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_b_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_b_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_b_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_b_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_b_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_b_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_b_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_b_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_b_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_b_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_b_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_b_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_b_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_b_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_b_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_b_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_b_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_b_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_b_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_b_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_b_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_b_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_b_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_b_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_b_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_b_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_b_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_b_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_b_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_b_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_b_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_b_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_b_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_b_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_b_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_b_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_b_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_b_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_b_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_b_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_b_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_b_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_b_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_b_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_b_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_b_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_b_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_b_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_b_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_b_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_b_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_b_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_b_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_b_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_b_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_c_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_c_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_c_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_c_free_trial_14_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_c_free_trial_14_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_c_free_trial_14_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_c_free_trial_14_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_c_free_trial_14_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_free_trial_14_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_free_trial_14_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_free_trial_14_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_c_free_trial_14_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_free_trial_14_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_c_free_trial_14_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_c_free_trial_14_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_c_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_c_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_c_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_c_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_c_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_c_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_c_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_c_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_c_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_c_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_c_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_c_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_c_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_c_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_c_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_c_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_c_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_c_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_c_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_c_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_c_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_c_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_c_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_c_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_c_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_c_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_c_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_c_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_c_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_c_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_c_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_c_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_c_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_c_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_c_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_c_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_c_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_c_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_c_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_c_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_c_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_c_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_c_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_c_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_c_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_c_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_c_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_c_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_c_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_c_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_c_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_c_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_c_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_c_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_c_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_c_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_d_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_d_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_d_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_d_free_trial_14_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_d_free_trial_14_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_d_free_trial_14_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_d_free_trial_14_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_d_free_trial_14_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_free_trial_14_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_free_trial_14_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_free_trial_14_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_d_free_trial_14_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_free_trial_14_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_d_free_trial_14_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_d_free_trial_14_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_d_free_trial_7_bite': appType_1.AppType.bite,
    'premium_yearly_full_price_tier_d_free_trial_7_droplets': appType_1.AppType.droplets,
    'premium_yearly_full_price_tier_d_free_trial_7_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'premium_yearly_full_price_tier_d_free_trial_7_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_d_free_trial_7_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_free_trial_7_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_free_trial_7_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_free_trial_7_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_d_free_trial_7_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_free_trial_7_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_d_free_trial_7_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_d_free_trial_7_upopoy': appType_1.AppType.upopoy,
    'premium_yearly_full_price_tier_d_global_eagle': appType_1.AppType.global_eagle,
    'premium_yearly_full_price_tier_d_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_int': appType_1.AppType.int,
    'premium_yearly_full_price_tier_d_lang_ain': appType_1.AppType.lang_ain,
    'premium_yearly_full_price_tier_d_lang_ar': appType_1.AppType.lang_ar,
    'premium_yearly_full_price_tier_d_lang_bs': appType_1.AppType.lang_bs,
    'premium_yearly_full_price_tier_d_lang_da': appType_1.AppType.lang_da,
    'premium_yearly_full_price_tier_d_lang_de': appType_1.AppType.lang_de,
    'premium_yearly_full_price_tier_d_lang_el': appType_1.AppType.lang_el,
    'premium_yearly_full_price_tier_d_lang_en': appType_1.AppType.lang_en,
    'premium_yearly_full_price_tier_d_lang_en2': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_lang_enus1': appType_1.AppType.lang_enus,
    'premium_yearly_full_price_tier_d_lang_eo': appType_1.AppType.lang_eo,
    'premium_yearly_full_price_tier_d_lang_es': appType_1.AppType.lang_es,
    'premium_yearly_full_price_tier_d_lang_es2': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_lang_esmx': appType_1.AppType.lang_esmx,
    'premium_yearly_full_price_tier_d_lang_et': appType_1.AppType.lang_et,
    'premium_yearly_full_price_tier_d_lang_fa': appType_1.AppType.lang_fa,
    'premium_yearly_full_price_tier_d_lang_fi': appType_1.AppType.lang_fi,
    'premium_yearly_full_price_tier_d_lang_fr': appType_1.AppType.lang_fr,
    'premium_yearly_full_price_tier_d_lang_haw': appType_1.AppType.lang_haw,
    'premium_yearly_full_price_tier_d_lang_he': appType_1.AppType.lang_he,
    'premium_yearly_full_price_tier_d_lang_hi': appType_1.AppType.lang_hi,
    'premium_yearly_full_price_tier_d_lang_hr': appType_1.AppType.lang_hr,
    'premium_yearly_full_price_tier_d_lang_hu': appType_1.AppType.lang_hu,
    'premium_yearly_full_price_tier_d_lang_ic': appType_1.AppType.lang_ic,
    'premium_yearly_full_price_tier_d_lang_id': appType_1.AppType.lang_id,
    'premium_yearly_full_price_tier_d_lang_it': appType_1.AppType.lang_it,
    'premium_yearly_full_price_tier_d_lang_ja': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_lang_jp': appType_1.AppType.lang_ja,
    'premium_yearly_full_price_tier_d_lang_ko': appType_1.AppType.lang_ko,
    'premium_yearly_full_price_tier_d_lang_mi': appType_1.AppType.lang_mi,
    'premium_yearly_full_price_tier_d_lang_nl': appType_1.AppType.lang_nl,
    'premium_yearly_full_price_tier_d_lang_no': appType_1.AppType.lang_no,
    'premium_yearly_full_price_tier_d_lang_pl': appType_1.AppType.lang_pl,
    'premium_yearly_full_price_tier_d_lang_pt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_lang_pt2': appType_1.AppType.lang_ptbr,
    'premium_yearly_full_price_tier_d_lang_ptpt': appType_1.AppType.lang_pt,
    'premium_yearly_full_price_tier_d_lang_ru': appType_1.AppType.lang_ru,
    'premium_yearly_full_price_tier_d_lang_sm': appType_1.AppType.lang_sm,
    'premium_yearly_full_price_tier_d_lang_sr': appType_1.AppType.lang_sr,
    'premium_yearly_full_price_tier_d_lang_sv': appType_1.AppType.lang_sv,
    'premium_yearly_full_price_tier_d_lang_th': appType_1.AppType.lang_th,
    'premium_yearly_full_price_tier_d_lang_tl': appType_1.AppType.lang_tl,
    'premium_yearly_full_price_tier_d_lang_tr': appType_1.AppType.lang_tr,
    'premium_yearly_full_price_tier_d_lang_vi': appType_1.AppType.lang_vi,
    'premium_yearly_full_price_tier_d_lang_zh': appType_1.AppType.lang_zh,
    'premium_yearly_full_price_tier_d_lang_zh2': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_lang_zhyue': appType_1.AppType.lang_zhyue,
    'premium_yearly_full_price_tier_d_local_ar': appType_1.AppType.local_ar,
    'premium_yearly_full_price_tier_d_local_hu': appType_1.AppType.local_hu,
    'premium_yearly_full_price_tier_d_local_zh': appType_1.AppType.local_zh,
    'premium_yearly_full_price_tier_d_scripts': appType_1.AppType.scripts,
    'premium_yearly_full_price_tier_d_upopoy': appType_1.AppType.upopoy,
    'rc_promo_free-premium_weekly': appType_1.AppType.bite,
    'subscription_monthly_10mins_alternative_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_10mins_bite': appType_1.AppType.bite,
    'subscription_monthly_10mins_droplets': appType_1.AppType.droplets,
    'subscription_monthly_10mins_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_10mins_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_10mins_int_cis_30': appType_1.AppType.bite,
    'subscription_monthly_10mins_int_cis_50': appType_1.AppType.bite,
    'subscription_monthly_10mins_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_10mins_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_10mins_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_10mins_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_10mins_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_10mins_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_10mins_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_10mins_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_10mins_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_monthly_10mins_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_10mins_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_10mins_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_10mins_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_monthly_10mins_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_10mins_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_10mins_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_10mins_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_10mins_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_10mins_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_10mins_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_10mins_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_10mins_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_10mins_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_10mins_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_10mins_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_10mins_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_10mins_lang_jp': appType_1.AppType.lang_ja,
    'subscription_monthly_10mins_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_10mins_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_10mins_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_10mins_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_10mins_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_10mins_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_10mins_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_10mins_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_monthly_10mins_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_10mins_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_10mins_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_10mins_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_10mins_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_10mins_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_10mins_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_10mins_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_10mins_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_10mins_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_monthly_10mins_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_10mins_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_10mins_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_10mins_scripts': appType_1.AppType.scripts,
    'subscription_monthly_10mins_upopoy': appType_1.AppType.upopoy,
    'subscription_monthly_all_languages_alternative_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_all_languages_bite': appType_1.AppType.bite,
    'subscription_monthly_all_languages_droplets': appType_1.AppType.droplets,
    'subscription_monthly_all_languages_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_all_languages_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_all_languages_hu': appType_1.AppType.local_hu,
    'subscription_monthly_all_languages_int': appType_1.AppType.int,
    'subscription_monthly_all_languages_int_apple_price': appType_1.AppType.int,
    'subscription_monthly_all_languages_int_cis_30': appType_1.AppType.bite,
    'subscription_monthly_all_languages_int_cis_50': appType_1.AppType.bite,
    'subscription_monthly_all_languages_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_all_languages_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_all_languages_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_all_languages_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_all_languages_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_all_languages_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_all_languages_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_all_languages_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_all_languages_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_monthly_all_languages_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_all_languages_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_all_languages_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_all_languages_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_monthly_all_languages_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_all_languages_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_all_languages_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_all_languages_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_all_languages_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_all_languages_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_all_languages_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_all_languages_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_all_languages_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_all_languages_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_all_languages_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_all_languages_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_all_languages_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_all_languages_lang_jp': appType_1.AppType.lang_ja,
    'subscription_monthly_all_languages_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_all_languages_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_all_languages_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_all_languages_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_all_languages_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_all_languages_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_all_languages_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_all_languages_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_monthly_all_languages_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_all_languages_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_all_languages_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_all_languages_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_all_languages_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_all_languages_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_all_languages_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_all_languages_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_all_languages_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_all_languages_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_all_languages_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_monthly_all_languages_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_all_languages_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_all_languages_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_all_languages_scripts': appType_1.AppType.scripts,
    'subscription_monthly_all_languages_trial_bite': appType_1.AppType.bite,
    'subscription_monthly_all_languages_trial_droplets': appType_1.AppType.droplets,
    'subscription_monthly_all_languages_trial_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_all_languages_trial_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_all_languages_trial_hu': appType_1.AppType.local_hu,
    'subscription_monthly_all_languages_trial_int': appType_1.AppType.int,
    'subscription_monthly_all_languages_trial_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_all_languages_trial_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_all_languages_trial_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_all_languages_trial_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_all_languages_trial_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_all_languages_trial_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_all_languages_trial_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_all_languages_trial_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_all_languages_trial_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_monthly_all_languages_trial_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_all_languages_trial_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_all_languages_trial_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_all_languages_trial_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_monthly_all_languages_trial_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_all_languages_trial_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_all_languages_trial_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_all_languages_trial_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_all_languages_trial_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_all_languages_trial_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_all_languages_trial_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_all_languages_trial_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_all_languages_trial_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_all_languages_trial_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_all_languages_trial_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_all_languages_trial_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_all_languages_trial_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_all_languages_trial_lang_jp': appType_1.AppType.lang_ja,
    'subscription_monthly_all_languages_trial_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_all_languages_trial_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_all_languages_trial_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_all_languages_trial_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_all_languages_trial_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_all_languages_trial_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_all_languages_trial_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_all_languages_trial_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_monthly_all_languages_trial_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_all_languages_trial_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_all_languages_trial_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_all_languages_trial_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_all_languages_trial_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_all_languages_trial_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_all_languages_trial_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_all_languages_trial_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_all_languages_trial_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_all_languages_trial_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_all_languages_trial_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_monthly_all_languages_trial_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_all_languages_trial_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_all_languages_trial_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_all_languages_trial_scripts': appType_1.AppType.scripts,
    'subscription_monthly_all_languages_trial_upopoy': appType_1.AppType.upopoy,
    'subscription_monthly_all_languages_upopoy': appType_1.AppType.upopoy,
    'subscription_monthly_curious_bite': appType_1.AppType.bite,
    'subscription_monthly_curious_droplets': appType_1.AppType.droplets,
    'subscription_monthly_curious_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_curious_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_curious_int': appType_1.AppType.int,
    'subscription_monthly_curious_int_apple_price': appType_1.AppType.int,
    'subscription_monthly_curious_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_curious_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_curious_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_curious_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_curious_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_curious_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_curious_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_curious_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_curious_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_curious_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_curious_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_curious_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_curious_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_curious_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_curious_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_curious_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_curious_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_curious_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_curious_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_curious_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_curious_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_curious_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_curious_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_curious_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_curious_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_curious_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_curious_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_curious_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_curious_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_curious_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_curious_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_curious_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_curious_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_curious_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_curious_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_curious_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_curious_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_curious_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_curious_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_curious_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_curious_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_curious_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_curious_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_curious_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_curious_scripts': appType_1.AppType.scripts,
    'subscription_monthly_curious_upopoy': appType_1.AppType.upopoy,
    'subscription_monthly_unliminted_time_bite': appType_1.AppType.bite,
    'subscription_monthly_unliminted_time_droplets': appType_1.AppType.droplets,
    'subscription_monthly_unliminted_time_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_unliminted_time_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_unliminted_time_hu': appType_1.AppType.local_hu,
    'subscription_monthly_unliminted_time_int': appType_1.AppType.int,
    'subscription_monthly_unliminted_time_int_apple_price': appType_1.AppType.int,
    'subscription_monthly_unliminted_time_int_cis_30': appType_1.AppType.bite,
    'subscription_monthly_unliminted_time_int_cis_50': appType_1.AppType.bite,
    'subscription_monthly_unliminted_time_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_unliminted_time_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_unliminted_time_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_unliminted_time_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_unliminted_time_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_unliminted_time_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_unliminted_time_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_unliminted_time_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_unliminted_time_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_monthly_unliminted_time_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_unliminted_time_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_unliminted_time_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_unliminted_time_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_monthly_unliminted_time_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_unliminted_time_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_unliminted_time_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_unliminted_time_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_unliminted_time_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_unliminted_time_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_unliminted_time_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_unliminted_time_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_unliminted_time_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_unliminted_time_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_unliminted_time_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_unliminted_time_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_unliminted_time_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_unliminted_time_lang_jp': appType_1.AppType.lang_ja,
    'subscription_monthly_unliminted_time_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_unliminted_time_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_unliminted_time_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_unliminted_time_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_unliminted_time_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_unliminted_time_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_unliminted_time_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_unliminted_time_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_monthly_unliminted_time_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_unliminted_time_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_unliminted_time_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_unliminted_time_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_unliminted_time_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_unliminted_time_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_unliminted_time_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_unliminted_time_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_unliminted_time_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_unliminted_time_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_unliminted_time_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_monthly_unliminted_time_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_unliminted_time_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_unliminted_time_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_unliminted_time_scripts': appType_1.AppType.scripts,
    'subscription_monthly_unliminted_time_trial_bite': appType_1.AppType.bite,
    'subscription_monthly_unliminted_time_trial_droplets': appType_1.AppType.droplets,
    'subscription_monthly_unliminted_time_trial_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_monthly_unliminted_time_trial_global_eagle': appType_1.AppType.global_eagle,
    'subscription_monthly_unliminted_time_trial_hu': appType_1.AppType.local_hu,
    'subscription_monthly_unliminted_time_trial_int': appType_1.AppType.int,
    'subscription_monthly_unliminted_time_trial_lang_ain': appType_1.AppType.lang_ain,
    'subscription_monthly_unliminted_time_trial_lang_ar': appType_1.AppType.lang_ar,
    'subscription_monthly_unliminted_time_trial_lang_bs': appType_1.AppType.lang_bs,
    'subscription_monthly_unliminted_time_trial_lang_da': appType_1.AppType.lang_da,
    'subscription_monthly_unliminted_time_trial_lang_de': appType_1.AppType.lang_de,
    'subscription_monthly_unliminted_time_trial_lang_el': appType_1.AppType.lang_el,
    'subscription_monthly_unliminted_time_trial_lang_en': appType_1.AppType.lang_en,
    'subscription_monthly_unliminted_time_trial_lang_en2': appType_1.AppType.lang_enus,
    'subscription_monthly_unliminted_time_trial_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_monthly_unliminted_time_trial_lang_eo': appType_1.AppType.lang_eo,
    'subscription_monthly_unliminted_time_trial_lang_es': appType_1.AppType.lang_es,
    'subscription_monthly_unliminted_time_trial_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_monthly_unliminted_time_trial_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_monthly_unliminted_time_trial_lang_et': appType_1.AppType.lang_et,
    'subscription_monthly_unliminted_time_trial_lang_fa': appType_1.AppType.lang_fa,
    'subscription_monthly_unliminted_time_trial_lang_fi': appType_1.AppType.lang_fi,
    'subscription_monthly_unliminted_time_trial_lang_fr': appType_1.AppType.lang_fr,
    'subscription_monthly_unliminted_time_trial_lang_haw': appType_1.AppType.lang_haw,
    'subscription_monthly_unliminted_time_trial_lang_he': appType_1.AppType.lang_he,
    'subscription_monthly_unliminted_time_trial_lang_hi': appType_1.AppType.lang_hi,
    'subscription_monthly_unliminted_time_trial_lang_hr': appType_1.AppType.lang_hr,
    'subscription_monthly_unliminted_time_trial_lang_hu': appType_1.AppType.lang_hu,
    'subscription_monthly_unliminted_time_trial_lang_ic': appType_1.AppType.lang_ic,
    'subscription_monthly_unliminted_time_trial_lang_id': appType_1.AppType.lang_id,
    'subscription_monthly_unliminted_time_trial_lang_it': appType_1.AppType.lang_it,
    'subscription_monthly_unliminted_time_trial_lang_ja': appType_1.AppType.lang_ja,
    'subscription_monthly_unliminted_time_trial_lang_jp': appType_1.AppType.lang_ja,
    'subscription_monthly_unliminted_time_trial_lang_ko': appType_1.AppType.lang_ko,
    'subscription_monthly_unliminted_time_trial_lang_mi': appType_1.AppType.lang_mi,
    'subscription_monthly_unliminted_time_trial_lang_nl': appType_1.AppType.lang_nl,
    'subscription_monthly_unliminted_time_trial_lang_no': appType_1.AppType.lang_no,
    'subscription_monthly_unliminted_time_trial_lang_pl': appType_1.AppType.lang_pl,
    'subscription_monthly_unliminted_time_trial_lang_pt': appType_1.AppType.lang_pt,
    'subscription_monthly_unliminted_time_trial_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_monthly_unliminted_time_trial_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_monthly_unliminted_time_trial_lang_ru': appType_1.AppType.lang_ru,
    'subscription_monthly_unliminted_time_trial_lang_sm': appType_1.AppType.lang_sm,
    'subscription_monthly_unliminted_time_trial_lang_sr': appType_1.AppType.lang_sr,
    'subscription_monthly_unliminted_time_trial_lang_sv': appType_1.AppType.lang_sv,
    'subscription_monthly_unliminted_time_trial_lang_th': appType_1.AppType.lang_th,
    'subscription_monthly_unliminted_time_trial_lang_tl': appType_1.AppType.lang_tl,
    'subscription_monthly_unliminted_time_trial_lang_tr': appType_1.AppType.lang_tr,
    'subscription_monthly_unliminted_time_trial_lang_vi': appType_1.AppType.lang_vi,
    'subscription_monthly_unliminted_time_trial_lang_zh': appType_1.AppType.lang_zh,
    'subscription_monthly_unliminted_time_trial_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_monthly_unliminted_time_trial_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_monthly_unliminted_time_trial_local_ar': appType_1.AppType.local_ar,
    'subscription_monthly_unliminted_time_trial_local_hu': appType_1.AppType.local_hu,
    'subscription_monthly_unliminted_time_trial_local_zh': appType_1.AppType.local_zh,
    'subscription_monthly_unliminted_time_trial_scripts': appType_1.AppType.scripts,
    'subscription_monthly_unliminted_time_trial_upopoy': appType_1.AppType.upopoy,
    'subscription_monthly_unliminted_time_upopoy': appType_1.AppType.upopoy,
    'subscription_yearly_10mins_bite': appType_1.AppType.bite,
    'subscription_yearly_10mins_droplets': appType_1.AppType.droplets,
    'subscription_yearly_10mins_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_yearly_10mins_global_eagle': appType_1.AppType.global_eagle,
    'subscription_yearly_10mins_int': appType_1.AppType.int,
    'subscription_yearly_10mins_int_apple_price': appType_1.AppType.int,
    'subscription_yearly_10mins_int_cis_30': appType_1.AppType.bite,
    'subscription_yearly_10mins_int_cis_50': appType_1.AppType.bite,
    'subscription_yearly_10mins_lang_ain': appType_1.AppType.lang_ain,
    'subscription_yearly_10mins_lang_ar': appType_1.AppType.lang_ar,
    'subscription_yearly_10mins_lang_bs': appType_1.AppType.lang_bs,
    'subscription_yearly_10mins_lang_da': appType_1.AppType.lang_da,
    'subscription_yearly_10mins_lang_de': appType_1.AppType.lang_de,
    'subscription_yearly_10mins_lang_el': appType_1.AppType.lang_el,
    'subscription_yearly_10mins_lang_en': appType_1.AppType.lang_en,
    'subscription_yearly_10mins_lang_en2': appType_1.AppType.lang_enus,
    'subscription_yearly_10mins_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_yearly_10mins_lang_eo': appType_1.AppType.lang_eo,
    'subscription_yearly_10mins_lang_es': appType_1.AppType.lang_es,
    'subscription_yearly_10mins_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_yearly_10mins_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_yearly_10mins_lang_et': appType_1.AppType.lang_et,
    'subscription_yearly_10mins_lang_fa': appType_1.AppType.lang_fa,
    'subscription_yearly_10mins_lang_fi': appType_1.AppType.lang_fi,
    'subscription_yearly_10mins_lang_fr': appType_1.AppType.lang_fr,
    'subscription_yearly_10mins_lang_haw': appType_1.AppType.lang_haw,
    'subscription_yearly_10mins_lang_he': appType_1.AppType.lang_he,
    'subscription_yearly_10mins_lang_hi': appType_1.AppType.lang_hi,
    'subscription_yearly_10mins_lang_hr': appType_1.AppType.lang_hr,
    'subscription_yearly_10mins_lang_hu': appType_1.AppType.lang_hu,
    'subscription_yearly_10mins_lang_ic': appType_1.AppType.lang_ic,
    'subscription_yearly_10mins_lang_id': appType_1.AppType.lang_id,
    'subscription_yearly_10mins_lang_it': appType_1.AppType.lang_it,
    'subscription_yearly_10mins_lang_ja': appType_1.AppType.lang_ja,
    'subscription_yearly_10mins_lang_jp': appType_1.AppType.lang_ja,
    'subscription_yearly_10mins_lang_ko': appType_1.AppType.lang_ko,
    'subscription_yearly_10mins_lang_mi': appType_1.AppType.lang_mi,
    'subscription_yearly_10mins_lang_nl': appType_1.AppType.lang_nl,
    'subscription_yearly_10mins_lang_no': appType_1.AppType.lang_no,
    'subscription_yearly_10mins_lang_pl': appType_1.AppType.lang_pl,
    'subscription_yearly_10mins_lang_pt': appType_1.AppType.lang_pt,
    'subscription_yearly_10mins_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_yearly_10mins_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_yearly_10mins_lang_ru': appType_1.AppType.lang_ru,
    'subscription_yearly_10mins_lang_sm': appType_1.AppType.lang_sm,
    'subscription_yearly_10mins_lang_sr': appType_1.AppType.lang_sr,
    'subscription_yearly_10mins_lang_sv': appType_1.AppType.lang_sv,
    'subscription_yearly_10mins_lang_th': appType_1.AppType.lang_th,
    'subscription_yearly_10mins_lang_tl': appType_1.AppType.lang_tl,
    'subscription_yearly_10mins_lang_tr': appType_1.AppType.lang_tr,
    'subscription_yearly_10mins_lang_vi': appType_1.AppType.lang_vi,
    'subscription_yearly_10mins_lang_zh': appType_1.AppType.lang_zh,
    'subscription_yearly_10mins_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_yearly_10mins_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_yearly_10mins_local_ar': appType_1.AppType.local_ar,
    'subscription_yearly_10mins_local_hu': appType_1.AppType.local_hu,
    'subscription_yearly_10mins_local_zh': appType_1.AppType.local_zh,
    'subscription_yearly_10mins_scripts': appType_1.AppType.scripts,
    'subscription_yearly_10mins_upopoy': appType_1.AppType.upopoy,
    'subscription_yearly_all_languages_bite': appType_1.AppType.bite,
    'subscription_yearly_all_languages_droplets': appType_1.AppType.droplets,
    'subscription_yearly_all_languages_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_yearly_all_languages_global_eagle': appType_1.AppType.global_eagle,
    'subscription_yearly_all_languages_hu': appType_1.AppType.local_hu,
    'subscription_yearly_all_languages_int': appType_1.AppType.int,
    'subscription_yearly_all_languages_int_apple_price': appType_1.AppType.int,
    'subscription_yearly_all_languages_int_cis_30': appType_1.AppType.bite,
    'subscription_yearly_all_languages_int_cis_50': appType_1.AppType.bite,
    'subscription_yearly_all_languages_lang_ain': appType_1.AppType.lang_ain,
    'subscription_yearly_all_languages_lang_ar': appType_1.AppType.lang_ar,
    'subscription_yearly_all_languages_lang_bs': appType_1.AppType.lang_bs,
    'subscription_yearly_all_languages_lang_da': appType_1.AppType.lang_da,
    'subscription_yearly_all_languages_lang_de': appType_1.AppType.lang_de,
    'subscription_yearly_all_languages_lang_el': appType_1.AppType.lang_el,
    'subscription_yearly_all_languages_lang_en': appType_1.AppType.lang_en,
    'subscription_yearly_all_languages_lang_en2': appType_1.AppType.lang_enus,
    'subscription_yearly_all_languages_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_yearly_all_languages_lang_eo': appType_1.AppType.lang_eo,
    'subscription_yearly_all_languages_lang_es': appType_1.AppType.lang_es,
    'subscription_yearly_all_languages_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_yearly_all_languages_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_yearly_all_languages_lang_et': appType_1.AppType.lang_et,
    'subscription_yearly_all_languages_lang_fa': appType_1.AppType.lang_fa,
    'subscription_yearly_all_languages_lang_fi': appType_1.AppType.lang_fi,
    'subscription_yearly_all_languages_lang_fr': appType_1.AppType.lang_fr,
    'subscription_yearly_all_languages_lang_haw': appType_1.AppType.lang_haw,
    'subscription_yearly_all_languages_lang_he': appType_1.AppType.lang_he,
    'subscription_yearly_all_languages_lang_hi': appType_1.AppType.lang_hi,
    'subscription_yearly_all_languages_lang_hr': appType_1.AppType.lang_hr,
    'subscription_yearly_all_languages_lang_hu': appType_1.AppType.lang_hu,
    'subscription_yearly_all_languages_lang_ic': appType_1.AppType.lang_ic,
    'subscription_yearly_all_languages_lang_id': appType_1.AppType.lang_id,
    'subscription_yearly_all_languages_lang_it': appType_1.AppType.lang_it,
    'subscription_yearly_all_languages_lang_ja': appType_1.AppType.lang_ja,
    'subscription_yearly_all_languages_lang_jp': appType_1.AppType.lang_ja,
    'subscription_yearly_all_languages_lang_ko': appType_1.AppType.lang_ko,
    'subscription_yearly_all_languages_lang_mi': appType_1.AppType.lang_mi,
    'subscription_yearly_all_languages_lang_nl': appType_1.AppType.lang_nl,
    'subscription_yearly_all_languages_lang_no': appType_1.AppType.lang_no,
    'subscription_yearly_all_languages_lang_pl': appType_1.AppType.lang_pl,
    'subscription_yearly_all_languages_lang_pt': appType_1.AppType.lang_pt,
    'subscription_yearly_all_languages_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_yearly_all_languages_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_yearly_all_languages_lang_ru': appType_1.AppType.lang_ru,
    'subscription_yearly_all_languages_lang_sm': appType_1.AppType.lang_sm,
    'subscription_yearly_all_languages_lang_sr': appType_1.AppType.lang_sr,
    'subscription_yearly_all_languages_lang_sv': appType_1.AppType.lang_sv,
    'subscription_yearly_all_languages_lang_th': appType_1.AppType.lang_th,
    'subscription_yearly_all_languages_lang_tl': appType_1.AppType.lang_tl,
    'subscription_yearly_all_languages_lang_tr': appType_1.AppType.lang_tr,
    'subscription_yearly_all_languages_lang_vi': appType_1.AppType.lang_vi,
    'subscription_yearly_all_languages_lang_zh': appType_1.AppType.lang_zh,
    'subscription_yearly_all_languages_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_yearly_all_languages_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_yearly_all_languages_local_ar': appType_1.AppType.local_ar,
    'subscription_yearly_all_languages_local_hu': appType_1.AppType.local_hu,
    'subscription_yearly_all_languages_local_zh': appType_1.AppType.local_zh,
    'subscription_yearly_all_languages_scripts': appType_1.AppType.scripts,
    'subscription_yearly_all_languages_upopoy': appType_1.AppType.upopoy,
    'subscription_yearly_unliminted_time_bite': appType_1.AppType.bite,
    'subscription_yearly_unliminted_time_droplets': appType_1.AppType.droplets,
    'subscription_yearly_unliminted_time_droplets_demo_apple_store': appType_1.AppType.droplets_demo_apple_store,
    'subscription_yearly_unliminted_time_global_eagle': appType_1.AppType.global_eagle,
    'subscription_yearly_unliminted_time_hu': appType_1.AppType.local_hu,
    'subscription_yearly_unliminted_time_int': appType_1.AppType.int,
    'subscription_yearly_unliminted_time_int_apple_price': appType_1.AppType.int,
    'subscription_yearly_unliminted_time_int_cis_30': appType_1.AppType.bite,
    'subscription_yearly_unliminted_time_int_cis_50': appType_1.AppType.bite,
    'subscription_yearly_unliminted_time_lang_ain': appType_1.AppType.lang_ain,
    'subscription_yearly_unliminted_time_lang_ar': appType_1.AppType.lang_ar,
    'subscription_yearly_unliminted_time_lang_bs': appType_1.AppType.lang_bs,
    'subscription_yearly_unliminted_time_lang_da': appType_1.AppType.lang_da,
    'subscription_yearly_unliminted_time_lang_de': appType_1.AppType.lang_de,
    'subscription_yearly_unliminted_time_lang_el': appType_1.AppType.lang_el,
    'subscription_yearly_unliminted_time_lang_en': appType_1.AppType.lang_en,
    'subscription_yearly_unliminted_time_lang_en2': appType_1.AppType.lang_enus,
    'subscription_yearly_unliminted_time_lang_enus1': appType_1.AppType.lang_enus,
    'subscription_yearly_unliminted_time_lang_eo': appType_1.AppType.lang_eo,
    'subscription_yearly_unliminted_time_lang_es': appType_1.AppType.lang_es,
    'subscription_yearly_unliminted_time_lang_es2': appType_1.AppType.lang_esmx,
    'subscription_yearly_unliminted_time_lang_esmx': appType_1.AppType.lang_esmx,
    'subscription_yearly_unliminted_time_lang_et': appType_1.AppType.lang_et,
    'subscription_yearly_unliminted_time_lang_fa': appType_1.AppType.lang_fa,
    'subscription_yearly_unliminted_time_lang_fi': appType_1.AppType.lang_fi,
    'subscription_yearly_unliminted_time_lang_fr': appType_1.AppType.lang_fr,
    'subscription_yearly_unliminted_time_lang_haw': appType_1.AppType.lang_haw,
    'subscription_yearly_unliminted_time_lang_he': appType_1.AppType.lang_he,
    'subscription_yearly_unliminted_time_lang_hi': appType_1.AppType.lang_hi,
    'subscription_yearly_unliminted_time_lang_hr': appType_1.AppType.lang_hr,
    'subscription_yearly_unliminted_time_lang_hu': appType_1.AppType.lang_hu,
    'subscription_yearly_unliminted_time_lang_ic': appType_1.AppType.lang_ic,
    'subscription_yearly_unliminted_time_lang_id': appType_1.AppType.lang_id,
    'subscription_yearly_unliminted_time_lang_it': appType_1.AppType.lang_it,
    'subscription_yearly_unliminted_time_lang_ja': appType_1.AppType.lang_ja,
    'subscription_yearly_unliminted_time_lang_jp': appType_1.AppType.lang_ja,
    'subscription_yearly_unliminted_time_lang_ko': appType_1.AppType.lang_ko,
    'subscription_yearly_unliminted_time_lang_mi': appType_1.AppType.lang_mi,
    'subscription_yearly_unliminted_time_lang_nl': appType_1.AppType.lang_nl,
    'subscription_yearly_unliminted_time_lang_no': appType_1.AppType.lang_no,
    'subscription_yearly_unliminted_time_lang_pl': appType_1.AppType.lang_pl,
    'subscription_yearly_unliminted_time_lang_pt': appType_1.AppType.lang_pt,
    'subscription_yearly_unliminted_time_lang_pt2': appType_1.AppType.lang_ptbr,
    'subscription_yearly_unliminted_time_lang_ptpt': appType_1.AppType.lang_pt,
    'subscription_yearly_unliminted_time_lang_ru': appType_1.AppType.lang_ru,
    'subscription_yearly_unliminted_time_lang_sm': appType_1.AppType.lang_sm,
    'subscription_yearly_unliminted_time_lang_sr': appType_1.AppType.lang_sr,
    'subscription_yearly_unliminted_time_lang_sv': appType_1.AppType.lang_sv,
    'subscription_yearly_unliminted_time_lang_th': appType_1.AppType.lang_th,
    'subscription_yearly_unliminted_time_lang_tl': appType_1.AppType.lang_tl,
    'subscription_yearly_unliminted_time_lang_tr': appType_1.AppType.lang_tr,
    'subscription_yearly_unliminted_time_lang_vi': appType_1.AppType.lang_vi,
    'subscription_yearly_unliminted_time_lang_zh': appType_1.AppType.lang_zh,
    'subscription_yearly_unliminted_time_lang_zh2': appType_1.AppType.lang_zhyue,
    'subscription_yearly_unliminted_time_lang_zhyue': appType_1.AppType.lang_zhyue,
    'subscription_yearly_unliminted_time_local_ar': appType_1.AppType.local_ar,
    'subscription_yearly_unliminted_time_local_hu': appType_1.AppType.local_hu,
    'subscription_yearly_unliminted_time_local_zh': appType_1.AppType.local_zh,
    'subscription_yearly_unliminted_time_scripts': appType_1.AppType.scripts,
    'subscription_yearly_unliminted_time_upopoy': appType_1.AppType.upopoy,
};
